/* ===== DIRTY BASTARD — GLOBAL JS ===== */

// ---- KICKSTARTER REDIRECT (DISABLED — campaign ended) ----
// Kept commented for reference. Remove entirely after launch.
// (function kickstarterRedirect() { ... })();

// ---- ACCOUNT DRAWER ----
function openAcctDrawer() {
  document.getElementById('acct-drawer').classList.add('open');
  document.getElementById('acct-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeAcctDrawer() {
  document.getElementById('acct-drawer').classList.remove('open');
  document.getElementById('acct-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

// ---- COUNTDOWN: removed 2026-09-09 (launch happened 2026-07-01; the interval ran forever on every page for elements that no longer exist) ----

// ---- MOBILE NAV DRAWER (IM8-style card menu) ----
// Markup lives in sections/header.liquid (#menu-overlay + #menu-panel).
// CSS lives in assets/db-global.css under "MOBILE NAV DRAWER".
function openMobileMenu() {
  var overlay = document.getElementById('menu-overlay');
  var panel = document.getElementById('menu-panel');
  var hamburger = document.getElementById('hamburger');
  if (!overlay || !panel) return;
  overlay.hidden = false;
  panel.hidden = false;
  // Force reflow so the transition fires reliably on the first open.
  void panel.offsetWidth;
  overlay.classList.add('open');
  panel.classList.add('open');
  document.body.style.overflow = 'hidden';
  if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  var firstFocusable = panel.querySelector('.menu-panel__close');
  if (firstFocusable) firstFocusable.focus();
}
function closeMobileMenu() {
  var overlay = document.getElementById('menu-overlay');
  var panel = document.getElementById('menu-panel');
  var hamburger = document.getElementById('hamburger');
  if (!overlay || !panel) return;
  overlay.classList.remove('open');
  panel.classList.remove('open');
  document.body.style.overflow = '';
  if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  // Wait for the slide-out transition before hiding so animation is visible.
  setTimeout(function(){
    overlay.hidden = true;
    panel.hidden = true;
  }, 260);
}
document.addEventListener('keydown', function(e){
  if (e.key !== 'Escape') return;
  var panel = document.getElementById('menu-panel');
  if (panel && !panel.hidden) closeMobileMenu();
});
// Back-compat: old hamburger code still calls toggleMenu() if anything misses the swap.
function toggleMenu(){
  var panel = document.getElementById('menu-panel');
  if (panel && !panel.hidden) { closeMobileMenu(); } else { openMobileMenu(); }
}

// ---- CART DRAWER ----
// ==========================================================================
// MYSTERY GIFT (Q4 2026, founder 2026-10-07; window Nov 23 to Dec 20 since 2026-10-21). One gift per order, and
// ONLY for a shopper who gave us an email (founder 2026-10-27: "you get the free mystery gift only if we collect
// your email"): the gift unlock in the popup, the laundry game's submit, or a prize email's ?gift=unlocked link.
// And ONLY with a bundle (founder 2026-10-28: "should we do free mystery gift with the bundle only... yes"): 3+ one-time
// boxes, any mix (a native bundle line counts as 3). A 3+ box cart with no email shows a slim locked strip that opens the
// unlock (_giftLocked); a 1 or 2 box cart hears that the third box brings the gift (the offer bar). Never named.
//
// HOW IT RINGS UP FREE. The automatic discount "Free Mystery Gift" takes 100% off the gift product,
// same dates. It has no "buy" condition on purpose: Shopify stacks buy-X-get-Y discounts only on the
// items they give away, and Buy 2, Get 1 Free claims every box in a 3- or 6-box cart, so a "buy 3,
// get the gift" discount was "not applicable" on exactly the carts that should get it (proven on
// live carts 2026-10-07). So the CART decides who gets the gift: DB_Cart._giftReconcile adds one when
// the cart qualifies and takes it off when it doesn't, and never lets it be charged.
//
// WHEN is decided here, in the shopper's browser, because pages come out of Shopify's page cache and
// Liquid's "now" can be hours old. window.DB_GIFT (layout/theme.liquid) carries the variant, its
// price, whether it is in stock, and the window. To stop the gift early, set the Mystery Gift product
// to Draft: DB_GIFT comes back null and every gift line on the site comes down.
// ==========================================================================
var DB_Gift = {
  _unlockMem: false,
  // The window is open and there is a gift to give. Sold out means off, so the page stops promising
  // the gift the moment the last one goes.
  on: function() {
    var g = window.DB_GIFT;
    if (!g || !g.variant || !g.available) return false;
    if (g.preview) return true;
    var now = Date.now(), s = Date.parse(g.start), e = Date.parse(g.end);
    if (isNaN(s) || isNaN(e)) return false;
    return now >= s && now <= e;
  },
  // The laundry game's prize (founder 2026-10-07): the gift with ANY order. Remembered in this
  // browser; a link carrying ?gift=unlocked (the prize email) sets it on whatever device opens it.
  unlocked: function() {
    if (this._unlockMem) return true;
    try { return localStorage.getItem('db_gift_unlocked') === '1'; } catch (e) { return false; }
  },
  unlock: function() {
    this._unlockMem = true;
    try { localStorage.setItem('db_gift_unlocked', '1'); } catch (e) {}
    try { this.paint(); } catch (e) {}
  },
  // Page lines: [data-gift-show] appear while the gift is on and [data-gift-hide] step aside. Liquid
  // renders them hidden and only this reveals them, so a cached page never shows the gift out of window.
  //   [data-gift-text]  swaps its contents for the attribute's text while the gift is on (the laundry game's
  //                     prize, founder 2026-10-07), and puts the original back when it is off.
  //   [data-gift-aria]  the same for the aria-label.
  //   .hero-game-link   the "Play the laundry game for a mystery discount" buttons say "mystery gift" instead.
  paint: function(root) {
    var on = this.on(), r = root || document, i, el, orig;
    var show = r.querySelectorAll('[data-gift-show]'), hide = r.querySelectorAll('[data-gift-hide]');
    for (i = 0; i < show.length; i++) show[i].hidden = !on;
    for (i = 0; i < hide.length; i++) hide[i].hidden = on;
    var txt = r.querySelectorAll('[data-gift-text]');
    for (i = 0; i < txt.length; i++) {
      el = txt[i];
      if (el.getAttribute('data-gift-orig') === null) el.setAttribute('data-gift-orig', el.innerHTML);
      el.innerHTML = on ? el.getAttribute('data-gift-text') : el.getAttribute('data-gift-orig');
    }
    var aria = r.querySelectorAll('[data-gift-aria]');
    for (i = 0; i < aria.length; i++) {
      el = aria[i];
      if (el.getAttribute('data-gift-aria-orig') === null) el.setAttribute('data-gift-aria-orig', el.getAttribute('aria-label') || '');
      el.setAttribute('aria-label', on ? el.getAttribute('data-gift-aria') : el.getAttribute('data-gift-aria-orig'));
    }
    //   [data-gift-unlocked-text]  swaps its text once this browser has given an email (the bundle page's gift block),
    //                     and puts the original back when it has not.
    var unl = r.querySelectorAll('[data-gift-unlocked-text]'), u = this.unlocked();
    for (i = 0; i < unl.length; i++) {
      el = unl[i];
      if (el.getAttribute('data-gift-unlocked-orig') === null) el.setAttribute('data-gift-unlocked-orig', el.textContent);
      el.textContent = u ? el.getAttribute('data-gift-unlocked-text') : el.getAttribute('data-gift-unlocked-orig');
    }
    var heroes = r.querySelectorAll('.hero-game-link');
    for (i = 0; i < heroes.length; i++) {
      el = heroes[i];
      orig = el.getAttribute('data-gift-orig');
      if (orig === null) { orig = el.textContent; el.setAttribute('data-gift-orig', orig); }
      el.textContent = on ? orig.replace(/mystery discount/i, 'mystery gift') : orig;
    }
    if (document.documentElement) document.documentElement.classList.toggle('db-gift-on', on);
    return on;
  },
  // The gift's face (founder 2026-10-28, gift block pick): one real photo of the wrapped gift on every cart surface, the
  // way gift-with-purchase leaders show a gift they won't name. The emoji only if the photo is missing.
  icon: function(cls) {
    var g = window.DB_GIFT;
    if (g && g.photo) return '<img class="' + cls + '" src="' + g.photo + '" alt="" width="30" height="30" loading="lazy" decoding="async">';
    return '<span class="' + cls + '" aria-hidden="true">🎁</span>';
  },
  value: function() { var g = window.DB_GIFT; return (g && g.price) || 0; },
  money: function(c) { return '$' + ((c || 0) / 100).toFixed(2); },
  // The gift's value as copy says it (founder 2026-10-28: "Mystery gift is always $10 value"): the product's own price,
  // without trailing zeros, so a $10.00 product reads "$10".
  valueText: function() { var c = this.value(); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
};
(function() {
  try { if (/[?&]gift=unlocked(?:&|$)/.test(location.search)) DB_Gift.unlock(); } catch (e) {}
  var run = function() { try { DB_Gift.paint(); } catch (e) {} };
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

var DB_Cart = {
  // ==========================================================================
  // ONE CART QUEUE (Stage 2, step 1).
  // Shopify's cart endpoints are not safe to run concurrently. The drawer has 34
  // cart/discount request sites across a dozen methods, and several fire from
  // render: the Ship Happens coverage auto-add, the SHIPSFREE re-apply, the
  // bundle steppers, and now the free-box add. Two adds in flight interleave,
  // and a read taken between someone else's read and write sees a cart that no
  // longer exists.
  //
  // Two layers, because they solve different problems:
  //   _cartFetch  serializes the TRANSPORT. Every cart/discount request goes
  //               through it in call order, so no two are ever open at once.
  //               Wrapping the transport keeps this to one place instead of
  //               restructuring 34 call sites.
  //   _enqueue    serializes a whole JOB. A read-then-write sequence holds the
  //               lane for its duration, so nobody can slip a write between the
  //               two halves. This is what the free-box add and the coverage
  //               add need; the transport queue alone cannot give it.
  //
  // Both release the lane after a cap (_QUEUE_MS) even if a request never
  // settles, so one hung fetch can never freeze the cart for good.
  // ==========================================================================
  _QUEUE_MS: 15000,
  _lane: null,
  // Chain `fn` after whatever is already queued. Failures never poison the lane.
  _chain: function(fn) {
    var self = this;
    var head = this._lane || Promise.resolve();
    var finish = null, done = false;
    // The lane follows `out` but swallows its result, and gives up waiting after the cap.
    this._lane = new Promise(function(release) { finish = function() { if (!done) { done = true; release(); } }; });
    // The cap counts from when this entry STARTS, not from when it was queued: counted from the queue, a job
    // waiting behind a slow one was let go before it had even begun, and two writes ran at once (the review's
    // fuzzer, slow requests, 2026-10-09). A request that hangs still frees the lane after _QUEUE_MS.
    var run = function() { setTimeout(finish, self._QUEUE_MS); return fn(); };
    var out = head.then(run, run);
    out.then(finish, finish);
    return out;
  },
  // Serialized transport for every cart and discount request. It ALWAYS chains.
  //
  // This used to pass straight through whenever `_jobDepth > 0`, to stop a job deadlocking on the
  // lane it was itself holding. That check asked "is ANYBODY inside a job", not "is THIS CALL the
  // job's own", so for the whole multi-second life of a job every other cart request on the page
  // skipped the queue and ran concurrently with the job's writes. The one guarantee _enqueue exists
  // to give was the one it did not give, and three money defects hung off it: a shopper write
  // landing between a job's read and its write, a verification credited with a box the shopper
  // added, and a rollback that deleted the shopper's own box as "excess". Reproduced 2026-09-18.
  //
  // A job now gets its OWN fetch handed to it (see _enqueue) and there is nothing to bypass.
  _cartFetch: function(url, opts) {
    // A job that reaches for _cartFetch instead of the fetch it was handed will WAIT on the lane it
    // is itself holding, until the _QUEUE_MS cap releases it. That is a bounded stall rather than a
    // hang, and it is far better than the alternative (letting it through, which is the hole this
    // whole change closed), but it is always a programming error, so say so loudly rather than
    // leaving someone to debug a 15 second pause.
    // It cannot tell "inside the job" from "a tap that arrived while a job runs", and the second is normal and
    // safe (it simply queues behind the job). The instant cart makes it common, so it says what it can know, once.
    // A request queued behind a running job is normal (a tap during a free-box add, a slow phone). One still
    // waiting just short of the lane's give-up is the job waiting on itself, so that is what gets reported.
    var started = false, stall = null;
    if (this._jobActive) {
      stall = setTimeout(function() {
        if (!started) { try { console.error('DB_Cart: a cart request has waited ' + Math.round((DB_Cart._QUEUE_MS - 1000) / 1000) + 's behind a running job. If the job itself made it, it stalls until _QUEUE_MS. URL:', url); } catch (e) {} }
      }, Math.max(1000, this._QUEUE_MS - 1000));
    }
    return this._chain(function() { started = true; if (stall) clearTimeout(stall); return DB_Cart._issue(url, opts); });
  },
  // The transport under both lanes. Each request is numbered as it is SENT, and a cart that comes back
  // carries its number (_dbSeq, not enumerable): the lane sends in order, so a higher number is a newer
  // cart. render will not paint an older cart over a newer one, which a very slow answer released by the
  // lane's give-up could otherwise do last (the review's fuzzer, slow requests, 2026-10-09).
  _issueN: 0,
  _issue: function(url, opts) {
    var n = ++DB_Cart._issueN;
    return fetch(url, opts).then(function(r) {
      try {
        if (r && typeof r.json === 'function') {
          var j = r.json.bind(r);
          r.json = function() { return j().then(function(o) { try { if (o && typeof o === 'object' && o.items) Object.defineProperty(o, '_dbSeq', { value: n, enumerable: false, configurable: true }); } catch (eS) {} return o; }); };
        }
      } catch (eW) {}
      return r;
    });
  },
  // The raw transport, handed to a job so its own calls do not wait on the lane the job holds.
  // Everything OUTSIDE a job must use _cartFetch; anything inside a job must use the `f` it is given.
  _jobFetch: function(url, opts) { return DB_Cart._issue(url, opts); },
  // Run a whole read-then-write job with the lane held for its duration. The job is CALLED WITH the
  // raw fetch: `_enqueue(function (f) { return f('/cart.js') ... })`. A job that reaches for
  // _cartFetch instead would wait forever on its own lane, so the parameter is not optional style,
  // it is the contract.
  _enqueue: function(job) {
    var self = this;
    return this._chain(function() {
      // Diagnostic only. It is NEVER used to let a call skip the lane, which is exactly what the
      // old _jobDepth counter did and why it was a hole: it recorded "somebody is in a job", which
      // is not the same question as "is this call the job's own".
      self._jobActive = true;
      var done = function() { self._jobActive = false; };
      setTimeout(done, self._QUEUE_MS);   // the lane gives up on a hung job then; so does this flag
      var p;
      try { p = Promise.resolve(job(self._jobFetch)); }
      catch (e) { done(); return Promise.reject(e); }
      return p.then(function(v) { done(); return v; }, function(e) { done(); throw e; });
    });
  },
  open: function(pre) {
    this._openDrawer();
    this.refresh(pre);
  },
  _openDrawer: function() {
    var ov = document.getElementById('cart-overlay'), dr = document.getElementById('cart-drawer');
    if (ov) ov.classList.add('open');
    if (dr) dr.classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  close: function() {
    document.getElementById('cart-overlay').classList.remove('open');
    document.getElementById('cart-drawer').classList.remove('open');
    document.body.style.overflow = '';
  },
  // Claim free shipping INLINE, without leaving the cart. The email is still required (list-building
  // and the "earned in exchange for an email" gate are intact: the code is applied only AFTER a valid
  // email is captured), but the shopper never leaves the drawer. Steps: validate -> subscribe the
  // email to Klaviyo (list XrtgEd, the same list the game popup / LP capture use) stamped
  // source 'cart-freeship' so the welcome flow can EXCLUDE this source (mirrors the laundry-game
  // exclusion, else welcome's SHIPSFREE_7DAY clashes with the SHIPSFREE just applied) -> apply the
  // evergreen SHIPSFREE code to THIS cart -> mark it claimed (so the drawer + /cart page show
  // "already yours" and re-apply if the session ever drops the discount cookie) -> re-render to the
  // claimed state. The field only shows on bundle-level carts (SHIPSFREE's $49.98 min), so the offer
  // is always true where it appears (see render()).
  claimFreeShipInline: function(e) {
    if (e && e.preventDefault) e.preventDefault();
    var self = this;
    var input = document.getElementById('cart-freeship-email');
    var btn = document.getElementById('cart-freeship-submit');
    var err = document.getElementById('cart-freeship-err');
    var email = input ? String(input.value || '').trim() : '';
    if (err) err.hidden = true;
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      if (err) { err.textContent = 'Enter a real email and free shipping is yours.'; err.hidden = false; }
      if (input) input.focus();
      return false;
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Applying...'; }
    // Segment tag for attribution parity with the game popup / LP capture (db_variant cookie).
    var seg = '';
    try { seg = decodeURIComponent((document.cookie.match(/db_variant=([a-z0-9_-]{1,40})/) || [])[1] || ''); } catch (x0) {}
    function fsFail() {
      if (btn) { btn.disabled = false; btn.textContent = 'Ship Free'; }
      if (err) { err.textContent = "That didn't go through. Give it another shot."; err.hidden = false; }
    }
    // Capture the email FIRST, and only apply the code if the subscribe lands. Free shipping is
    // "earned in exchange for the email," so we never hand out SHIPSFREE without adding the address
    // to the list (matches the /cart page's gated flow; protects both the list and the margin).
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=T3JGhu', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Cart Free Shipping',
        profile: { data: { type: 'profile', attributes: {
          email: email,
          properties: { source: 'cart-freeship', popup_offer: 'free-shipping-cart-drawer', lp_segment: (seg || 'storewide'), signup_page: location.pathname }
        } } }
      }, relationships: { list: { data: { type: 'list', id: 'XrtgEd' } } } } })
    })
      .then(function(r) { if (!r.ok && r.status !== 202) throw new Error('subscribe failed'); })
      .then(function() {
        // Persist claimed state (mirrors the game reveal + /cart page) so the confirmed state survives
        // and SHIPSFREE re-applies if the session ever drops the discount cookie.
        try {
          localStorage.setItem('db_shipfree_claimed', '1');
          localStorage.setItem('db_last_lead', JSON.stringify({ email: email, source: 'cart-freeship', timestamp: new Date().toISOString() }));
        } catch (x2) {}
        // Apply the free-shipping code to THIS cart, then re-render IN PLACE (no navigation).
        return DB_Cart._cartFetch('/discount/SHIPSFREE', { credentials: 'same-origin', cache: 'no-store' });
      })
      .then(function() { return DB_Cart._cartFetch('/cart.js'); })
      .then(function(r) { return r.json(); })
      .then(function(c) { self.render(c); })
      .catch(fsFail);
    return false;
  },
  // Returns the read AND its paint, kept as _refreshP, so whoever needs Shopify's cart on screen before
  // the next step (the stepper flush) can wait for it rather than for the network alone.
  // `pre` (optional) runs on the fresh cart just before it is painted. An add that was showing ahead of
  // Shopify comes off the screen in the SAME paint that puts Shopify's own boxes on it, so the two are
  // never both shown or both missing for a beat. If the read fails, it is tried once more, then `pre`
  // runs with null and the last cart Shopify sent is painted.
  refresh: function(pre, retried) {
    var self = this;
    this._refreshP = DB_Cart._cartFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart || !cart.items) throw new Error('No cart in the answer');
        if (pre) { try { pre(cart); } catch (e0) {} }
        self.render(cart);
      })
      .catch(function(e) {
        console.error('Cart fetch error:', e);
        // A read that failed is tried again, whoever asked for it: the screen should not rest on an old cart
        // because one request dropped.
        // (Once here; _resync, which calls this, makes its own bounded tries, so an offline phone is not polled.)
        if (!retried) { setTimeout(function() { self.refresh(pre, true); }, 1500); return; }
        if (!pre) return;
        try { pre(null); } catch (e1) {}
        if (self._lastCart) self.render(self._lastCart);
      });
    return this._refreshP;
  },
  // True when the cart already carries a FREE-SHIPPING code (SHIPSFREE, or any code listed in
  // window.DB_FREESHIP_CODES) that Shopify reports as applicable. Read straight from the /cart.js
  // discount_codes array, so it is the REAL applied state, not a guess: if this is true, checkout
  // will not charge shipping (a free-shipping code does not reduce the subtotal, so total_discount
  // stays 0 and it only shows up here). Flash codes and creator <handle> codes are PERCENT-off and
  // also appear in discount_codes, so we match the free-shipping code list EXACTLY and never treat
  // a percent code as free shipping (that would be a false "you're covered" promise).
  _freeShipApplied: function(cart) {
    var codes = cart && cart.discount_codes;
    if (!codes || !codes.length) return false;
    var set = { SHIPSFREE: 1 };
    try { (window.DB_FREESHIP_CODES || []).forEach(function(c) { if (c) set[String(c).toUpperCase()] = 1; }); } catch (e) {}
    for (var i = 0; i < codes.length; i++) {
      var d = codes[i];
      if (d && d.applicable !== false && set[String(d.code || '').toUpperCase()]) return true;
    }
    return false;
  },
  // ==========================================================================
  // FREE BOX ADDS ITSELF (settings.byb_auto_free). One pinned offer bar, three states:
  //   1 or 4 boxes -> add a paid box AND the free one in a single add
  //   2 or 5 boxes -> the free box stays reserved; the shopper picks its scent right here
  //   3 or 6 boxes -> nothing: the bar stands down (founder 2026-09-28; it used to confirm the free box)
  // Founder-approved look: db-cart-proto.vercel.app (2026-09-17). A2, the bar stays calm at
  // 2 boxes and carries ONE action plus the struck price. B2, the scents are NAMED rather
  // than hidden behind a swap link.
  // STAGE 1 reuses the proven add paths (addItems, addFreeBox, _bybCanAdd). The serialized
  // cart queue, the armed auto-add/reconcile and the free-unit rollback check are STAGE 2.
  // ==========================================================================
  _bybAuto: function() {
    var b = window.DB_BYB;
    return !!(b && b.live && b.auto && b.variants);
  },
  // Buy 2 Get 1 frees the LAST unit added, so the last handle here is the one that wears FREE.
  _bybFreeOrder: function() {
    var b = window.DB_BYB;
    var o = (b && b.freeOrder && b.freeOrder.length) ? b.freeOrder : ['amber-canyon', 'alaskan-alpine', 'coastal-drift'];
    // TRIM. byb_free_order is a free-text theme setting split on commas, so typing it the natural
    // way, "amber-canyon, alaskan-alpine, coastal-drift", used to leave a leading space on every
    // entry after the first, none of which match a handle. The list silently collapsed to ONE scent:
    // Coastal Drift could never wear the FREE tag and the one-tap CTA added two Amber Canyons.
    return o.map(function(h) { return String(h || '').trim().toLowerCase(); })
            .filter(function(h) { return h && b && b.variants && b.variants[h]; });
  },
  // ==========================================================================
  // THE BUNDLE AS THREE LOOSE BOXES (settings.byb_bundle_loose; founder go-ahead 2026-09-17,
  // "on at launch" 2026-09-21).
  //
  // Checked on real checkouts 2026-09-17: the native Big Bastard Bundle reaches checkout as ONE line
  // at the bundle price with NO struck price and NO "TOTAL SAVINGS", on the product most orders are.
  // Three loose boxes under the Buy 2 Get 1 automatic print "FREE" on a line and Shopify's own
  // TOTAL SAVINGS. So with the switch on, adding the bundle adds one box of each scent instead.
  // Nothing else about the bundle changes: its page, its price, every ad destination.
  //
  // THREE RULES, each one a way this could take money it should not:
  //   1. ADD ORDER. Buy 2 Get 1 frees the last unit added, so the lines go in _bybFreeOrder order
  //      (Coastal Drift last, the founder's pick for the box that wears FREE).
  //   2. A VISIBLE TAG. `Bundle: Big Bastard Bundle` rides on every line so the name survives to the
  //      drawer, the checkout, the order and the packing slip. Hidden `_` properties do not display.
  //   3. PRICE SAFETY. The bundle price only exists if the automatic reaches the cart. After the add,
  //      the cart is read back; if the free box is not there, exactly the boxes this tap added come
  //      back out (never more than we sent) and the native bundle line goes in at its own fixed
  //      price. A shopper can never pay three single-box prices for what the page sold as a bundle.
  // ==========================================================================
  _BUNDLE_TAG_KEY: 'Bundle',
  _BUNDLE_TAG_VAL: 'Big Bastard Bundle',
  _bybLooseOn: function() {
    var b = window.DB_BYB;
    return !!(b && b.live && b.loose && b.variants && b.bundleVariant);
  },
  _bybIsBundleTagged: function(item) {
    return !!(item && item.properties && item.properties[this._BUNDLE_TAG_KEY] === this._BUNDLE_TAG_VAL);
  },
  // One line per scent, or null when any scent cannot be sold right now (variants holds only the
  // AVAILABLE scents), in which case the caller adds the native bundle exactly as before.
  //
  // `freeHandle` (optional) is the SHOPPER'S OWN FREE PICK (founder 2026-09-21: on a scent page the
  // box he picks third is tagged FREE in the picker, "and that should match when it goes to the cart
  // drawer"). Buy 2 Get 1 frees the last unit added, so his pick goes LAST. Anything that is not one
  // of the three scents is ignored and the founder's standing order applies (Coastal Drift last).
  _bybLooseLines: function(q, freeHandle) {
    if (!this._bybLooseOn()) return null;
    var b = window.DB_BYB, order = this._bybFreeOrder(), props = {};
    if (!b.handles || order.length !== b.handles.length) return null;
    var pick = String(freeHandle || '').trim().toLowerCase();
    if (pick && order.indexOf(pick) > -1) order = order.filter(function(h) { return h !== pick; }).concat([pick]);
    props[this._BUNDLE_TAG_KEY] = this._BUNDLE_TAG_VAL;
    return order.map(function(h) { return { id: b.variants[h], quantity: q || 1, props: props, handle: h }; });
  },
  // ONE OF EACH, FROM A SCENT PAGE. The picker's 1/1/1 mix IS the Big Bastard Bundle, so it takes the
  // same road as the bundle page: three tagged loose boxes while the loose switch is on (with the
  // same price safety, _bybAddBundleLoose), the native bundle line otherwise. The only difference is
  // that the shopper chose which box is his free one. This used to go through addItems with the
  // bundle variant, which skipped the loose road entirely: the same bundle landed as three boxes
  // from the bundle page and as one native line from a scent page (found 2026-09-21).
  addBundle: function(freeHandle, onSuccess) {
    var b = window.DB_BYB;
    if (!b || !b.bundleVariant) { if (onSuccess) onSuccess(); return; }
    var looseLines = this._bybLooseLines(1, freeHandle);
    if (looseLines) { this._bybAddBundleLoose(looseLines, 1, onSuccess); return; }
    this.addItem(b.bundleVariant, 1, null, onSuccess);
  },
  // Take back AT MOST cap[handle] units of the tagged lines, one change at a time, reading the key
  // fresh before each (Shopify re-keys a line whenever its characteristics change). Decrements, never
  // zeroes a line blindly: an earlier bundle tap can share the same tagged line.
  _bybTakeTagged: function(cap) {
    var self = this, guard = 0, left = {};
    Object.keys(cap || {}).forEach(function(h) { left[h] = cap[h]; });
    var step = function() {
      return DB_Cart._cartFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var hit = null;
          (cart.items || []).some(function(i) {
            if (i.selling_plan_allocation || !self._bybIsBundleTagged(i) || !(left[i.handle] > 0)) return false;
            hit = i; return true;
          });
          if (!hit || guard++ > 12) return cart;
          var take = Math.min(hit.quantity, left[hit.handle]);
          left[hit.handle] -= take;
          return DB_Cart._cartFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: hit.key, quantity: hit.quantity - take }) })
            .then(function() { return step(); });
        });
    };
    return step();
  },
  _bybAddBundleLoose: function(lines, q, onSuccess) {
    var self = this, b = window.DB_BYB;
    // Checkout waits until the price check below (and its fallback to the native bundle) is done: leaving
    // in between could take the bundle line AND its loose boxes (review 2 finding 6).
    self._bundleLooseBusy = true;
    self._opArm('loose', function() { self._bundleLooseBusy = false; });
    var done = function() { self._bundleLooseBusy = false; self._opDisarm('loose'); if (onSuccess) onSuccess(); };
    // addItems calls back on success AND after a failed add it has already rolled back, so the cart
    // itself is the only honest witness of which one happened.
    self.addItems(lines, function() {
      DB_Cart._cartFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var mine = 0, boxes = 0, free = 0;
          (cart.items || []).forEach(function(i) {
            if (i.selling_plan_allocation || !b.variants[i.handle]) return;
            boxes += i.quantity; free += self._bybFreeUnits(i);
            if (self._bybIsBundleTagged(i)) mine += i.quantity;
          });
          if (!mine) { done(); return; }                       // the add failed and was rolled back
          if (free >= Math.floor(boxes / 3)) { done(); return; } // the free box landed: bundle price holds
          var cap = {};
          lines.forEach(function(ln) { cap[ln.handle] = (cap[ln.handle] || 0) + ln.quantity; });
          return self._bybTakeTagged(cap)
            .then(function() {
              return DB_Cart._cartFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(self._addBody(b.bundleVariant, q || 1, null)) });
            })
            .then(function(r) { return self._okJson(r); })
            .then(function() { self.refresh(); self.open(); done(); });
        })
        .catch(function(e) {
          // The fallback itself failed (network, a 422 on the native line). Never leave it silent: the
          // drawer repaints from the real cart, so whatever is in it shows at its real price, and the
          // shopper is told to try again rather than finding out at checkout.
          console.error('Bundle add error:', e);
          self._toast('Could not add the bundle. Check your cart and try again.');
          self.refresh(); self.open(); done();
        });
    }, { src: 'bundle' });
  },
  // ==========================================================================
  // ARM AND RECONCILE (Stage 2, step 2). The step where the free box adds itself.
  //
  // Two halves, deliberately split:
  //   _bybTouch    records that the SHOPPER moved the cart, and which way. An add arms
  //                the auto-add; a removal disarms it. Nothing else may arm it, so the
  //                free box can never appear on a page load, on a refresh, or off the
  //                back of the Ship Happens coverage add. That is the FTC "sneaking"
  //                line: only the $0 box is ever added on its own, and only right after
  //                the shopper did something.
  //   _bybReconcile runs at the END of render, sees the cart that was just painted, and
  //                adds the free box when the cart is exactly one box short of one.
  //
  // A removal that LANDS one short of a free box (3 boxes down to 2) is a deliberate
  // "no thanks", not an accident, so it sets the opt-out and the box stays out. The way
  // back in is the slot in the offer bar, which the shopper taps themselves. The opt-out
  // is in-memory here; step 4 persists it against the cart token.
  //
  // The whole add runs as one _enqueue job: read, re-check, add, price, re-read. Nothing
  // can slip a write between the read and the add, which is the collision the queue in
  // step 1 exists to stop.
  // ==========================================================================
  _bybArmed: false,     // a shopper add happened; never set by render, refresh or a page load
  // (_bybSrc removed 2026-09-18: it was written on every touch and read nowhere. The _byb_src line
  //  property is set at each call site instead, which is the more accurate thing anyway, because it
  //  describes the path the box came in by rather than whatever last armed the cart.)
  _bybOptOutMem: '',    // in-memory mirror of the opt-out, for when localStorage is blocked
  _bybLastRemoved: '',  // the scent they last took off, so the auto-add does not push it back
  _bybRemoved: null,    // a removal is pending judgement; reconcile decides once it sees the count
  _bybAdding: false,    // one auto-add in flight
  _bybTried: {},        // cart states already attempted, so a blocked add never loops
  _bybBlocked: false,   // a verified add came back NOT free: this cart cannot take the offer
  _bybBlockedCodes: '', // the codes that were on the cart when it blocked, so a change un-blocks it
  _bybSwapOpen: '',     // which scent row has its swap panel open, '' for none. One at a time.

  // Has the shopper taken the free box off THIS cart?
  //
  // Stored against the CART TOKEN, so a fresh cart (after checkout, or after the cart is emptied)
  // starts clean and last week's no does not haunt a new shopper. Persisted, so the answer survives
  // a reload and reaches a second tab, which an in-memory flag could not.
  //
  // The in-memory mirror is read FIRST, exactly like the Ship Happens opt-out: if storage is blocked
  // (a private window, an extension), a removal this session must still be honoured, or reconcile
  // would push the box straight back in and the shopper would have no way to get rid of it.
  _bybOptOutKey: function(cart) { return String((cart && cart.token) || '-'); },
  _bybOptedOut: function(cart) {
    var token = this._bybOptOutKey(cart);
    if (this._bybOptOutMem && this._bybOptOutMem === token) return true;
    try { return localStorage.getItem('db_byb_free_optout') === token; } catch (e) { return false; }
  },
  _bybSetOptOut: function(cart) {
    var token = this._bybOptOutKey(cart);
    this._bybOptOutMem = token;
    try { localStorage.setItem('db_byb_free_optout', token); } catch (e) {}
  },
  _bybClearOptOut: function() {
    this._bybOptOutMem = '';
    try { localStorage.removeItem('db_byb_free_optout'); } catch (e) {}
  },
  // A shopper moved the cart. dir > 0 is an add, dir < 0 is a removal.
  // Is this variant id one of the three one-time scent boxes? The arm is about BOXES, not about
  // "the shopper did something": a hat from the in-drawer merch upsell, a Subscribe and Save box, or
  // the Big Bastard Bundle must never arm the free box. Each of those used to, because addItem armed
  // on any product: a merch tap re-added the box the shopper had just removed and wiped the opt-out
  // they had just earned, and a bundle tap grew a fourth loose box. Reproduced 2026-09-18.
  _bybIsBoxVariant: function(variantId) {
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || variantId === null || variantId === undefined) return false;
    var want = String(variantId), h;
    for (h in byb.variants) {
      if (Object.prototype.hasOwnProperty.call(byb.variants, h) && String(byb.variants[h]) === want) return true;
    }
    return false;
  },
  _bybTouch: function(src, dir, handle) {
    if (!this._bybAuto()) return;
    if (dir > 0) {
      this._bybArmed = true;
      if (handle && window.DB_BYB.variants && window.DB_BYB.variants[handle]) this._bybLastTapped = handle;
      // They asked for more boxes, so the free one is welcome again.
      this._bybClearOptOut();
      this._bybLastRemoved = '';
      this._bybRemoved = null;
    } else if (dir < 0) {
      this._bybArmed = false;
      this._bybLastRemoved = handle || '';
      // Held as a string (the handle, possibly empty) so reconcile can tell "a removal is
      // waiting to be judged" from "nothing happened". null means nothing is pending.
      this._bybRemoved = handle || '';
    }
  },
  // One-time scent boxes in the cart. Subscription lines and the Big Bastard Bundle's own
  // boxes never count: the Buy 2 Get 1 discount is one-time only and scoped to the three
  // scent products (PRD), so counting them would promise a free box checkout will not give.
  _bybBoxes: function(cart) {
    var byb = window.DB_BYB, n = 0;
    if (!byb || !byb.variants || !cart || !cart.items) return 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!it.selling_plan_allocation && byb.variants[it.handle]) n += it.quantity;
    }
    return n;
  },
  // Which scent the free box should be. Preferences in order:
  //   1. a scent he does not have yet, so a one-box shopper ends up with all three
  //   2. failing that, any scent with headroom under its cap
  //   3. never the scent he just took off, unless it is the only one left
  // Within each pass it walks the free order BACKWARDS, because Buy 2 Get 1 frees the last
  // unit added and the last entry is the scent that should wear the FREE tag (Coastal Drift,
  // founder 2026-09-17).
  // (Rewritten 2026-10-09: see _bybPickFromCounts for the order and why.) A free box already showing
  // on screen keeps its scent, as long as that scent still has room.
  _bybPickScent: function(cart) {
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || !this._bybFreeOrder().length) return '';
    if (this._bybAutoPlanned && this._bybCanAdd(this._bybAutoPlanned, cart)) return this._bybAutoPlanned;
    var have = {};
    ((cart && cart.items) || []).forEach(function(it) {
      if (!it.selling_plan_allocation && byb.variants[it.handle]) have[it.handle] = (have[it.handle] || 0) + it.quantity;
    });
    return this._bybPickFromCounts(have);
  },
  // Add the free box as ONE job: read, re-check, add, price, re-read, VERIFY, roll back if needed.
  // Re-reads the cart inside the lane first, because the gate was decided against the cart render
  // painted and another write may have landed since.
  //
  // STEP 3, the promise this function exists to keep: WE NEVER CHARGE FOR A FREE BOX. The add is
  // only half the job. Shopify applies whichever discount saves the shopper more, so a big code on
  // the cart can beat Buy 2 Get 1 and leave the box we just added as a PAID third box. So the cart
  // is re-read and the free count compared against what it was before the add. If it did not go up,
  // the box comes straight back off, silently, and the offer bar stands down (_bybBlocked).
  //
  // It fails CLOSED: if the allocation never shows (the automatic is off, a payload without
  // allocation detail), the count does not rise, the box is removed, and the cart is simply the
  // plain cart. The feature doing nothing is the correct failure; charging for a gift is not.
  _bybAutoAdd: function(handle, intentKey, onStart) {
    var self = this, byb = window.DB_BYB;
    var vid = String(byb && byb.variants && byb.variants[handle]);
    // Quantities of THIS variant only, the shape _bybUndo takes to put the cart back.
    var qtyOf = function(cart) {
      var m = {};
      ((cart && cart.items) || []).forEach(function(i) {
        if (String(i.variant_id) === vid && !i.selling_plan_allocation) m[vid] = (m[vid] || 0) + i.quantity;
      });
      return m;
    };
    return this._enqueue(function(f) {
      if (onStart) { try { onStart(); } catch (eS) {} }
      return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(fresh) {
          var boxes = self._bybBoxes(fresh);
          // Decided not to act: release the intent stamp reconcile took on our behalf, so a job that
          // looked and correctly did nothing does not burn that cart state forever.
          var standDown = function() {
            if (intentKey) { delete self._bybTried[intentKey]; }
            return null;
          };
          // Still exactly one short, and the scent is still addable? If not, do nothing at all.
          if (boxes < 2 || boxes % 3 !== 2) return standDown();
          if (!self._bybCanAdd(handle, fresh)) return standDown();
          // Acting. Keep the intent stamp AND stamp the state we actually read, which may differ.
          self._bybTried[self._bybTriedKey(fresh, boxes)] = 1;
          // What the cart must look like afterwards if nothing else has touched it.
          var expected = boxes + 1;
          var before = qtyOf(fresh);
          return f('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(self._addBody(byb.variants[handle], 1, null, { _byb_auto: '1', _byb_src: 'auto' }))
          })
            .then(function(r) { return self._okJson(r); })
            // Placed AFTER _okJson, not as its sibling: a sibling handler catches the FETCH failing,
            // while a 422 is _okJson's OWN rejection and sails straight past it. That mistake meant
            // the rollback below never ran. A multi-line add is not all-or-nothing on Shopify: it
            // adds the maximum available quantity and THEN returns 422 (real cart, 2026-09-16), so
            // a box the cart added by itself was left sitting there at full price.
            .then(null, function(err) {
              return self._bybUndo(before, qtyOf, f).then(function() { throw err; }, function() { throw err; });
            })
            .then(function() { return self._bybApplyTestCode(f); })
            .then(function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
            .then(function(r) { return r.json(); })
            .then(function(after) {
              // EXACTLY what we predicted, or put our box back. _bybFreeShortfall is max(0, owed
              // minus free), so it only ever detects TOO FEW free boxes; an EXCESS of BOXES reads as
              // 0 and used to sail through as success. Two auto-adds racing (possible once the lane's
              // own 15s cap expires) took a cart from 2 boxes to 4: owed 1, rang 1, shortfall 0,
              // accepted, and the shopper pays for 3 boxes at $74.97 having asked for 2. Found by the
              // other session on 2026-09-18 by reading the code, before it was ever reproduced.
              if (self._bybBoxes(after) !== expected) {
                return self._bybUndoAuto(f)
                  .then(function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
                  .then(function(r) { return r.json(); });
              }
              if (self._bybFreeShortfall(after) === 0) { self._bybAutoKept = true; return after; }      // Shopify really rang it free
              // It did not come out free. Take it back off and stand the offer down.
              self._bybBlocked = true;
              self._bybBlockedCodes = self._bybCodeKey(after);
              return self._bybUndoAuto(f)
                .then(function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
                .then(function(r) { return r.json(); });
            });
        });
    });
  },
  // Called at the END of render, with the cart that was just painted.
  // Judge a pending removal. A shopper removal that LANDS one short of a free box is a deliberate
  // "no thanks", so it sets the opt-out and the box stays out.
  //
  // This runs BEFORE the bar paints, not at the end of render with the rest of reconcile. The bar's
  // wording depends on it ("your free box is still yours" is only true if he took one off), so
  // judging it afterwards made the bar read, on the very render where he removed the box, as though
  // he never had. Idempotent, so reconcile calling it again is harmless.
  _bybJudgeRemoval: function(cart) {
    if (!this._bybAuto() || !cart || !cart.items) return;
    if (typeof this._bybRemoved !== 'string') return;
    // His removal is recorded when he taps (_bybIntent); it is judged on the cart his moves land on, not
    // on an in-between cart that arrives first.
    if (this._userOpsInFlight()) return;
    this._bybRemoved = null;
    var boxes = this._bybBoxes(cart);
    if (boxes >= 2 && boxes % 3 === 2) this._bybSetOptOut(cart);
  },
  _bybReconcile: function(cart) {
    if (!this._bybAuto() || !cart || !cart.items) return;
    var self = this, boxes = this._bybBoxes(cart);
    this._bybJudgeRemoval(cart);
    // HE IS STILL TAPPING (founder 2026-10-09). Decide once his moves are all in Shopify's cart and he has
    // paused: every landing and the pause timer call back here. Deciding mid-burst added a free box
    // between two of his taps; deciding while his chip's add was on its way added it AHEAD of that add,
    // and his $0.00 chip box rang up as a paid 4th (review finding 1).
    if (this._userOpsInFlight()) return;
    var wait = this._bybGraceUntil - Date.now();
    if (wait > 0) {
      clearTimeout(this._bybRecheckT);
      this._bybRecheckT = setTimeout(function() { if (self._lastCart) self.render(self._lastCart); }, wait + 10);
      return;
    }
    // A free box already on screen that the cart now decides NOT to add comes straight back off it.
    var drop = function() {
      if (!self._bybAutoPlanned || self._bybAutoStarted) return;
      self._bybAutoPlanned = '';
      setTimeout(function() { if (self._lastCart) self.render(self._lastCart); }, 0);
    };
    if (this._bybBlocked) { drop(); return; }     // proven: this cart cannot take the free box
    if (!this._bybArmed) { drop(); return; }      // shopper action only, never a page load
    if (this._bybOptedOut(cart)) { drop(); return; } // they took it off and meant it, on this cart
    if (this._bybAdding) return;      // one add in flight
    if (this._protectAdding) return;  // the coverage add owns the cart this tick
    if (this._protectSyncing) return; // a coverage plan repair owns the cart this tick
    if (boxes < 2 || boxes % 3 !== 2) { drop(); return; }
    // Tried once per cart state and never again, so a blocked add (a code that beats the
    // free box, a 422) cannot turn into a loop of adds against a live store.
    // Stamped by the JOB, once it has re-checked and is actually going to add (see _bybAutoAdd).
    // Stamping here burned the state on a job that looked and correctly did nothing, which left a
    // genuinely eligible cart unable to ever get its free box. Reproduced 2026-09-18.
    var key = this._bybTriedKey(cart, boxes);
    if (this._bybTried[key]) { drop(); return; }
    var handle = this._bybPickScent(cart);
    if (!handle) { drop(); return; }  // every scent capped out: silent, no auto-add
    // The box on screen is the box that goes in.
    this._bybAutoPlanned = handle;
    this._bybAutoStarted = true;
    // STAMP THE INTENT HERE, synchronously, before the job can await anything.
    //
    // The stamp used to be taken inside the job, after its first read resolved. That left a window:
    // if that read STALLS past the lane's own _QUEUE_MS give-up, the lane releases, a later render
    // finds nothing stamped, and a second job starts CONCURRENTLY with the first. Both read the same
    // short cart, both add, and the shopper ends up with two free boxes. The in-job re-check cannot
    // catch it, because both reads happen before either write. _bybAutoAdd releases this stamp again
    // if it decides not to act, so a no-op still does not burn the state.
    this._bybTried[key] = 1;
    this._bybAdding = true;
    // A fetch that never settles (a dropped mobile connection, a Cloudflare hold) used to leave this
    // flag true for the life of the page, which killed the free box for the whole session with no
    // symptom. It now gives up INSIDE the lane's own give-up, not after it: see below.
    var released = false;
    var release = function() { if (!released) { released = true; self._bybAdding = false; } };
    // INSIDE the lane's own give-up, not after it. At _QUEUE_MS + 2000 this only ever fired in a
    // regime where the lane had already released, so it cleared the flag at precisely the moment
    // serialization was gone. Firing early means a premature clear still lands while the lane holds.
    this._bybLastAdded = handle;
    this._bybAutoSeq = this._opSeq();
    var job = this._bybAutoJob = (this._bybAutoJob || 0) + 1;
    // Only this job's own landing (or give-up) takes its box off; a late answer must not clear a newer plan.
    var settle = function() { if (self._bybAutoJob !== job) return; self._bybAutoPlanned = ''; self._bybAutoStarted = false; };
    // A job that never answers also takes its box back off the screen and reads Shopify's cart again;
    // clearing only _bybAdding left the box painted and checkout held for the life of the page (review finding 2).
    // Armed when the job STARTS (like the lane's own cap), so a job still waiting in a long queue is not given up on.
    var watchdog = null;
    var armWatchdog = function() {
      watchdog = setTimeout(function() {
        release();
        if (self._bybAutoPlanned === handle && self._bybAutoStarted) { settle(); if (self._lastCart) self.render(self._lastCart); self._resync(); }
      }, Math.max(2000, self._QUEUE_MS - 2000));
    };
    this._bybAutoKept = false;
    this._bybAutoAdd(handle, key, armWatchdog).then(function(c) {
      clearTimeout(watchdog); release();
      // Disarm on success. "Armed" means the shopper just asked for boxes, and that request has now
      // been answered. Leaving it armed let a later render the shopper did not cause (a discount
      // re-apply, a coverage repair, a second tab) add another box on its own.
      self._bybArmed = false;
      settle();
      if (self._bybAutoKept) { self._bybAutoKept = false; var sh = {}; sh[handle] = 1; self._bfShiftBase(sh); }
      if (c) self.render(c); else if (self._lastCart) self.render(self._lastCart);
    }, function(e) {
      // Silent on purpose: an auto-add the shopper never asked for must never raise a toast
      // or an error state. The cart just stays as it is and the offer bar keeps the slot.
      clearTimeout(watchdog); release();
      settle();
      if (self._lastCart) self.render(self._lastCart);
      self._resync();   // the add may have landed before the failure (a lost answer): read Shopify's cart until it answers
      console.error('Free box auto-add error:', e);
    });
    // The bar was painted (by the render that called this) before the box was on its way: paint it again,
    // so a cart that cannot be predicted does not keep offering $0.00 chips while the box is being added
    // (a chip tapped then rang up a paid 4th box: review 2 finding 1). The paint after this shows the rest.
    this._paintOffer(cart);
  },
  // ==========================================================================
  // MYSTERY GIFT IN THE CART (see DB_Gift at the top of this file). One gift line, put there and taken
  // away by the cart itself, never by the shopper:
  //   ADD     while the gift is on and the cart qualifies: an unlocked browser (an email) AND 3+ one-time
  //           boxes, any mix (a native bundle line counts as 3).
  //   REMOVE  when the cart stops qualifying or the window closes.
  //   NEVER CHARGE. A gift line that comes back above $0.00 (the discount missing, a code that beats
  //           it) comes straight off and stays off for this cart and these codes, like the free box.
  // Every write runs as one job in the cart lane (_enqueue), so it never races the free-box add or the
  // coverage add, and each cart state is tried once, so a refused add can never loop.
  // ==========================================================================
  _giftBusy: false,
  _giftTried: {},
  _giftBlocked: '',
  _giftIsLine: function(item) {
    var g = window.DB_GIFT;
    return !!(g && g.variant && item && String(item.variant_id) === String(g.variant));
  },
  // No email, no gift (founder 2026-10-27), and bundles only (founder 2026-10-28): an unlocked browser AND 3+ one-time
  // boxes. (Oct 7 to Oct 27 the 3+ boxes alone did it; Oct 27 to 28 an email at any order did.)
  _giftWant: function(cart) {
    if (!DB_Gift.on() || !DB_Gift.unlocked() || !cart || !cart.items) return 0;
    return this._giftBoxes(cart) >= 3 ? 1 : 0;
  },
  // One-time boxes in a cart for the gift rules: a scent line counts its quantity, a native bundle line counts 3.
  // Subscription boxes don't count (the bundle is one-time only).
  _giftBoxes: function(cart) {
    var byb = window.DB_BYB, scents = (byb && byb.handles) || ['coastal-drift', 'amber-canyon', 'alaskan-alpine'];
    var n = 0, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].selling_plan_allocation) continue;
      if (scents.indexOf(items[i].handle) > -1) n += items[i].quantity;
      else if (items[i].handle === 'big-bastard-bundle') n += 3 * items[i].quantity;
    }
    return n;
  },
  // A cart that would hold the gift if he gave us an email: the drawer and the cart page draw a locked gift row
  // whose button opens the unlock (game-popup.liquid, openGiftUnlock). Never shown when the unlock is missing.
  _giftLocked: function(cart) {
    return !!(DB_Gift.on() && !DB_Gift.unlocked() && typeof window.openGiftUnlock === 'function' && this._giftBoxes(cart) >= 3);
  },
  // One slim line (founder 2026-10-28: "i need it to be more subtle... it cant take up so much space"); the whole strip
  // is the button.
  _giftLockedRowHtml: function() {
    return '<button type="button" class="cart-gift-locked" onclick="DB_Cart.unlockGift()">' +
      DB_Gift.icon('cart-gift-locked__g') +
      '<span class="cart-gift-locked__t">Free ' + DB_Gift.valueText() + ' mystery gift with your email</span>' +
      '<span class="cart-gift-locked__a">Unlock</span>' +
    '</button>';
  },
  unlockGift: function() {
    if (typeof window.openGiftUnlock !== 'function') return;
    this.close();
    window.openGiftUnlock('cart');
  },
  // The gift lines on a cart, how many, whether any rang up above $0.00, and how many the cart should hold.
  _giftState: function(cart) {
    var lines = [], have = 0, charged = false, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (!this._giftIsLine(items[i])) continue;
      lines.push(items[i]); have += items[i].quantity;
      if ((items[i].final_line_price || 0) > 0) charged = true;
    }
    return { lines: lines, have: have, charged: charged, want: this._giftWant(cart) };
  },
  // Blocked per cart AND per set of codes, so a shopper who removes the code that beat the gift gets one more try.
  _giftBlockKey: function(cart) { return ((cart && cart.token) || '-') + '|' + this._bybCodeKey(cart); },
  _giftReconcile: function(cart) {
    var g = window.DB_GIFT;
    if (!g || !g.variant || !cart || !cart.items) return;
    // Another cart write owns this tick; the render it finishes with brings us back here.
    if (this._giftBusy || this._bybAdding || this._protectAdding || this._protectSyncing) return;
    // His own taps still on their way: the render they land with brings the gift sync back.
    if (this._instantWanted && this._instantWanted()) return;
    var st = this._giftState(cart);
    var want = this._giftBlocked === this._giftBlockKey(cart) ? 0 : st.want;
    if (st.have === want && !st.charged) return;
    var key = this._giftBlockKey(cart) + ':' + want + ':' + st.have + ':' + (st.charged ? 1 : 0);
    if (this._giftTried[key]) return;
    this._giftTried[key] = 1;
    var self = this;
    this._giftBusy = true;
    // Released inside the lane's own give-up, the same pattern as the free-box add (see _bybReconcile).
    var released = false, release = function() { if (!released) { released = true; self._giftBusy = false; } };
    var watchdog = setTimeout(release, Math.max(2000, this._QUEUE_MS - 2000));
    this._enqueue(function(f) {
      var read = function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }); };
      return read().then(function(fresh) {
        var s = self._giftState(fresh);
        var w = self._giftBlocked === self._giftBlockKey(fresh) ? 0 : s.want;
        if (s.charged) {
          // Never charge for the gift: off it comes, and it stays off while the cart and its codes stay as they are.
          self._giftBlocked = self._giftBlockKey(fresh);
          return self._giftRemoveAll(s.lines, f).then(read);
        }
        if (w === 0) return s.have ? self._giftRemoveAll(s.lines, f).then(read) : null;
        if (s.have === 1) return null;
        // One gift per order: anything other than one line of one comes off before the single add.
        return (s.have ? self._giftRemoveAll(s.lines, f) : Promise.resolve())
          .then(function() { return self._giftAdd(fresh, f, read); });
      });
    }).then(function(c) {
      clearTimeout(watchdog); release();
      if (c) self.render(c);
    }, function(e) {
      // Silent on purpose: the shopper never asked for this write, so it never raises an error state.
      clearTimeout(watchdog); release();
      console.error('Mystery gift sync error:', e);
    });
  },
  _giftRemoveAll: function(lines, f) {
    var chain = Promise.resolve();
    (lines || []).forEach(function(l) {
      chain = chain.then(function() {
        return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: l.key, quantity: 0 }) });
      });
    });
    return chain;
  },
  // Add ONE gift and prove Shopify rang it up at $0.00, or take it straight back off.
  _giftAdd: function(cart, f, read) {
    var self = this, g = window.DB_GIFT;
    var body = { items: [{ id: parseInt(g.variant, 10), quantity: 1, properties: { _gift: '1' } }] };
    return f('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r) {
        // A 422 (sold out between the page load and now) RESOLVES the fetch. Stand down for this cart.
        if (!r.ok) { self._giftBlocked = self._giftBlockKey(cart); return null; }
        return self._applyTestCode(g.code, f).then(read).then(function(after) {
          var s = self._giftState(after);
          if (!s.charged) return after;
          self._giftBlocked = self._giftBlockKey(after);
          return self._giftRemoveAll(s.lines, f).then(read);
        });
      })
      .then(function(c) { return c || read(); });
  },
  // The cart's gift row: the gift, its price ($10.00) struck, FREE. No stepper: the cart owns this line.
  // One slim line inside the bundle card (founder 2026-10-28: "more subtle"), the same line as the gift on its own.
  _giftRowHtml: function(line) {
    var orig = line.original_line_price || DB_Gift.value(), fin = line.final_line_price || 0;
    return '<div class="cart-gift-row cart-gift-slim">' +
      DB_Gift.icon('cart-gift-slim__g') +
      '<span class="cart-gift-slim__t">Mystery gift, in the box</span>' +
      '<span class="cart-gift-slim__p">' + (orig > fin ? '<span class="cart-item-orig">' + DB_Gift.money(orig) + '</span> ' : '') + (fin > 0 ? DB_Gift.money(fin) : '<span class="cart-item-free">FREE</span>') + '</span>' +
    '</div>';
  },
  // THE HOODIE DROP (2026-10-29): the free box is its own hidden product (hoodie-drop-free-box, a native bundle of the
  // real scent box), so none of the box counting above ever sees it. Two rules live here: its row has no stepper (the
  // cart owns this line), and a cart never holds more free boxes than hoodies, so a hoodie taken out takes its box with
  // it and nobody is charged for a box he was told was free.
  _HD_HOODIE: 'dirty-bastard-hoodie',
  _HD_BOX: 'hoodie-drop-free-box',
  _hdBusy: false,
  _hdTried: {},
  _hdState: function(cart) {
    var hoodies = 0, have = 0, lines = [], items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === this._HD_HOODIE) hoodies += items[i].quantity;
      else if (items[i].handle === this._HD_BOX) { lines.push(items[i]); have += items[i].quantity; }
    }
    return { hoodies: hoodies, have: have, lines: lines };
  },
  _hdReconcile: function(cart) {
    if (!cart || !cart.items || this._hdBusy) return;
    // Another cart write owns this tick; the render it finishes with brings us back here.
    if (this._giftBusy || this._bybAdding || this._protectAdding || this._protectSyncing) return;
    if (this._instantWanted && this._instantWanted()) return;
    var st = this._hdState(cart);
    if (st.have <= st.hoodies) return;
    var key = ((cart && cart.token) || '-') + ':' + st.hoodies + ':' + st.have;
    if (this._hdTried[key]) return;
    this._hdTried[key] = 1;
    var self = this;
    this._hdBusy = true;
    this._enqueue(function(f) {
      var read = function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }); };
      return read().then(function(fresh) {
        var s = self._hdState(fresh), extra = s.have - s.hoodies, chain = Promise.resolve();
        if (extra <= 0) return null;
        // The newest box lines come off first.
        s.lines.slice().reverse().forEach(function(l) {
          if (extra <= 0) return;
          var cut = Math.min(extra, l.quantity); extra -= cut;
          chain = chain.then(function() {
            return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: l.key, quantity: l.quantity - cut }) });
          });
        });
        return chain.then(read);
      });
    }).then(function(c) {
      self._hdBusy = false;
      if (c) self.render(c);
    }, function(e) {
      // Silent on purpose, like the gift sync: the shopper never asked for this write.
      self._hdBusy = false;
      console.error('Hoodie box sync error:', e);
    });
  },
  // A clothing size reads as words in the cart, "Size: Large", not a bare "L" (founder 2026-10-29). Any other
  // variant title (a scent) prints as it is.
  _variantLabel: function(item) {
    var v = item && item.variant_title, sizes = { 'XS': 'X-Small', 'S': 'Small', 'M': 'Medium', 'L': 'Large', 'XL': 'X-Large', '2XL': '2X-Large', '3XL': '3X-Large' };
    return sizes[v] ? 'Size: ' + sizes[v] : (v || '');
  },
  // The free box's row: the scent, its price struck when the drop discount took it, FREE. No stepper.
  _hdRowHtml: function(item) {
    var orig = item.original_line_price || 0, fin = item.final_line_price || 0;
    var img = item.featured_image ? item.featured_image.url + (item.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    var money = function(c) { return '$' + (c / 100).toFixed(2); };
    return '<div class="cart-item cart-item--hdbox">' +
      '<img class="cart-item-img" src="' + img + '" alt="" width="100" height="100" loading="lazy">' +
      '<div class="cart-item-info">' +
        '<div class="cart-item-name">Free box with your hoodie</div>' +
        '<div class="cart-item-variant">' + (item.variant_title || '') + (item.quantity > 1 ? ' &times; ' + item.quantity : '') + '</div>' +
        '<div class="cart-item-price">' + (orig > fin ? '<span class="cart-item-orig">' + money(orig) + '</span> ' : '') + (fin > 0 ? money(fin) : '<span class="cart-item-free">FREE</span>') + '</div>' +
      '</div>' +
    '</div>';
  },
  // The quiet subscribe line under the offer bar. Gate and action are the theme's own:
  // _unlockBox is set by render only for a single one-time box with no sub and no bundle,
  // and makeItSubscription already swaps that box to its 10-week plan.
  _paintSubStrip: function(show) {
    var el = document.getElementById('cart-substrip');
    if (!el) return;
    // `show` false: the cart being painted (a prediction too) no longer holds one single box, so the line
    // goes, even though Shopify's last cart still did (it sat under a predicted 2-box cart: review).
    if (!this._bybAuto() || !this._unlockBox || show === false) { el.style.display = 'none'; el.innerHTML = ''; return; }
    var price = el.getAttribute('data-sub-price') || '';
    el.innerHTML = 'or <button type="button" class="cart-substrip-btn" onclick="DB_Cart.makeItSubscription()">subscribe for ' +
      price + ' a box</button>';
    el.style.display = 'block';
    // ONE pitch per idea: the offer bar owns the free box, this strip owns the subscription,
    // so the old two-button upsell card stands down instead of repeating both.
    var up = document.getElementById('cart-unlock-upsell');
    if (up) up.style.display = 'none';
  },
  _paintOffer: function(cart) {
    var el = document.getElementById('cart-offer');
    if (!el) return;
    if (!this._bybAuto() || !cart || !cart.items) { el.style.display = 'none'; el.__dbHtml = null; el.innerHTML = ''; return; }
    // Proven blocked (an add came back not free). Every state of this bar promises a free box, so
    // none of them may be painted here, but going SILENT after a price moves is the shape that reads
    // as sneaking. Say what happened in one line instead.
    if (this._bybBlocked) {
      // Do not assert a cause we do not know. A competing code is the COMMON reason the free box
      // will not apply, but it is not the only one: before launch the Buy 2 Get 1 automatic is
      // parked at startsAt 2027-01-01, so on a cart with NO code at all the same path fires, and
      // "your discount code beats the free box" would be telling the shopper about a code they do
      // not have. Say what happened; name the code only when there is one.
      var hasCode = !!(cart.discount_codes && cart.discount_codes.length);
      el.__dbHtml = null; el.innerHTML = '<div class="cart-offer-note">' + (hasCode
        ? 'Your discount code beats the free box, so we left your cart as it was.'
        : 'The free box is not available on this cart, so we left it as it was.') + '</div>';
      el.style.display = 'block';
      return;
    }
    var byb = window.DB_BYB, i, it, boxes = 0, paidCents = 0;
    for (i = 0; i < cart.items.length; i++) {
      it = cart.items[i];
      if (it.selling_plan_allocation) continue;
      if (byb.variants[it.handle]) { boxes += it.quantity; paidCents += (it.final_line_price || 0); }
    }
    if (boxes < 1) { el.style.display = 'none'; el.__dbHtml = null; el.innerHTML = ''; return; }
    // No literal fallback. Every price in this theme comes from the product (the constants rule in
    // CLAUDE.md); a hardcoded 2499 would go stale silently the next time the founder moves a price.
    // If the price is not there, the bar says nothing rather than guessing.
    var price = byb.prices && byb.prices['coastal-drift'];
    if (!price) { el.style.display = 'none'; el.__dbHtml = null; el.innerHTML = ''; return; }
    var money = function(c) { return '$' + (c / 100).toFixed(2); };
    // The three segments read as an UNLOCK LADDER, not as cart contents (founder 2026-09-18):
    //   what you have -> what one more box does -> the reward.
    // Two things the labels must get right, both caught on the prototype:
    //   segment 1 shows the REAL box count, so it can never say "1 BOX" on a 4-box cart, and
    //   "Free shipping" only appears while it is NOT already earned, otherwise the bar dangles
    //   a benefit the shopper already owns.
    // The REAL answer render computed (a subscription, an applied code, or Shipping v2's threshold),
    // not a threshold guess. Guessing promised free shipping to a repeat customer who would meet the
    // flat rate at checkout. Where a claim is made about the NEXT cart, it is computed from what that
    // cart will hold, and the numbers come from window.DB_SHIP / DB_FREESHIP_MIN, never typed here.
    var shipAlready = !!this._shipFree;
    var shipMin = window.DB_FREESHIP_MIN || window.DB_BUNDLE_PRICE || 0;
    // A FORWARD-LOOKING shipping claim ("one more box and it ships free") is only unconditionally
    // true under Shipping v2, where any cart of the minimum ships free for every customer, first
    // order or not. Under today's model free shipping comes from SHIPSONUS, which Shopify enforces
    // once per customer, so the same sentence is false for a repeat customer and the drawer must not
    // say it. Below v2 the bar stays quiet about shipping and the line under Checkout owns the
    // wording, with its condition, from snippets/ship-copy.liquid.
    // It also has to be a claim about a CHANGE: a cart already over the minimum earns nothing by
    // adding another box, and saying "ships free" there dangles a benefit already owned.
    var shipV2 = !!(window.DB_SHIP && window.DB_SHIP.v2);
    var shipAfterOneMore = shipV2 && !!shipMin && paidCents < shipMin && (paidCents + price) >= shipMin;
    var seg = function(filled, compact) {
      var s = '<div class="cart-offer-segs' + (compact ? ' compact' : '') + '">', k;
      for (k = 1; k <= 3; k++) {
        var on = k <= filled, gift = k === 3, body = '', pr, cp, cpCls = 'cart-offer-cap';
        if (!compact) {
          if (gift) {
            pr = '<b><span class="cart-offer-emoji" aria-hidden="true">\uD83C\uDF81</span> FREE BOX</b>';
            cp = 'Any scent'; cpCls += ' gift';
          } else if (k === 1) {
            pr = boxes + (boxes === 1 ? ' BOX' : ' BOXES'); cp = 'In your cart';
          } else {
            pr = 'ADD 1 MORE'; cp = (!shipAlready && shipAfterOneMore) ? 'Ships free' : '&nbsp;';
            if (!on) cpCls += ' add';
          }
          body = '<div class="cart-offer-price">' + pr + '</div><div class="' + cpCls + '">' + cp + '</div>';
        }
        // The NEXT step gets an amber outline so the eye lands on what to do, matching the
        // approved prototype. Only meaningful in the non-compact state.
        var segCls = on ? ' on' : (gift ? ' gift' : (!compact && k === 2 ? ' add' : ''));
        s += '<div class="cart-offer-col"><div class="cart-offer-seg' + segCls + '"></div>' + body + '</div>';
      }
      return s + '</div>';
    };
    var mod = boxes % 3, html = '';
    // Which box is the free one: the 3rd at 1-2 boxes, the 6th at 4-5 (the bundle page ladder, founder 2026-10-07).
    var freeNth = boxes - mod + 3, freeOrd = freeNth + (freeNth === 3 ? 'rd' : 'th');
    // MYSTERY GIFT: the third box brings the gift (bundles only, founder 2026-10-28), so a cart one or two boxes short says
    // so in one quiet line. The email it also needs is asked for at three boxes, by the locked strip.
    var giftNext = boxes < 3 && DB_Gift.on() && !cart.items.some(function(i) { return DB_Cart._giftIsLine(i); });
    var giftLine = giftNext ? '<div class="cart-offer-giftline"><span aria-hidden="true">🎁</span> Plus a free ' + DB_Gift.valueText() + ' mystery gift</div>' : '';
    if (mod === 1) {
      // THE ONE BUTTON, NOW NAMING THE SCENT (founder 2026-10-09: "why is it always another free box of
      // coastal drift? what if somebody doesnt want coastal drift"). It used to choose both boxes itself,
      // scents he did not have first and then the standing order, so the box that rang FREE was Coastal
      // Drift. Now it offers the scent he picked last (else the one he has most of), says so, and adds the
      // paid box AND the free one in one tap. "Pick another scent" opens the other two only when he asks:
      // a row of three chips here wrapped to two lines on small phones and pushed a scent row out of view
      // (founder 2026-10-07: every scent row in view on a short phone). Founder's look kept (2026-09-17,
      // "ONE action plus the price").
      var shipLine = (!shipAlready && shipAfterOneMore) ? ' Ships free.' : '';
      // His "Add 1 more" is on its way on a cart the drawer cannot predict (a partner code): the button
      // says so and does nothing, so a second tap cannot add two more (review 2 finding 5).
      if (!cart._predicted && this._instantOps.some(function(o) { return o.kind === 'more'; })) {
        html = '<button class="cart-offer-cta" type="button" data-k="cta" disabled aria-disabled="true"><b>Adding your free box</b><span>One moment.</span></button>' + seg(1, false);
        if (el.__dbHtml !== html) { el.innerHTML = html; el.__dbHtml = html; }
        el.style.display = 'block';
        return;
      }
      var ctaH = this._bybCtaScent(cart);
      if (!ctaH) { el.style.display = 'none'; el.__dbHtml = null; el.innerHTML = ''; return; }
      var ctaNm = byb.names[ctaH] || ctaH;
      html = '<button class="cart-offer-cta" type="button" data-k="cta" onclick="DB_Cart.addMoreBoxes(this,\'' + ctaH + '\')">' +
        '<b>Add 1 more ' + ctaNm + ', ' + money(price) + '</b><span>Your ' + freeOrd + ' box is free, same scent.' + shipLine + (giftNext ? ' Plus a mystery gift.' : '') + '</span></button>';
      if (this._bybOtherOpen) {
        html += '<div class="cart-offer-picks">' + (byb.handles || this._bybFreeOrder()).filter(function(h) { return h !== ctaH; }).map(function(h) {
          var img = (byb.images && byb.images[h]) || '', nm = byb.names[h] || h, ok = DB_Cart._bybCanAdd2(h, cart);
          return '<button class="cart-offer-chip" type="button" data-k="add-' + h + '"' + (ok ? '' : ' aria-disabled="true" disabled') +
            ' aria-label="' + (ok ? 'Add 2 ' + nm + ' boxes for ' + money(price) + ', one of them free' : nm + ', out of stock') + '"' +
            ' onclick="DB_Cart.addMoreBoxes(this,\'' + h + '\')">' + (img ? '<img src="' + img + '" alt="" aria-hidden="true">' : '') + nm + '</button>';
        }).join('') + '</div>';
      } else {
        html += '<button class="cart-offer-other" type="button" data-k="other" onclick="DB_Cart.bybOtherScent()">Pick another scent</button>';
      }
      html += seg(1, false);
    } else if (mod === 2 && !cart._predicted && ((this._bybAutoPlanned && this._bybAutoStarted) || this._pendingSlot)) {
      // The free box is on its way (the cart's own, or his chip) on a cart painted from Shopify's answer:
      // no chips now, or a tap would add a second box at full price (review 2 finding 1).
      html = '<div class="cart-offer-calm">Adding your free box<span class="cart-offer-amt"><s>' + money(price) + '</s><b>$0.00</b></span></div>' + seg(2, true);
    } else if (mod === 2) {
      var chips = this._bybFreeOrder().map(function(h) {
        var img = (byb.images && byb.images[h]) || '';
        var ok = DB_Cart._bybCanAdd(h, cart);
        // The accessible name says what the button DOES, not just the scent, and a scent that is
        // out of stock says so instead of silently dropping out of the tab order.
        var nm = byb.names[h] || h;
        return '<button class="cart-offer-chip" type="button" data-k="chip-' + h + '"' + (ok ? '' : ' aria-disabled="true" disabled') +
          ' aria-label="' + (ok ? 'Add your free box: ' + nm : nm + ', out of stock') + '"' +
          ' onclick="DB_Cart.addFreeBox(\'' + h + '\', this)">' +
          (img ? '<img src="' + img + '" alt="" aria-hidden="true">' : '') + nm + '</button>';
      }).join('');
      // Every chip disabled means there is nothing to offer, so offer nothing: the headline, the
      // struck price and "add it back" used to paint over three dead buttons.
      if (chips.indexOf('<button') === -1 || chips.indexOf(' disabled') > -1 && chips.split('<button').length - 1 === chips.split(' disabled').length - 1) {
        el.style.display = 'none'; el.__dbHtml = null; el.innerHTML = ''; return;
      }
      // "Still yours" and "add it back" are only true when he TOOK ONE OFF. On a cold 2-box cart
      // that never had a free box, they claim a history that did not happen. A predicted cart his minus
      // just landed one short says so straight away (the opt-out is written when Shopify confirms it).
      var tookOff = this._bybOptedOut(cart) || !!(cart._predicted && this._bybLastDir < 0);
      html = '<div class="cart-offer-calm">' + (tookOff ? 'Your free box is still yours' : ('Your ' + freeOrd + ' box is free')) +
        '<span class="cart-offer-amt"><s>' + money(price) + '</s><b>$0.00</b></span>' +
        '<span class="visually-hidden">Was ' + money(price) + ', now free.</span></div>' +
        giftLine +
        '<div class="cart-offer-l">' + (tookOff ? 'Add it back, any scent' : 'Pick your scent') + '</div>' +
        '<div class="cart-offer-picks">' + chips + '</div>' + seg(2, true);
    } else {
      // A FULL SET (3, 6, 9 boxes): the bar stands down and says nothing (founder 2026-09-28, off a
      // Clarity recording of a bundle cart: "remove the FREE BOX ADDED $0 ships free thing if they
      // already have 3 boxes in the cart"). The line already wears FREE with the struck price and
      // $0.00, its minus button sits on that line, and the note under Checkout carries shipping, so
      // the bar was saying all of it a second time. The confirmation it painted here ("Free box
      // added, $0.00 · ships free" / "Remove it any time with the minus button.") is at 4a6a075.
      // The 3-box exception of 2026-10-07 (one quiet line, "2 more = another free box" / "Tap + on any scent")
      // is gone. Founder 2026-10-13: "i also dont love the cart upsell when they already have 3 boxes in the cart,
      // we can upsell them post-purchase". So every full set (3, 6, 9) is silent again, as on 09-28, and the next
      // box is offered after checkout instead. The line is at 3e80f5c if it ever comes back.
      el.style.display = 'none'; el.__dbHtml = null; el.innerHTML = '';
      // Blank the hidden status line too. Left alone it kept "Add 1 more box, $24.99" on a 3-box cart
      // for a screen reader to find (measured on the sandbox), and forgetting the sentence means the
      // next state he reaches (one box off, back to two) is announced again.
      var stFull = document.getElementById('cart-offer-status');
      if (stFull) stFull.textContent = '';
      this._bybSaid = '';
      // One offer per cart still holds with the bar silent: the top free-shipping strip stays down
      // too, or it pops up with its own "Free shipping on this order" in the space the bar just left.
      var fsFull = document.getElementById('cart-freeship');
      if (fsFull) fsFull.style.display = 'none';
      return;
    }
    // innerHTML destroys the focused control, which threw a keyboard or switch user to the top of
    // the document on EVERY tap inside the bar (measured: activeElement went to BODY). Remember what
    // had focus and put it back.
    var hadFocus = el.contains(document.activeElement) ? document.activeElement.getAttribute('data-k') : null;
    // Only rewrite the bar when its words changed: the same bar repainted swapped a chip out from under a finger.
    if (el.__dbHtml !== html) { el.innerHTML = html; el.__dbHtml = html; } else { hadFocus = null; }
    el.style.display = 'block';
    if (hadFocus) {
      var back = el.querySelector('[data-k="' + hadFocus + '"]');
      if (back) { try { back.focus(); } catch (eF) {} }
    }
    // ONE sentence into a visually hidden live region, instead of letting the whole bar be the live
    // region. Every paint replaced the whole subtree, so a screen reader re-announced all of it
    // ("Add another box to earn FREE box any scent FREE shipping 4 BOXES In your cart ADD 1 MORE
    // wrapped gift FREE BOX Any scent") on every cart change, twice per tap.
    var status = document.getElementById('cart-offer-status');
    if (status) {
      var say = el.querySelector('.cart-offer-done') || el.querySelector('.cart-offer-note') || el.querySelector('.cart-offer-calm') || el.querySelector('.cart-offer-cta b');
      var next = say ? say.textContent.replace(/\s+/g, ' ').trim() : '';
      if (next && next !== this._bybSaid) { status.textContent = next; this._bybSaid = next; }
    }
    // ONE offer per cart: the old email-for-free-shipping block stands down while this bar is on,
    // otherwise the drawer states free shipping twice on top of the line under Checkout.
    var fs = document.getElementById('cart-freeship');
    if (fs) fs.style.display = 'none';
  },
  // The scent the 1-or-4-box button offers: the one he picked last, else the one he has most of, with
  // room for two more under its stock cap (the button adds the paid box AND the free one).
  _bybCtaScent: function(cart) {
    var byb = window.DB_BYB, self = this, have = {};
    ((cart && cart.items) || []).forEach(function(i) { if (!i.selling_plan_allocation && byb.variants[i.handle]) have[i.handle] = (have[i.handle] || 0) + i.quantity; });
    var first = this._bybPickFromCounts(have);
    if (first && this._bybCanAdd2(first, cart)) return first;
    var hs = (byb.handles || []).slice().sort(function(a, b) { return (have[b] || 0) - (have[a] || 0); });
    for (var i = 0; i < hs.length; i++) { if (self._bybCanAdd2(hs[i], cart)) return hs[i]; }
    return '';
  },
  _bybCanAdd2: function(handle, cart) {
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || !byb.variants[handle]) return false;
    if (!byb.caps || typeof byb.caps[handle] !== 'number') return true;
    var inCart = 0;
    ((cart || this._lastCart || {}).items || []).forEach(function(i) { if (i.handle === handle && !i.selling_plan_allocation) inCart += i.quantity; });
    return byb.caps[handle] >= inCart + 2;
  },
  bybOtherScent: function() {
    this._bybOtherOpen = !this._bybOtherOpen;
    // render paints where anything on its way lands as its last step, so one call shows the right cart.
    if (this._lastCart) this.render(this._lastCart);
  },
  // One add carrying the paid box AND the free box, both in the scent the button names (founder
  // 2026-10-09: no more choosing for him; it used to take scents he did not have yet, then the standing
  // order, which put Coastal Drift on the free box). Painted at once; addItems rolls a partial add back,
  // and the free box is proved before checkout (_bybVerifyTapped).
  addMoreBoxes: function(btn, handle) {
    var self = this, byb = window.DB_BYB;
    if (!this._bybAuto()) return;
    // One at a time: a second tap while the first is on its way would add two more (review 2 finding 5).
    if (this._instantOps.some(function(o) { return o.kind === 'more'; })) return;
    var cart = this._lastCart || { items: [] };
    // The scent the button names, or nothing: a cap that filled since the bar was painted repaints the
    // bar instead of quietly adding a scent he did not tap (review, 2026-10-09).
    if (!(handle && byb.variants[handle] && this._bybCanAdd2(handle, cart))) { if (this._lastCart) this.render(this._lastCart); return; }
    var h = handle, pick = [h, h];
    var tapProps = this._addBody(byb.variants[h], 1, null, { _byb_src: 'tap' }).properties || {};
    // Tracked even on a cart the drawer cannot predict: checkout waits for it and the bar shows it adding.
    var tok = this._instantStart([{ h: h, q: 2, props: tapProps }], 'more');
    this._bybIntent(1, h, 'tap');
    // A cart the drawer cannot predict paints the bar again from Shopify's cart: it shows the button
    // adding and disabled (see _paintOffer), whichever element the tap came from.
    if (!this._instantPaint() && this._lastCart) this._paintOffer(this._lastCart);
    var ids = {}, added = {};
    pick.forEach(function(x) {
      var v = String(byb.variants[x]);
      ids[v] = true;
      added[v] = (added[v] || 0) + 1;      // the paid box and the free one, same scent
    });
    var qtyOf = this._bybQtyOf(ids);
    var before = qtyOf(cart);
    this.addItems(pick.map(function(x) { return { id: byb.variants[x], quantity: 1, props: { _byb_src: 'tap' } }; }), function(ok) {
      // The button promised a free box. Prove it, or put the cart back the way it was. (A failed add was
      // already put back by addItems; there is nothing to prove.)
      if (ok !== false) self._bybVerifyTapped(before, qtyOf, added);
    }, { src: 'tap', handle: h, touched: true, instantTok: tok });
  },
  render: function(cart) {
    // A PREDICTED cart (see "INSTANT CART" below) paints exactly like a real one and does nothing else:
    // no coverage add or repair, no free box, no code re-apply, and it never becomes _lastCart, which
    // stays Shopify's own answer.
    var predicted = !!(cart && cart._predicted);
    // Shopify's latest answer, remembered FIRST. Render can hand off below (the coverage add, a plan
    // repair) before it paints, and the stepper numbers painted after every render read this: left on
    // the previous cart they showed 0 boxes for a beat on the first add (found 2026-10-09).
    // An older cart than the one already painted (a late answer, or a cart a handler kept from before) is
    // not painted over it: the newest cart is painted instead, so the paint and its free-box decision still happen.
    if (!predicted && cart && cart._dbSeq && DB_Cart._lastSeq && cart._dbSeq < DB_Cart._lastSeq && DB_Cart._lastCart) {
      cart = DB_Cart._lastCart;
      // Out of order means the lane let go of a request that later answered; which answer is newer is not
      // certain any more, so read Shopify's cart again (once per burst).
      if (!DB_Cart._staleResync) { DB_Cart._staleResync = setTimeout(function() { DB_Cart._staleResync = null; DB_Cart._resync(); }, 0); }
    }
    if (!predicted && cart && cart._dbSeq) DB_Cart._lastSeq = cart._dbSeq;
    if (!predicted && cart && cart.items) {
      DB_Cart._lastCart = cart;
      // How Shopify draws each scent's line (title, image, type), kept so a box the drawer paints ahead of
      // Shopify looks exactly like the one that replaces it (a predicted "Coastal Drift" turned into Shopify's
      // "COASTAL DRIFT" a second later, found 2026-10-09).
      var bybT = window.DB_BYB;
      if (bybT && bybT.variants) cart.items.forEach(function(it) {
        if (!it.selling_plan_allocation && bybT.variants[it.handle]) DB_Cart._lineLook[it.handle] = { product_title: it.product_title, title: it.title, featured_image: it.featured_image, product_type: it.product_type, variant_title: it.variant_title, url: it.url };
      });
    }
    // Ship Happens Coverage line (hidden $1.98 add-on). Detect it so item counts + the item list
    // exclude it, and so the cart auto-drops coverage if it ends up the only thing left.
    var protectLine = null;
    if (window.DB_SHIP_PROTECT) {
      for (var spi = 0; spi < cart.items.length; spi++) {
        if (String(cart.items[spi].variant_id) === window.DB_SHIP_PROTECT.variant) { protectLine = cart.items[spi]; break; }
      }
    }
    // Never more than one Ship Happens. Should a second ever land (two adds racing past the lane's give-up
    // on a stalled connection, an app), it is taken back to one before anything else happens.
    if (!predicted && protectLine && window.DB_SHIP_PROTECT && !this._protectTrimming) {
      var covLines = cart.items.filter(function(i) { return String(i.variant_id) === window.DB_SHIP_PROTECT.variant; });
      var extra = covLines.length > 1 ? covLines[1] : (protectLine.quantity > 1 ? protectLine : null);
      if (extra) {
        var selfT = this;
        this._protectTrimming = true;
        this._opArm('protTrim', function() { selfT._protectTrimming = false; });
        DB_Cart._cartFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: extra.key, quantity: covLines.length > 1 ? 0 : 1 }) })
          .then(function(r) { return r.json(); })
          .then(function(c) { selfT._protectTrimming = false; selfT._opDisarm('protTrim'); if (c && c.items) selfT.render(c); else selfT.refresh(); })
          .catch(function() { selfT._protectTrimming = false; selfT._opDisarm('protTrim'); selfT.refresh(); });
        return;
      }
    }
    var protectQty = protectLine ? protectLine.quantity : 0;
    var protectCents = protectLine ? protectLine.final_line_price : 0;
    // The mystery gift line is the cart's own doing, so it is not something he added: it stays out of the
    // count on the badge and out of "is there real product here" (a gift alone comes back off).
    var giftQty = 0;
    for (var gqi = 0; gqi < cart.items.length; gqi++) { if (this._giftIsLine(cart.items[gqi])) giftQty += cart.items[gqi].quantity; }
    var realCount = cart.item_count - protectQty - giftQty;
    // A gift the cart no longer qualifies for is on its way back off (the gift sync at the end of render), so it is
    // not drawn meanwhile. Shopify's answer to his minus still holds it, and drawing it put the row back for a moment
    // after the instant cart had already taken it away (measured 2026-10-13: gone, back 0.7s, gone).
    var giftWanted = !!(window.DB_GIFT && DB_Cart._giftWant(cart) && DB_Cart._giftBlocked !== DB_Cart._giftBlockKey(cart));
    // Product subtotal EXCLUDING coverage, so eligibility checks (checkout routing, upsells) look at
    // real product (a box), never at the $1.98 add-on. There is no free-shipping threshold anymore
    // (flat $5.99 on one-time orders); this subtotal only gates offer eligibility.
    var productSubtotal = cart.total_price - protectCents;
    if (!predicted && protectLine && realCount <= 0) {
      // Once: a repaint of the same cart while the drop is on its way must not send it again with a key
      // the first one already spent (a 400, then a refresh, found in review 2026-10-09).
      if (this._protectDropping) return;
      var self0 = this;
      this._protectDropping = true;
      this._opArm('protDrop', function() { self0._protectDropping = false; });
      DB_Cart._cartFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: protectLine.key, quantity: 0 }) })
        .then(function(r) { return r.json(); }).then(function(c) { self0._protectDropping = false; self0._opDisarm('protDrop'); self0.render(c); })
        .catch(function() { self0._protectDropping = false; self0._opDisarm('protDrop'); self0.refresh(); });
      return;
    }
    // Stale coverage plan repair (see _syncProtectPlan). Only a coverage line that ALREADY carries a
    // plan can be wrong in the expensive direction (a recurring charge nobody asked for), so the cheap
    // check gates the work. Painting resumes on the rebuilt cart, or on the original one if the repair
    // could not run, so the drawer always ends up rendered.
    if (!predicted && protectLine && protectLine.selling_plan_allocation) {
      var syncP = this._syncProtectPlan(cart);
      if (syncP) {
        var selfSp = this;
        syncP.then(function(c) { selfSp.render(c || cart); });
        return;
      }
    }
    // Pre-selected coverage (opt-out): if the cart has real product and no coverage line yet, auto-add it
    // once, UNLESS the visitor unchecked it earlier (persisted opt-out flag). The _protectAdding guard
    // prevents an add/re-render loop while the add is in flight. _protectSyncing does the same for a plan
    // repair: that repair removes the coverage line before re-adding it, and without this flag a render
    // landing in that gap sees "no coverage" and adds its own, leaving the shopper with coverage x2
    // (caught on a test theme, 2026-09-18: $28.95 instead of $26.97).
    // On the full /cart page the page controller (DB_CartPage) owns coverage instead, so the drawer
    // stands down there (window.DB_CART_PAGE_OWNS_PROTECT) to avoid two simultaneous adds doubling the line.
    if (!predicted && window.DB_SHIP_PROTECT && !protectLine && realCount > 0 && !this._protectOptedOut() && !this._protectAdding && !this._protectSyncing && !this._protectAddFailed && !window.DB_CART_PAGE_OWNS_PROTECT && !this._protectToggling) {
      var self0b = this;
      this._protectAdding = true;
      // A coverage add that never answers must not hold the free box and checkout for the life of the page.
      this._opArm('protAdd', function() { self0b._protectAdding = false; });
      this._addProtection(cart)
        // A 422 from /cart/add.js (coverage variant unsellable) RESOLVES the
        // fetch, so without the ok-check this branch re-entered forever and the
        // drawer never painted (showed "empty cart", checkout button hidden).
        // One-shot flag: fail once, then render the real cart without coverage.
        .then(function(r) { if (r && !r.ok) { self0b._protectAddFailed = true; } return DB_Cart._cartFetch('/cart.js'); })
        .then(function(r) { return r.json(); })
        .then(function(c) { self0b._protectAdding = false; self0b._opDisarm('protAdd'); self0b.render(c); })
        .catch(function(e) {
          self0b._protectAdding = false; self0b._opDisarm('protAdd'); self0b._protectAddFailed = true; console.error('Coverage auto-add error:', e);
          // The add may have landed before its answer was lost: paint the newest cart now, then read Shopify's.
          self0b.render(self0b._lastCart || cart); self0b.refresh();
        });
      return;
    }

    // Update badge
    var badge = document.getElementById('cart-badge');
    if (badge) {
      badge.textContent = realCount;
      badge.classList.toggle('visible', realCount > 0);
    }
    // Header count
    var hc = document.getElementById('cart-header-count');
    if (hc) hc.textContent = realCount;

    // A cart holding nothing but the gift is empty to him; the gift sync at the end of render takes it back off.
    var isEmpty = (cart.item_count - giftQty) === 0;
    var emptyEl = document.getElementById('cart-empty');
    var footerEl = document.getElementById('cart-footer');
    if (emptyEl) emptyEl.style.display = isEmpty ? 'block' : 'none';
    if (footerEl) footerEl.style.display = isEmpty ? 'none' : 'block';

    // Subtotal
    var sub = document.getElementById('cart-subtotal');
    if (sub) sub.textContent = '$' + (cart.total_price / 100).toFixed(2);

    // Shipping note
    var hasSubscription = cart.items.some(function(i) {
      return i.selling_plan_allocation !== null && i.selling_plan_allocation !== undefined;
    });
    var hasBundle = cart.items.some(function(i) {
      return i.handle === 'big-bastard-bundle';
    });

    // FREE-SHIPPING STATE. Shipping is free three ways: a subscription (automatic), the pre-launch
    // flag, or the SHIPSFREE code already applied to this session (earned via email signup).
    // freeShipApplied reads the REAL applied code from /cart.js, so a shopper who has already
    // claimed free shipping is shown "you're covered" instead of being re-pitched a $5.99 charge
    // they have already zeroed out. That mis-pitch was the reported bug: the cart only ever checked
    // subscription state and was blind to an applied SHIPSFREE.
    // Threshold reads the Liquid-injected bundle price, never a JS literal (the bundle-price trap).
    // Product subtotal EXCLUDES the coverage add-on, and /cart.js totals are already net of product
    // discounts, so a Build Your Bundle 3-box cart ($49.98 after the free box) clears it.
    // The free-ship codes' minimum (SHIPSONUS / SHIPSFREE / COLOGNESHIP) is $35 once Build Your Bundle is
    // live (founder 2026-09-17): Shopify checks it AFTER other discounts, so a $49.98 floor dropped free
    // shipping whenever a percent code stacked. DB_FREESHIP_MIN mirrors that minimum; the bundle price
    // stays the fallback while the switch is off.
    // SHIPPING V2 (window.DB_SHIP.v2, settings.ship_v2_live): an automatic discount frees every cart of
    // $35+ after discounts for EVERY customer, first order or not, so there is no code to look for.
    var shipV2 = !!(window.DB_SHIP && window.DB_SHIP.v2);
    var shipRate = '$' + (((window.DB_SHIP && window.DB_SHIP.rateCents) || 599) / 100).toFixed(2);
    var fsBundleLevel = productSubtotal >= (window.DB_FREESHIP_MIN || window.DB_BUNDLE_PRICE || 4998);
    // A free-ship code can sit in cart.discount_codes with applicable:true on a cart that is UNDER
    // its $49.98 minimum; Shopify only enforces the minimum at checkout. The drawer used to read
    // "Free shipping applied" on a one-box cart and the shopper met $5.99 at the payment step.
    // "Applied" now means: the code is here AND the cart clears the minimum it carries.
    var freeShipApplied = shipV2 ? fsBundleLevel : (this._freeShipApplied(cart) && fsBundleLevel);

    // RECOVER EARNED FREE SHIPPING. A shopper who already claimed (email captured -> earned
    // SHIPSFREE, which the popup promises is "automatically applied at checkout") but whose session
    // has NO code applied gets SHIPSFREE re-applied once, silently, then the cart re-renders with
    // it. Guards: fires only when discount_codes is EMPTY (never clobbers a creator/percent code),
    // only once per page load (_reapplyTried), and we only DISPLAY "claimed" after the re-fetch
    // confirms the code actually stuck (below) so an expired/used code just falls back to the offer.
    var _claimedBefore = false;
    try { _claimedBefore = localStorage.getItem('db_shipfree_claimed') === '1' || !!localStorage.getItem('db_last_lead'); } catch (e) {}
    if (!predicted && !shipV2 && !freeShipApplied && _claimedBefore && !hasSubscription
        && (!cart.discount_codes || cart.discount_codes.length === 0) && !this._reapplyTried) {
      this._reapplyTried = true;
      var selfR = this;
      DB_Cart._cartFetch('/discount/SHIPSFREE', { credentials: 'same-origin', cache: 'no-store' })
        .then(function() { return DB_Cart._cartFetch('/cart.js'); })
        .then(function(r) { return r.json(); })
        .then(function(c) { selfR.render(c); })
        .catch(function() { /* keep the normal offer state; no broken promise */ });
      return;
    }

    // FIRST-ORDER FREE SHIPPING (2026-08-24 ~10pm, founder decision "for all site visitors...
    // only for the first purchase"): theme.liquid silently applies SHIPSONUS (once per
    // customer, $49.98 min) for every visitor, so a first bundle order ships free with no
    // email and no typing. The drawer keys on the APPLIED code (freeShipApplied reads the
    // real cart state), so a repeat customer whose re-application Shopify refuses sees the
    // honest first-order line below and pays the flat rate. The email-for-free-shipping
    // pitch is retired for good (the code applies without an email now); the popup remains
    // the list-capture surface.
    // (fsBundleLevel is computed above, before freeShipApplied, so both read the same threshold.)

    var note = document.getElementById('cart-shipping-note');
    if (note && shipV2) note.textContent = (freeShipApplied
        ? '\u2713 Free shipping on 2+ boxes'
        : (hasSubscription
          ? '\u2713 Free shipping included with subscription'
          : '\uD83D\uDE9A ' + shipRate + ' shipping. Two or more boxes or a subscription ship free.'));
    else if (note) note.textContent = (freeShipApplied
        ? '✓ Free shipping applied'
        : (hasSubscription
          ? '✓ Free shipping included with subscription'
          : (fsBundleLevel
            ? '🚚 First order ships free, applied at checkout'
            : ((window.DB_BYB && window.DB_BYB.live)
              ? '🚚 $5.99 shipping. Three boxes or a subscription ship free.'
              : '🚚 Switch to a bundle or subscription for free shipping'))));

    // Shipping nudge (top of cart). Flat $5.99 on sub-threshold one-time orders; a first
    // $49.98+ order ships free via the auto-applied SHIPSONUS. The nudge surfaces whichever
    // truth applies HERE, before checkout, so nothing ambushes anyone at the payment step.
    var fsWrap = document.getElementById('cart-freeship');
    if (fsWrap) {
      var fsMsg = document.getElementById('cart-freeship-msg');
      var fsForm = document.getElementById('cart-freeship-form');
      var fsAlreadyFree = hasSubscription || freeShipApplied;
      // fsBundleLevel is computed above (shared with the subtotal note) so both surfaces read the
      // same threshold. The free-ship-for-email offer is only TRUE on a bundle-level cart; on a
      // single box we point at the bundle instead.
      // Show the inline email-capture form only when free shipping is actually claimable HERE: not
      // already free AND a bundle-level cart. Single-box carts hide the form; the message points them
      // to the bundle instead. Claiming happens in place via DB_Cart.claimFreeShipInline (no popup).
      // Email form permanently retired 2026-08-24: free shipping no longer needs an email
      // (SHIPSONUS auto-applies site-wide), so "your email makes it free" would be a false
      // pitch. The popup owns list capture.
      var fsShowForm = false;
      if (isEmpty) {
        fsWrap.style.display = 'none';
      } else if (shipV2 && fsAlreadyFree) {
        // Already free: no strip (founder 2026-10-28: "free shipping on this order is a bit repetitive and takes away space
        // for the savings math in the cart to be visible at first scroll"). The card's Shipping row and the line under
        // Checkout already say it; the strip only comes back while shipping still costs something.
        fsWrap.style.display = 'none';
      } else {
        fsWrap.style.display = 'block';
        fsWrap.classList.toggle('is-unlocked', fsAlreadyFree);
        if (fsMsg) {
          if (shipV2) {
            fsMsg.innerHTML = freeShipApplied
              ? '\u2713 Free shipping on this order. <small>Every order of 2+ boxes ships free.</small>'
              : (fsAlreadyFree
                ? '\u2713 Free shipping included'
                : 'Shipping is ' + shipRate + '. <small>Free on 2+ boxes or with a subscription.</small>');
          } else if (freeShipApplied) {
            fsMsg.innerHTML = '✓ Free shipping claimed. <small>Applied to this order, no shipping charged.</small>';
          } else if (fsAlreadyFree) {
            fsMsg.innerHTML = '✓ Free shipping included';
          } else if (fsBundleLevel) {
            fsMsg.innerHTML = 'First order ships free. <small>Applied automatically at checkout. Reorders pay $5.99 flat.</small>';
          } else {
            fsMsg.innerHTML = (window.DB_BYB && window.DB_BYB.live)
              ? 'Shipping is $5.99. <small>Free on any three boxes or with a subscription.</small>'
              : 'Shipping is $5.99. <small>Free on the Big Bastard Bundle or with a subscription.</small>';
          }
        }
        if (fsForm) fsForm.style.display = fsShowForm ? 'block' : 'none';
      }
    }

    // Drawer Checkout routing: straight to /checkout, always. The free-shipping-for-email capture now
    // lives INLINE at the top of this drawer (DB_Cart.claimFreeShipInline), so the old reroute that
    // sent uncaptured bundle carts to the /cart page for "one more pitch" is pure friction on the
    // highest-intent path and is retired. (The /cart page keeps its own capture for direct visitors.)
    window.DB_CHECKOUT_HREF = '/checkout';
    var _ckBtns = document.querySelectorAll('.cart-checkout-btn');
    for (var _cb = 0; _cb < _ckBtns.length; _cb++) { _ckBtns[_cb].setAttribute('href', window.DB_CHECKOUT_HREF); }
    // (The greyed "busy" checkout button that used to be set here is gone, for two reasons found by
    //  the other session on 2026-09-18. It never ran on the coverage-repair path at all: that repair
    //  hook returns from render ~180 lines above this, and it clears _protectSyncing before it
    //  resolves, so this line saw false both times. Measured: marked busy 0ms, never. And on the
    //  path where it DID run, a greyed checkout button reads as broken. The click is DEFERRED
    //  instead, in dbWireCheckout: the tap is honoured a beat later rather than discarded.)

    // Free-shipping upsell: every one-time cart pays the flat $5.99 rate, so every one-time cart
    // holding a swappable single box sees it. The subscription path makes shipping free; the
    // bundle path adds +1 free box.
    var unlock = document.getElementById('cart-unlock-upsell');
    var subOk = true;   // the painted cart (real or predicted) still holds one swappable box
    if (unlock) {
      var boxLine = null;
      for (var bi = 0; bi < cart.items.length; bi++) {
        var it = cart.items[bi];
        if (!it.selling_plan_allocation && window.DB_SUB_PLANS && window.DB_SUB_PLANS[it.handle]) { boxLine = it; break; }
      }
      // With Build Your Bundle live and 2+ one-time boxes in the cart, the free-box nudge owns the
      // slot (a subscription swap here would collapse the boxes to one; makeItSubscription is qty 1).
      var bybBoxesForUnlock = 0;
      if (window.DB_BYB && window.DB_BYB.live && window.DB_BYB.variants) {
        for (var ubi = 0; ubi < cart.items.length; ubi++) { var ubit = cart.items[ubi]; if (!ubit.selling_plan_allocation && window.DB_BYB.variants[ubit.handle]) bybBoxesForUnlock += ubit.quantity; }
      }
      var showUnlock = !isEmpty && !hasSubscription && !hasBundle && !!boxLine && bybBoxesForUnlock < 2;
      // The swap functions post quantity 1, so the offer only shows for a one-box line (D-04).
      showUnlock = showUnlock && boxLine.quantity === 1;
      subOk = showUnlock;
      if (!predicted) DB_Cart._unlockBox = showUnlock ? { key: boxLine.key, handle: boxLine.handle, quantity: boxLine.quantity } : null;
      unlock.style.display = showUnlock ? 'block' : 'none';
      // With Build Your Bundle live the free-box nudge owns the "+1 free box" pitch, so the
      // bundle-swap button here hides and only the subscription button remains.
      var unlockBundleBtn = unlock.querySelector('.cart-unlock-btn:not(.cart-unlock-btn--primary)');
      if (unlockBundleBtn) unlockBundleBtn.style.display = (window.DB_BYB && window.DB_BYB.live) ? 'none' : '';
    }

    // BUILD YOUR BUNDLE free-box nudge. Counts ONE-TIME scent boxes only (subscription lines and
    // the Big Bastard Bundle's own boxes never count toward the free third; the discount is
    // one-time only and scoped to the scent products, see the PRD). Shows at 1 or 2 boxes when
    // no line is discounted yet; at 3+ the FREE tag on the line does the talking.
    var freebox = document.getElementById('cart-freebox');
    // Remembered for the Build Your Bundle add guards (_bybCanAdd), which run between renders.
    if (!predicted) DB_Cart._lastCart = cart;
    // The pinned offer bar owns the free-box pitch while byb_auto_free is on. Un-block FIRST, so a
    // cart whose codes have changed since the block gets its offer back on this paint, not the next.
    // Hand the bar the REAL free-shipping answer that render just computed (subscription, the applied
    // code, or Shipping v2's threshold). The bar used to decide for itself from the threshold alone,
    // so it promised free shipping to a repeat customer who would meet the flat rate at checkout.
    DB_Cart._shipFree = freeShipApplied;
    if (!predicted) { DB_Cart._bybJudgeRemoval(cart); DB_Cart._bybUnblock(cart); }
    DB_Cart._paintOffer(cart);
    DB_Cart._paintSubStrip(subOk);
    if (freebox) {
      var byb = window.DB_BYB;
      var oneTimeBoxes = 0, anyFree = false;
      for (var fbi = 0; fbi < cart.items.length; fbi++) {
        var fbit = cart.items[fbi];
        if (!fbit.selling_plan_allocation && byb && byb.variants && byb.variants[fbit.handle]) {
          oneTimeBoxes += fbit.quantity;
          // A FREE box is a whole unit taken off the line. A percent code also lowers the line, and it
          // must not read as a free box (it used to hide this nudge for a code holder with one box).
          if (DB_Cart._bybFreeUnits(fbit) > 0) anyFree = true;
        }
      }
      var showFree = !!(byb && byb.live) && !isEmpty && oneTimeBoxes > 0 && oneTimeBoxes < 3 && !anyFree;
      // Each chip shows only while its scent can take one more one-time box (stock and the member
      // reserve floor, window.DB_BYB.caps from snippets/byb-cap); no chip left means no nudge.
      var anyChip = false;
      freebox.querySelectorAll('.cart-freebox-chip[data-handle]').forEach(function(chip) {
        var ok = DB_Cart._bybCanAdd(chip.getAttribute('data-handle'), cart);
        chip.style.display = ok ? '' : 'none';
        if (ok) anyChip = true;
      });
      // The old nudge stands down when the pinned offer bar is on, so there is ONE offer in the cart.
      showFree = showFree && anyChip && !DB_Cart._bybAuto();
      freebox.style.display = showFree ? 'block' : 'none';
      if (showFree) {
        var fbHead = document.getElementById('cart-freebox-head');
        var fbMsg = document.getElementById('cart-freebox-msg');
        var bpr = '$' + ((window.DB_BUNDLE_PRICE || 0) / 100).toFixed(2);
        if (oneTimeBoxes === 2) {
          if (fbHead) fbHead.textContent = 'Your free box is waiting';
          if (fbMsg) fbMsg.textContent = 'Buy 2, get 1 free + free shipping. Pick the third box, it rings up free and the ' + bpr + ' order ships free.';
        } else {
          if (fbHead) fbHead.textContent = 'Buy 2, get 1 free + free shipping';
          if (fbMsg) fbMsg.textContent = 'Add two more boxes, any scents. The third is free and the order ships free. Three boxes, ' + bpr + '.';
        }
      }
    }

    // Multi-scent -> bundle nudge. Fires when the cart holds 2+ DIFFERENT one-time scent singles
    // and no bundle: the multi-single buyer paying singles prices for what the Big Bastard Bundle
    // sells cheaper. Offers to swap all those singles for the one bundle. Bundle price is read live
    // from window.DB_BUNDLE_PRICE (Liquid-injected), never a JS literal (the bundle-price trap).
    var multibundle = document.getElementById('cart-multibundle');
    if (multibundle) {
      var scentLines = [], scentHandles = {};
      for (var msi = 0; msi < cart.items.length; msi++) {
        var msit = cart.items[msi];
        if (!msit.selling_plan_allocation && window.DB_SUB_PLANS && window.DB_SUB_PLANS[msit.handle]) {
          scentLines.push(msit); scentHandles[msit.handle] = true;
        }
      }
      var distinctScents = Object.keys(scentHandles).length;
      // Stands down when Build Your Bundle is live: two scents already cost the bundle price for two boxes, the free-box nudge below makes the honest pitch.
      var scentBoxCount = scentLines.reduce(function(n, l) { return n + l.quantity; }, 0);
      var showMulti = !isEmpty && !hasBundle && distinctScents >= 2 && scentBoxCount <= 3 && !(window.DB_BYB && window.DB_BYB.live);
      // Carry the HANDLE as well as the key. The key goes stale the moment anything writes to the
      // cart, and this list is consumed after an add; the handle does not go stale.
      if (!predicted) DB_Cart._multiScentKeys = showMulti ? scentLines.map(function(l) { return { key: l.key, handle: l.handle, quantity: l.quantity }; }) : null;
      multibundle.style.display = showMulti ? 'block' : 'none';
      if (showMulti) {
        var scentSubtotal = scentLines.reduce(function(s, l) { return s + l.final_line_price; }, 0);
        var bp = window.DB_BUNDLE_PRICE || 0;
        var save = scentSubtotal - bp;
        var mbHead = document.getElementById('cart-multibundle-head');
        var mbMsg = document.getElementById('cart-multibundle-msg');
        var mbSub = document.getElementById('cart-multibundle-sub');
        var bpStr = '$' + (bp / 100).toFixed(2);
        if (save > 0) {
          var saveStr = '$' + (save / 100).toFixed(2);
          if (mbHead) mbHead.textContent = 'Get all three. Pay less.';
          if (mbMsg) mbMsg.innerHTML = "You've got " + distinctScents + " scents in your cart. The Big Bastard Bundle is all three for " + bpStr + ", so you'd save <strong>" + saveStr + "</strong>.";
          if (mbSub) mbSub.textContent = 'Save ' + saveStr + ', all 3 scents';
        } else {
          if (mbHead) mbHead.textContent = 'Your third scent is free.';
          if (mbMsg) mbMsg.innerHTML = "You've got " + distinctScents + " scents. Make it the Big Bastard Bundle for the same " + bpStr + " and your third scent is free. 90 sheets, all three.";
          if (mbSub) mbSub.textContent = 'Same price, +1 free box';
        }
      }
    }

    // Merch upsell: hide pieces already in the cart, show block only for non-empty carts
    var merchUpsell = document.getElementById('cart-merch-upsell');
    if (merchUpsell) {
      var cartHandles = cart.items.map(function(i) { return i.handle; });
      var visibleMerch = 0;
      merchUpsell.querySelectorAll('.cart-merch-item').forEach(function(el) {
        var inCart = cartHandles.indexOf(el.getAttribute('data-handle')) !== -1;
        el.style.display = inCart ? 'none' : 'flex';
        if (!inCart) visibleMerch++;
      });
      merchUpsell.style.display = (!isEmpty && visibleMerch > 0) ? 'block' : 'none';
    }

    // Ship Happens Coverage toggle: reflect current opt-in state, show only for non-empty carts.
    // If the cart has a subscription box AND a matching-frequency coverage plan exists, coverage will
    // recur with the box, so disclose "$1.98 per order"; otherwise it's a one-time $1.98.
    var protectWrap = document.getElementById('cart-protect');
    if (protectWrap) {
      var protectCheck = document.getElementById('cart-protect-check');
      // His tick on its way wins; coverage the cart is adding by itself shows as on (it was unticking for a
      // second while that add ran, review 2).
      if (protectCheck) protectCheck.checked = (DB_Cart._protectWant !== undefined) ? !!DB_Cart._protectWant : (!!protectLine || !!DB_Cart._protectAdding);
      // On the full /cart page the page controller (DB_CartPage) owns coverage, so hide the drawer's
      // redundant coverage control there. Two independent, unsynced coverage toggles on one document
      // let a drawer toggle leave the /cart page's checkbox + subtotal stale vs the real cart.
      protectWrap.style.display = (isEmpty || window.DB_CART_PAGE_OWNS_PROTECT) ? 'none' : 'flex';
      var coverageRecurs = false;
      if (window.DB_SHIP_PROTECT_PLANS) {
        for (var ci = 0; ci < cart.items.length; ci++) {
          var it2 = cart.items[ci];
          var isCov2 = window.DB_SHIP_PROTECT && String(it2.variant_id) === window.DB_SHIP_PROTECT.variant;
          if (it2.selling_plan_allocation && !isCov2) {
            var nm2 = (it2.selling_plan_allocation.selling_plan && it2.selling_plan_allocation.selling_plan.name) || '';
            var wk2 = nm2.match(/\d+/);
            if (wk2 && window.DB_SHIP_PROTECT_PLANS[wk2[0]]) { coverageRecurs = true; break; }
          }
        }
      }
      var priceEl = document.getElementById('cart-protect-price');
      if (priceEl && window.DB_SHIP_PROTECT) priceEl.textContent = window.DB_SHIP_PROTECT.price + (coverageRecurs ? ' per order' : '');
    }

    // Items (exclude the hidden coverage line; it's represented by the toggle, not an item row)
    var container = document.getElementById('cart-items');
    if (!container) return;
    // BUILD YOUR BUNDLE GROUP CARD. Shopify splits a scent line whenever the Buy 2 Get 1 discount
    // covers only part of it (3 on one line become 2 + 1 free) and keeps lines apart when their
    // attribution properties differ; it never re-merges them. So when the cart holds 3+ one-time
    // scent boxes the drawer shows ONE bundle card (struck original, final price, FREE count, one
    // row per scent with its own steppers) and hides the raw lines. The steppers act on the
    // underlying lines through DB_Cart.bybStep. Below 3 boxes the lines render as usual.
    var bybGroupKeys = {}, bybGroupHtml = '';
    if (window.DB_BYB && window.DB_BYB.live && window.DB_BYB.variants) {
      var gLines = cart.items.filter(function(i) { return !i.selling_plan_allocation && window.DB_BYB.variants[i.handle]; });
      var gBoxes = gLines.reduce(function(n, l) { return n + l.quantity; }, 0);
      if (gBoxes >= 3) {
        var gOrig = 0, gFinal = 0, perScent = {}, freeG = 0, sOrig = {}, sFinal = {}, sFree = {};
        // FREE count = whole units the discount took off, summed per line (DB_Cart._bybFreeUnits). Dividing
        // the card's total saving by one box price read a 25% code on six boxes as "2 FREE".
        gLines.forEach(function(l) {
          var u = DB_Cart._bybFreeUnits(l);
          bybGroupKeys[l.key] = true; gOrig += l.original_line_price; gFinal += l.final_line_price; freeG += u;
          perScent[l.handle] = (perScent[l.handle] || 0) + l.quantity;
          sOrig[l.handle] = (sOrig[l.handle] || 0) + l.original_line_price;
          sFinal[l.handle] = (sFinal[l.handle] || 0) + l.final_line_price;
          sFree[l.handle] = (sFree[l.handle] || 0) + u;
        });
        var money = function(c) { return '$' + (c / 100).toFixed(2); };
        var gIsBundle = gLines.every(function(l) { return DB_Cart._bybIsBundleTagged(l); }) &&
          window.DB_BYB.handles.every(function(h) { return perScent[h] && perScent[h] === perScent[window.DB_BYB.handles[0]]; });
        // RECEIPT (founder pick B, 2026-09-17): one row per scent with its own price, the free box
        // struck through to $0.00, then shipping, any order-level code, and the total saved. Every
        // number is read from /cart.js; the shipping row only claims FREE when the free-ship code is
        // really applied (freeShipApplied, computed above) and only then counts toward the saving.
        // Which scents are actually in the cart. Used for the rows AND for the swap control, which
        // stands down entirely once all three are here (founder, 2026-09-19).
        var presentScents = window.DB_BYB.handles.filter(function(h) { return perScent[h]; });
        // Clear any open panel the moment the control stands down, rather than only hiding it. The
        // open state is a string that deliberately survives renders, so hiding without clearing
        // leaves a panel he never opened waiting to reappear if a scent later leaves the cart.
        if (presentScents.length >= window.DB_BYB.handles.length) DB_Cart._bybSwapOpen = '';
        var rows = presentScents.map(function(h) {
          var ln = gLines.filter(function(l) { return l.handle === h; })[0];
          var img = ln && ln.featured_image ? ln.featured_image.url + (ln.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          var off = sOrig[h] > sFinal[h];
          var price = off
            ? '<span class="cart-item-orig">' + money(sOrig[h]) + '</span> <span class="cart-rc-final">' + money(sFinal[h]) + '</span>'
            : money(sFinal[h]);
          return '<div class="cart-byb-row' + (sFree[h] ? ' has-free' : '') + '">' +
            (img ? '<img class="cart-byb-row-img" src="' + img + '" alt="" width="44" height="44" loading="lazy">' : '') +
            '<span class="cart-byb-row-main">' +
              '<span class="cart-byb-row-name">' + (window.DB_BYB.names[h] || h) + (sFree[h] ? ' <span class="cart-rc-gift">\uD83C\uDF81 ' + (sFree[h] > 1 ? sFree[h] + ' ' : '') + 'FREE</span>' : '') + '</span>' +
              '<span class="cart-rc-price">' + price + '</span>' +
              (sFree[h] && perScent[h] > sFree[h] ? '<span class="cart-rc-note">' + (perScent[h] - sFree[h]) + ' paid + ' + sFree[h] + ' free</span>' : '') +
              DB_Cart._bybSwapHtml(h, perScent[h] - (sFree[h] || 0), cart, presentScents.length) +
            '</span>' +
            '<span class="cart-qty cart-byb-qty"><button class="cart-qty-btn" onclick="DB_Cart.bybStep(\'' + h + '\',-1)" aria-label="One fewer">\u2212</button><span class="cart-qty-num" data-bf="' + h + '">' + perScent[h] + '</span><button class="cart-qty-btn" onclick="DB_Cart.bybStep(\'' + h + '\',1)" aria-label="One more"' + (DB_Cart._bybCanAdd(h, cart) ? '' : ' disabled') + '>+</button></span>' +
          '</div>';
        }).join('');
        var shipCents = window.DB_BYB.shipCents || 599;
        var extra = '';
        if (freeShipApplied) {
          extra += '<div class="cart-rc-line"><span>Shipping</span><span><span class="cart-item-orig">' + money(shipCents) + '</span> <span class="cart-rc-final">FREE</span></span></div>';
        } else if (hasSubscription) {
          extra += '';
        } else {
          extra += '<div class="cart-rc-line"><span>Shipping</span><span>' + (fsBundleLevel ? 'Free on a first order' : money(shipCents)) + '</span></div>';
        }
        var codeOff = 0;
        (cart.cart_level_discount_applications || []).forEach(function(d) {
          var amt = d.total_allocated_amount || 0;
          if (amt > 0) { codeOff += amt; extra += '<div class="cart-rc-line"><span>' + String(d.title || 'Discount').replace(/[<>&"]/g, '') + '</span><span class="cart-rc-final">\u2212' + money(amt) + '</span></div>'; }
        });
        // The mystery gift rides in this card as its own row, and its $9.99 counts toward the saving.
        var giftRow = '', giftSaved = 0;
        cart.items.forEach(function(gl) {
          if (giftRow || !DB_Cart._giftIsLine(gl)) return;
          bybGroupKeys[gl.key] = true;
          if (!giftWanted) return;   // on its way back off: no row, and its $9.99 is not counted as saved
          giftRow = DB_Cart._giftRowHtml(gl);
          giftSaved = Math.max(0, (gl.original_line_price || 0) - (gl.final_line_price || 0));
        });
        var saved = (gOrig - gFinal) + codeOff + (freeShipApplied ? shipCents : 0) + giftSaved;
        bybGroupHtml = '<div class="cart-item cart-byb cart-rc">' +
          '<div class="cart-item-info">' +
            // The card keeps the Big Bastard Bundle name only while that is exactly what the cart holds:
            // every box carries the bundle tag and the three scents are in equal number. One loose box
            // on top and it is honestly "Your Bundle" again.
            '<div class="cart-item-name">' + (gIsBundle ? 'Big Bastard Bundle' : 'Your Bundle') + ' <span class="cart-byb-count">' + gBoxes + ' boxes</span>' +
              // The saving rides up here when the card's own YOU'RE SAVING row is out of sight (founder 2026-10-07:
              // "the savings get harder to see right when he's spending more"; polish call P1 "b": only when that row
              // is cut off). Rendered whenever there is a saving; _fitSavingPill, at the end of render, hides it while
              // the whole card fits, so it never repeats a number that is already on screen.
              (saved > 0 ? ' <span class="cart-byb-saving" style="display:inline-block;margin-left:4px;font-family:\'Oswald\',sans-serif;font-size:10.5px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#fff;background:#2a6b2a;border-radius:20px;padding:3px 8px;vertical-align:2px;">Saving ' + money(saved) + '</span>' : '') +
            '</div>' +
            '<div class="cart-item-variant">' + (gBoxes * 30) + ' sheets' + (gIsBundle ? ' \u00b7 all 3 scents' : '') + '</div>' +
            '<div class="cart-byb-rows">' + rows + giftRow + '</div>' +
            extra +
            // The saving bar only when Shopify actually took something off: a cart the discount did not
            // reach (discount inactive, misconfigured) must not promise a free box it will not get.
            (saved > 0 ? '<div class="cart-rc-saved"><span>You\'re saving</span><span>' + money(saved) + '</span></div>' : '') +
            '<button class="cart-item-remove" onclick="DB_Cart.bybRemoveAll()">Remove bundle</button>' +
          '</div>' +
        '</div>';
      }
    }
    // BIG BASTARD BUNDLE RECEIPT (founder 2026-09-17: "show the bundle like it shows on the 1+1+1").
    // The native bundle is one line in /cart.js, so the drawer draws it as its three scent boxes at the
    // real single-box price (DB_BYB.prices, from the products), Alaskan Alpine struck to $0.00 as the free
    // box, then shipping, any code, and the saving. Only when the numbers reconcile: the line's original
    // price must equal two paid boxes, otherwise the plain line renders. One line only, one-time only.
    if (window.DB_BYB && window.DB_BYB.live && window.DB_BYB.prices) {
      var bbLines = cart.items.filter(function(i) { return i.handle === 'big-bastard-bundle' && !i.selling_plan_allocation; });
      var bbP = window.DB_BYB.prices, bbHs = window.DB_BYB.handles;
      var bbBox = bbP[bbHs[0]];
      var bbSame = bbHs.every(function(h) { return bbP[h] === bbBox; });
      if (bbLines.length === 1 && bbBox > 0 && bbSame && bbLines[0].original_line_price === 2 * bbBox * bbLines[0].quantity) {
        var bb = bbLines[0], bq = bb.quantity;
        var bMoney = function(c) { return '$' + (c / 100).toFixed(2); };
        var bImgs = window.DB_BYB.images || {};
        var bRows = bbHs.map(function(h, i) {
          // The free box is the LAST scent: turning the bundle into loose boxes adds Coastal, Amber, Alaskan in that
          // order and Buy 2 Get 1 takes the last-added box, so the FREE tag stays on the same row after a tap.
          var free = i === bbHs.length - 1;
          return '<div class="cart-byb-row' + (free ? ' has-free' : '') + '">' +
            (bImgs[h] ? '<img class="cart-byb-row-img" src="' + bImgs[h] + '" alt="" width="44" height="44" loading="lazy">' : '') +
            '<span class="cart-byb-row-main">' +
              '<span class="cart-byb-row-name">' + (window.DB_BYB.names[h] || h) + (free ? ' <span class="cart-rc-gift">🎁 ' + (bq > 1 ? bq + ' ' : '') + 'FREE</span>' : '') + '</span>' +
              '<span class="cart-rc-price">' + (free ? '<span class="cart-item-orig">' + bMoney(bbBox * bq) + '</span> <span class="cart-rc-final">$0.00</span>' : bMoney(bbBox * bq)) + '</span>' +
            '</span>' +
            '<span class="cart-qty cart-byb-qty"><button class="cart-qty-btn" onclick="DB_Cart.bbStep(\'' + h + '\',-1)" aria-label="One fewer">\u2212</button><span class="cart-qty-num">' + bq + '</span><button class="cart-qty-btn" onclick="DB_Cart.bbStep(\'' + h + '\',1)" aria-label="One more"' + (DB_Cart._bbCanAdd(h, cart, bq, 1) ? '' : ' disabled') + '>+</button></span>' +
          '</div>';
        }).join('');
        var bExtra = '';
        (bb.line_level_discount_allocations || []).forEach(function(a) {
          var amt = a.amount || 0;
          var ttl = (a.discount_application && a.discount_application.title) || 'Discount';
          if (amt > 0) bExtra += '<div class="cart-rc-line"><span>' + String(ttl).replace(/[<>&"]/g, '') + '</span><span class="cart-rc-final">−' + bMoney(amt) + '</span></div>';
        });
        var bShip = window.DB_BYB.shipCents || 599, bCodeOff = 0;
        // The Build Your Bundle card above already carries shipping and order codes; never twice.
        if (!bybGroupHtml) {
          if (freeShipApplied) {
            bExtra += '<div class="cart-rc-line"><span>Shipping</span><span><span class="cart-item-orig">' + bMoney(bShip) + '</span> <span class="cart-rc-final">FREE</span></span></div>';
          } else if (!hasSubscription) {
            bExtra += '<div class="cart-rc-line"><span>Shipping</span><span>' + (fsBundleLevel ? 'Free on a first order' : bMoney(bShip)) + '</span></div>';
          }
          (cart.cart_level_discount_applications || []).forEach(function(d) {
            var amt = d.total_allocated_amount || 0;
            if (amt > 0) { bCodeOff += amt; bExtra += '<div class="cart-rc-line"><span>' + String(d.title || 'Discount').replace(/[<>&"]/g, '') + '</span><span class="cart-rc-final">−' + bMoney(amt) + '</span></div>'; }
          });
        }
        var bSaved = (3 * bbBox * bq - bb.final_line_price) + bCodeOff + (!bybGroupHtml && freeShipApplied ? bShip : 0);
        // The mystery gift rides in this card too, as the same slim row as in the box-by-box card, and its value counts
        // toward the saving. It used to sit under the card as a full-size line, below the fold on a phone (founder
        // 2026-10-28: "more subtle... it cant take up so much space"). Skipped when the card above already holds it.
        var bGiftRow = '';
        cart.items.forEach(function(gl) {
          if (bGiftRow || !DB_Cart._giftIsLine(gl) || bybGroupKeys[gl.key]) return;
          bybGroupKeys[gl.key] = true;
          if (!giftWanted) return;   // on its way back off: no row, and its value is not counted as saved
          bGiftRow = DB_Cart._giftRowHtml(gl);
          bSaved += Math.max(0, (gl.original_line_price || 0) - (gl.final_line_price || 0));
        });
        bybGroupKeys[bb.key] = true;
        bybGroupHtml += '<div class="cart-item cart-byb cart-rc cart-bb">' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">Big Bastard Bundle <span class="cart-byb-count">' + (3 * bq) + ' boxes</span></div>' +
            '<div class="cart-item-variant">' + (90 * bq) + ' sheets · all 3 scents</div>' +
            '<div class="cart-byb-rows">' + bRows + bGiftRow + '</div>' +
            bExtra +
            (bSaved > 0 ? '<div class="cart-rc-saved"><span>You\'re saving</span><span>' + bMoney(bSaved) + '</span></div>' : '') +
            '<button class="cart-item-remove" onclick="DB_Cart.updateQty(\'' + bb.key + '\',0)">Remove bundle</button>' +
          '</div>' +
        '</div>';
      }
    }
    // Shopify lists the newest line first, and the gift is always added after his boxes; it reads under them.
    var listItems = cart.items.filter(function(item) { return !DB_Cart._giftIsLine(item); })
      .concat(cart.items.filter(function(item) { return DB_Cart._giftIsLine(item); }));
    // Built as a string and only written when it CHANGED (2026-10-09). The instant cart repaints often, and
    // rewriting identical rows swapped the buttons out from under a finger mid-tap.
    var itemsHtml = bybGroupHtml + listItems.filter(function(item) {
      if (bybGroupKeys[item.key]) return false;
      // A gift with no box beside it, or on a cart that no longer qualifies, is on its way back off (the gift sync
      // below); don't paint it meanwhile.
      if (DB_Cart._giftIsLine(item) && (realCount <= 0 || !giftWanted)) return false;
      return !(window.DB_SHIP_PROTECT && String(item.variant_id) === window.DB_SHIP_PROTECT.variant);
    }).map(function(item, idx) {
      // The Hoodie Drop's free box: its own row, no stepper (see _hdRowHtml).
      if (item.handle === DB_Cart._HD_BOX) return DB_Cart._hdRowHtml(item);
      // The mystery gift outside a bundle card (the laundry game's prize on a 1- or 2-box order): its own
      // small row, $9.99 struck to $0.00, no stepper, because the cart owns this line.
      if (DB_Cart._giftIsLine(item)) {
        // One slim line (founder 2026-10-28: "more subtle"), not a full product row.
        var gOrigC = item.original_line_price || DB_Gift.value(), gFinC = item.final_line_price || 0;
        return '<div class="cart-gift-item cart-gift-slim">' +
          DB_Gift.icon('cart-gift-slim__g') +
          '<span class="cart-gift-slim__t">Mystery gift, in the box</span>' +
          '<span class="cart-gift-slim__p">' + (gOrigC > gFinC ? '<span class="cart-item-orig">' + DB_Gift.money(gOrigC) + '</span> ' : '') + (gFinC > 0 ? DB_Gift.money(gFinC) : '<span class="cart-item-free">FREE</span>') + '</span>' +
        '</div>';
      }
      var isSub = item.selling_plan_allocation !== null && item.selling_plan_allocation !== undefined;
      var imgSrc = item.featured_image ? item.featured_image.url + (item.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var linePrice = '$' + (item.final_line_price / 100).toFixed(2);
      // BUILD YOUR BUNDLE: a line the Buy 2 Get 1 discount touched shows the original struck
      // through and a FREE tag (how many boxes the allocation covers, from the unit price). Read
      // straight from /cart.js (original vs final line price, line_level_discount_allocations),
      // never computed from a literal. Any other product discount renders the same honest way.
      // Gated on the switch so the live drawer is unchanged until Build Your Bundle is turned on.
      var priceHtml = linePrice;
      if (window.DB_BYB && window.DB_BYB.live && item.original_line_price > item.final_line_price) {
        var offCents = item.original_line_price - item.final_line_price;
        // The FREE tag comes from DB_Cart._bybFreeUnits, which only counts the free-box discount, so a
        // percent code that happens to land on a round number renders as the money it took off and
        // never as a free box (founder 2026-09-18: never tag a box Shopify did not discount).
        var freeUnits = DB_Cart._bybFreeUnits(item);
        var tag = freeUnits >= 1 ? (freeUnits + ' FREE') : ('-$' + (offCents / 100).toFixed(2));
        priceHtml = '<span class="cart-item-orig">$' + (item.original_line_price / 100).toFixed(2) + '</span> ' + linePrice + ' <span class="cart-item-free">' + tag + '</span>';
      }
      return '<div class="cart-item">' +
        /* alt="" : the product name is the very next element, so alt text here just says it twice.
           The receipt rows already do this correctly. */
        '<img class="cart-item-img" src="' + imgSrc + '" alt="" width="100" height="100" loading="lazy">' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + item.product_title + '</div>' +
          (isSub ? '<span class="cart-item-sub-badge">Subscribe &amp; Save</span>' : '') +
          '<div class="cart-item-variant">' + (item.product_title && item.product_title.toLowerCase().indexOf('bundle') !== -1 ? '90 Sheets · All 3 Scents' : (item.product_type === 'Detergent Sheets' ? '~2 Month Supply · 30 Sheets' : ((item.variant_title && item.variant_title !== 'Default Title') ? DB_Cart._variantLabel(item) : ''))) + '</div>' +
          '<div class="cart-item-price">' + priceHtml + '</div>' +
          '<div class="cart-qty">' +
            /* The glyph is U+2212, which a screen reader announces as "minus sign, button" or as
               nothing at all. For the free box especially, an unlabelled glyph is not an obviously
               removable control, which is what the disclosure above promises it is. */
            '<button class="cart-qty-btn" aria-label="One fewer ' + item.product_title + '" onclick="DB_Cart.qtyStep(\'' + item.key + '\',-1)">−</button>' +
            '<span class="cart-qty-num" data-bfk="' + item.key + '">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" aria-label="One more ' + item.product_title + '" onclick="DB_Cart.qtyStep(\'' + item.key + '\',1)">+</button>' +
          '</div>' +
          /* No "Remove" link (founder 2026-09-11): the minus button already removes the line at quantity 1 (updateQty to 0). */
        '</div>' +
      '</div>';
    }).join('');
    // No email yet: the gift waits in a locked row at the TOP of the cart, one tap from the unlock (under the boxes it
    // sat below the fold, behind the drawer's footer, on a 3-box cart on an iPhone 13).
    if (realCount > 0 && DB_Cart._giftLocked(cart)) itemsHtml = DB_Cart._giftLockedRowHtml() + itemsHtml;
    if (container.__dbHtml !== itemsHtml) { container.innerHTML = itemsHtml; container.__dbHtml = itemsHtml; }

    // The Saving pill shows only while the YOU'RE SAVING row is cut off (see _fitSavingPill). Measured on the cart just painted.
    DB_Cart._fitSavingPill();
    if (predicted) return;
    // LAST thing render does: with the painted cart in hand, add the free box if this cart is
    // exactly one box short of one and the shopper just did something. See _bybReconcile.
    DB_Cart._bybReconcile(cart);
    // Then the mystery gift: on when the cart qualifies, off when it doesn't. It stands aside while the
    // free-box add above is in flight and runs again on the render that add finishes with.
    DB_Cart._giftReconcile(cart);
    // Then the Hoodie Drop: never more free boxes than hoodies (see _hdReconcile).
    DB_Cart._hdReconcile(cart);
    // Shopify's answer is on screen. If taps, a free box or a page add are still on their way, paint
    // where they land on top of it, so the screen never steps back to an in-between cart.
    if (DB_Cart._instantWanted()) DB_Cart._instantPaint();
  },
  // THE SAVING PILL, ONLY WHEN THE SAVING IS OUT OF SIGHT (founder 2026-10-07, polish call P1 "b"). The pill and the card's
  // own YOU'RE SAVING row both sit in .cart-body, the drawer's one scroller, so the pill only repeats the row when the whole
  // card fits. Measured at scrollTop 0 with the pill taken out first: taking it out only makes the card shorter, so it can
  // never be what makes the row fit, and showing it only makes the card taller, so a shown pill stays needed (no flicker).
  // Measured 2026-10-07: 390x664 iPhone at 3 boxes = row in view, no pill; 360x640 Android at 3, a 1280x800 laptop at 3 to 4,
  // and any phone at 4 to 5 boxes = row cut off, pill. Runs at the end of every render (opening the drawer renders) and on resize.
  _fitSavingPill: function() {
    var pill = document.querySelector('#cart-items .cart-byb-saving');
    if (pill) {
      var body = pill.closest('.cart-body'), card = pill.closest('.cart-byb'), row = card && card.querySelector('.cart-rc-saved');
      if (body && row) {
        pill.style.display = 'none';
        var top = body.getBoundingClientRect().top - body.scrollTop;
        pill.style.display = (row.getBoundingClientRect().bottom - top) <= body.clientHeight ? 'none' : 'inline-block';
      }
    }
    if (!this._fitBound) {
      this._fitBound = true;
      var self = this, t = null;
      window.addEventListener('resize', function() { clearTimeout(t); t = setTimeout(function() { self._fitSavingPill(); }, 150); });
    }
  },
  // Swap ONE box from one scent to another, as a single job: remove one of `from`, add one of `to`.
  //
  // THE POINT IS THAT THE BOX COUNT NEVER CHANGES. Doing this with the steppers instead walks the
  // cart 3 -> 2 -> 3, and on the way down a removal that lands one short sets the opt-out, while the
  // way back up arms and fires an auto-add. The shopper wanted a different scent, not a negotiation
  // about the free box. A swap touches neither: it never calls _bybTouch, so it cannot arm the
  // auto-add and cannot write an opt-out.
  //
  // Remove BEFORE add, with an add-back if the add fails. The other order (add then remove) leaves
  // the shopper holding an extra box they are charged for when the remove fails; this order leaves
  // them briefly short inside a held lane, and puts it straight back.
  //
  // The removal prefers an UNMARKED line: never hand back the free box while a paid box of that
  // scent is still sitting there.
  // THE SWAP CONTROL (founder pick B, 2026-09-19). A "Swap scent" link under the scent name that
  // opens a small panel of the other two scents.
  //
  // WHY A LINK AND NOT ALWAYS-ON CHIPS. The drawer's only scroller, .cart-body, is 274px tall at
  // 390x844 and 185px at 393x660, the rest being the pinned offer bar, the coverage line, subtotal,
  // checkout and the trust and payment strips. Measured on the real store 2026-09-19. Always-on
  // chips cost 50px of that permanently and push YOU'RE SAVING off screen; this costs 9px until he
  // asks for it. Discoverability is a wording problem and can be fixed without touching layout.
  //
  // ONLY ON A ROW WITH A PAID BOX. bybSwap deliberately prefers an unmarked line so it never hands
  // back the free box while a paid box of that scent is still there, so offering the control on a
  // free-only row would promise something the mechanic refuses.
  _bybSwapHtml: function(handle, paid, cart, distinctScents) {
    var byb = window.DB_BYB;
    if (!byb || !byb.handles || paid < 1) return '';
    // ALL THREE SCENTS ALREADY IN THE CART: NO SWAP (founder, 2026-09-19). The control exists to go
    // and get a scent he does NOT have without disturbing the free box. Once all three are here
    // there is nothing to go and get, so every row offering a swap is offering a rearrangement
    // nobody asked for. This is the state the first proof shot landed in: one swap put all three in
    // the cart and both paid rows were still pitching another.
    //
    // Recomputed from the cart on every render, never latched, so it comes straight back if a scent
    // leaves.
    if (typeof distinctScents === 'number' && distinctScents >= byb.handles.length) return '';
    var name = function(h) { return (byb.names && byb.names[h]) || h; };
    if (this._bybSwapOpen !== handle) {
      return '<button type="button" class="cart-byb-swap-link" aria-expanded="false"' +
        ' onclick="DB_Cart.bybSwapOpen(\'' + handle + '\')">Swap scent</button>';
    }
    var self = this;
    var chips = byb.handles.filter(function(d) { return d !== handle; }).map(function(d) {
      // DISABLED, not offered and then refused. bybSwap turns a capped destination away silently,
      // and a chip that looks tappable and does nothing is the exact shape this project has called
      // out twice as worse than no control at all.
      var can = self._bybCanAdd(d, cart);
      return '<button type="button" class="cart-byb-swap-chip"' + (can ? '' : ' disabled') +
        ' onclick="DB_Cart.bybSwap(\'' + handle + '\',\'' + d + '\',this)">' + name(d) + '</button>';
    }).join('');
    return '<button type="button" class="cart-byb-swap-link" aria-expanded="true"' +
        ' onclick="DB_Cart.bybSwapOpen(\'' + handle + '\')">Swap scent</button>' +
      '<span class="cart-byb-swap">' +
        '<span class="cart-byb-swap-lab">Swap this box for</span>' + chips +
        '<button type="button" class="cart-byb-swap-cancel" onclick="DB_Cart.bybSwapOpen(\'\')">Cancel</button>' +
      '</span>';
  },
  // Open one row's panel, or close it. Repaints from the cart already in hand rather than re-reading:
  // this is a display toggle and must never touch the network or the cart.
  bybSwapOpen: function(handle) {
    this._bybSwapOpen = (this._bybSwapOpen === handle) ? '' : (handle || '');
    if (this._lastCart) this.render(this._lastCart);
    if (!this._bybSwapOpen) return;
    // SCROLL THE OPEN PANEL INTO VIEW, and this is not a nicety.
    //
    // The rows sit in .cart-body, which is the ONLY scroller and is 274px tall at 390x844 with the
    // offer bar and footer pinned below it. Opening a panel near the bottom of that window put the
    // second scent chip and Cancel UNDER the pinned bar: present in the DOM, reachable by nothing.
    // Every test passed, because they all asked the DOM rather than the screen. Caught by looking
    // at the screenshot, which is the whole argument for the proof gate.
    try {
      var el = document.querySelector('.cart-byb-swap');
      if (!el) return;
      el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      var first = el.querySelector('.cart-byb-swap-chip:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    } catch (e) { /* a drawer that cannot scroll is still usable, just tighter */ }
  },
  bybSwap: function(from, to, btn) {
    var self = this, byb = window.DB_BYB;
    if (!byb || !byb.variants || !byb.variants[from] || !byb.variants[to] || from === to) return;
    if (this._bybSwapping) return;
    this._bybSwapping = true;
    if (btn) { btn.disabled = true; }
    var done = function() { self._bybSwapping = false; self._swapPlan = null; self._opDisarm('swap'); if (btn) { btn.disabled = false; } };
    // On screen at once, panel closed; the job below makes it true or puts the screen back (2026-10-09).
    this._swapPlan = { from: from, to: to, seq: this._opSeq() };
    this._opArm('swap', function() { self._bybSwapping = false; self._swapPlan = null; });
    if (this._instantPaint()) { this._bybSwapOpen = ''; this._instantPaint(); }
    this._enqueue(function(f) {
      return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (!self._bybCanAdd(to, cart)) return null;
          var lines = (cart.items || []).filter(function(i) { return i.handle === from && !i.selling_plan_allocation; });
          if (!lines.length) return null;
          var plain = lines.filter(function(i) { return !(i.properties && i.properties._byb_auto); });
          var pool = plain.length ? plain : lines;
          var ln = pool[pool.length - 1];
          return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: ln.key, quantity: Math.max(0, ln.quantity - 1) }) })
            .then(function(r) { return self._okJson(r); })
            .then(function() {
              return f('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(self._addBody(byb.variants[to], 1, null)) })
                .then(function(r) { return self._okJson(r); })
                .then(null, function(err) {
                  // The add failed after the remove landed. Put the box back exactly as it was
                  // rather than leaving the shopper a box down, then report the failure.
                  return f('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(self._addBody(byb.variants[from], 1, null)) })
                    .then(function() { throw err; }, function() { throw err; });
                });
            })
            .then(function() { return self._bybApplyTestCode(f); })
            .then(function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
            .then(function(r) { return r.json(); });
        });
    }).then(function(c) {
      done();
      // Close the panel once the swap lands. Leaving it open over a row that no longer says what it
      // said when he opened it is how a shopper swaps twice by accident.
      if (c) { var sh = {}; sh[from] = -1; sh[to] = 1; self._bfShiftBase(sh); self._bybSwapOpen = ''; self.render(c); }
      else if (self._lastCart) self.render(self._lastCart);   // nothing changed: take the preview back off
    }, function(e) {
      done();
      self._bybSwapOpen = '';
      console.error('Scent swap error:', e);
      self._toast('Could not swap that scent. Your cart is unchanged.');
      if (self._lastCart) self.render(self._lastCart);
      self._resync();
    });
  },
  // Build Your Bundle group card steppers. Minus takes one box off that scent's last line (the
  // discount re-allocates on its own); plus adds one box through addItems so attribution rides
  // along. Shopify merges identical lines, so the count on the card is the sum across lines.
  // ==========================================================================
  // "LIKE BUTTER" (founder 2026-09-21: the drawer "should be super fast and smooth... its a bit
  // rigid... especially if im toggling anything fast").
  //
  // Measured first, at 450ms a cart call: one + tap was 4 requests and nothing on screen moved for
  // 1.4s; three fast taps were 12 requests and the number sat still for 3.2s, then jumped. Worse, the
  // old steppers were built from the last PAINTED cart, so under fast taps they were wrong, not just
  // slow: "+ then -" left an extra box in the cart, two fast minus taps removed one box, and four
  // fast + taps walked straight past the stock cap.
  //
  // What this does: a tap changes the NUMBER at once and is remembered as intent (_bfPend). After a
  // short pause (_BF_WAIT) the net intent goes out as ONE job through the same safe roads as before
  // (addItems for more boxes, a fresh-keyed change for fewer). A burst that nets to zero sends
  // nothing. Taps that arrive while a job is running wait for the next one; none is dropped.
  //
  // What it never does: guess money. Prices, the free box and the totals only ever come from
  // Shopify's answer; they dim while it is on its way. Checkout waits for it (dbCheckoutBusy).
  // ==========================================================================
  _BF_WAIT: 220,
  _bfPend: {}, _bfSend: {}, _bfBase: {}, _bfKeyPend: {}, _bfKeySend: {}, _bfKeyBase: {}, _bfTimer: null, _bfBusy: false,
  _bfReset: function() { clearTimeout(this._bfTimer); this._bfPend = {}; this._bfSend = {}; this._bfBase = {}; this._bfKeyPend = {}; this._bfKeySend = {}; this._bfKeyBase = {}; this._bfBusy = false; this._bfPaint(); },
  _bfHasPending: function() {
    var p = this._bfPend, k = this._bfKeyPend, h;
    for (h in p) { if (p[h]) return true; }
    for (h in k) { if (k[h]) return true; }
    return false;
  },
  // One-time boxes of a scent in the last cart Shopify sent us.
  _bfInCart: function(handle) {
    var n = 0, c = this._lastCart;
    if (c && c.items) c.items.forEach(function(i) { if (i.handle === handle && !i.selling_plan_allocation) n += i.quantity; });
    return n;
  },
  _bfLineQty: function(key) {
    var c = this._lastCart, q = null;
    if (c && c.items) c.items.forEach(function(i) { if (i.key === key) q = i.quantity; });
    return q;
  },
  // The number to show for a scent: where everything on its way lands (_replay), the same replay the
  // predicted cart is built from, so the stepper number and the prices can never disagree.
  _bfShown: function(handle) {
    var lines = this._replay(this._lastCart);
    var n = 0;
    for (var i = 0; i < lines.length; i++) { if (lines[i].h === handle) n += lines[i].q; }
    return Math.max(0, n);
  },
  _bfPaint: function() {
    var self = this, drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    // A number changed here is a change render's cached HTML does not know about, so the cache is dropped
    // and the next paint rewrites the rows (left alone, a refused tap kept its number: review finding 9).
    var items = document.getElementById('cart-items'), touchedDom = false;
    var nums = drawer.querySelectorAll('[data-bf]');
    for (var i = 0; i < nums.length; i++) {
      var h = nums[i].getAttribute('data-bf'), v = String(self._bfShown(h));
      if (nums[i].textContent !== v) { nums[i].textContent = v; nums[i].classList.remove('bf-pop'); void nums[i].offsetWidth; nums[i].classList.add('bf-pop'); touchedDom = true; }
    }
    // Rows (below three boxes) carry a line key. A prediction on screen drew every row with its number
    // already, so they are left be; otherwise each row shows Shopify's number plus his taps on its way.
    var predicting = self._instantOK && self._instantWanted();
    var byb = window.DB_BYB, lc = self._lastCart, lineOf = {}, boxRow = {};
    ((lc && lc.items) || []).forEach(function(i) { lineOf[i.key] = i; });
    var setNum = function(el, t) { if (el.textContent !== t) { el.textContent = t; el.classList.remove('bf-pop'); void el.offsetWidth; el.classList.add('bf-pop'); touchedDom = true; } };
    var lines = drawer.querySelectorAll('[data-bfk]');
    for (var k = 0; k < lines.length; k++) {
      var key = lines[k].getAttribute('data-bfk'), li = lineOf[key];
      // A one-time box row: its taps move the scent's count (qtyStep sends them through bybStep), so its
      // number is set below from the scent; the last row of each scent is where that change shows.
      if (li && !li.selling_plan_allocation && byb && byb.variants && byb.variants[li.handle]) { if (!predicting) boxRow[li.handle] = { el: lines[k], q: li.quantity }; continue; }
      if (predicting && !(key in self._bfKeyPend) && !(key in self._bfKeySend)) continue;
      var b = (key in self._bfKeySend) ? (self._bfKeyBase[key] + self._bfKeySend[key]) : self._bfLineQty(key);
      if (b === null) continue;
      // Nothing of his on its way for this line: Shopify's own number, so a refused tap's number goes back.
      setNum(lines[k], String(Math.max(0, b + (self._bfKeyPend[key] || 0))));
    }
    for (var bh in boxRow) {
      if (!Object.prototype.hasOwnProperty.call(boxRow, bh)) continue;
      setNum(boxRow[bh].el, String(Math.max(0, boxRow[bh].q + self._bfShown(bh) - self._bfInCart(bh))));
    }
    if (touchedDom && items) items.__dbHtml = null;
    // Waiting on Shopify. When the cart could be predicted to the cent (is-instant) the prices stay at
    // full strength, because they are already the answer; otherwise they rest at half strength.
    var waiting = self._instantWanted();
    drawer.classList.toggle('is-bf-pending', waiting);
    drawer.classList.toggle('is-instant', waiting && self._instantOK);
  },
  _bfArm: function() {
    var self = this;
    clearTimeout(this._bfTimer);
    this._bfTimer = setTimeout(function() { self._bfFlush(); }, this._BF_WAIT);
  },
  bybStep: function(handle, delta) {
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || !byb.variants[handle]) return;
    var d = delta > 0 ? 1 : -1, shown = this._bfShown(handle);
    if (d > 0) {
      // The stock cap counts what is in the cart AND what he has already tapped, so fast taps cannot walk past it.
      if (byb.caps && typeof byb.caps[handle] === 'number' && byb.caps[handle] <= shown) return;
    } else if (shown <= 0) return;
    this._bfPend[handle] = (this._bfPend[handle] || 0) + d;
    this._tapped(handle, d);
    this._bfPaint();
    this._bfArm();
  },
  // A plain line's stepper (one box, merch). Same idea, keyed by the line.
  qtyStep: function(key, delta) {
    // A line the cart is still drawing from a prediction has no Shopify key yet; its stepper is the scent's.
    if (String(key).indexOf('pending:') === 0) { this.bybStep(String(key).split(':')[1], delta); return; }
    var have = this._bfLineQty(key);
    if (have === null) { this.refresh(); return; }
    var line = null, byb = window.DB_BYB;
    ((this._lastCart && this._lastCart.items) || []).forEach(function(i) { if (i.key === key) line = i; });
    // A one-time box is a box whichever row its stepper sits on: it moves the scent's own count, so a
    // tap on the bundle card and a tap on a line row can never fight over the same box (review finding 6:
    // both set Amber to 1 and the cart kept a box he had taken off).
    if (line && !line.selling_plan_allocation && byb && byb.variants && byb.variants[line.handle]) { this.bybStep(line.handle, delta); return; }
    var d = delta > 0 ? 1 : -1;
    var base = (key in this._bfKeySend) ? (this._bfKeyBase[key] + this._bfKeySend[key]) : have;
    if (base + (this._bfKeyPend[key] || 0) + d < 0) return;
    this._bfKeyPend[key] = (this._bfKeyPend[key] || 0) + d;
    this._tapped('', d);
    this._bfPaint();
    this._bfArm();
  },
  _bfFlush: function() {
    var self = this, byb = window.DB_BYB;
    if (this._bfBusy) return;   // the running job flushes again when it lands
    var adds = [], takes = [], keyJobs = [], h;
    for (h in this._bfPend) { var n = this._bfPend[h]; if (n > 0) adds.push({ h: h, n: n }); else if (n < 0) takes.push({ h: h, n: -n }); }
    for (h in this._bfKeyPend) { if (this._bfKeyPend[h]) keyJobs.push({ key: h, n: this._bfKeyPend[h], have: this._bfLineQty(h) }); }
    if (!adds.length && !takes.length && !keyJobs.length) {
      this._bfPend = {}; this._bfKeyPend = {}; this._bfPaint();
      // Nothing to send (his taps cancelled out), but a minus among them may have declined the free box:
      // a plain repaint from Shopify's cart lets that be judged now, and puts the bar's words right.
      if (this._lastCart) this.render(this._lastCart);
      return;
    }
    this._bfBusy = true;
    this._bfSendSeq = this._opSeq(); this._bfAddSeq = 0;   // the add is stamped when it is queued (below)
    adds.concat(takes).forEach(function(x) { self._bfBase[x.h] = self._bfInCart(x.h); self._bfSend[x.h] = self._bfPend[x.h]; });
    keyJobs.forEach(function(x) { self._bfKeyBase[x.key] = x.have === null ? 0 : x.have; self._bfKeySend[x.key] = x.n; });
    this._bfPend = {}; this._bfKeyPend = {};
    this._bfPaint();
    var landed = function() {
      self._bfSend = {}; self._bfBase = {}; self._bfKeySend = {}; self._bfKeyBase = {}; self._bfBusy = false; self._bfSendSeq = 0; self._bfAddSeq = 0;
      self._bfPaint();
      if (self._bfHasPending()) { self._bfFlush(); return; }
      // Everything he tapped is in Shopify's cart. Paint that answer once more (it matches what is
      // already on screen), which also lets the free box decide now that he has stopped.
      if (self._lastCart) self.render(self._lastCart);
    };
    var chain = Promise.resolve();
    // His taps recorded which way they went when he made them (_bybIntent); nothing is recorded again here.
    takes.forEach(function(x) { chain = chain.then(function() { return self._bfTake(x.h, x.n); }); });
    keyJobs.forEach(function(x) {
      chain = chain.then(function() { if (x.have === null) return; return self._bfChangeLine(x.key, x.n); });
    });
    if (adds.length) {
      chain = chain.then(function() {
        return new Promise(function(res) {
          // No `handle`: the tap itself already recorded the scent he picked last, and this confirmation
          // arrives a second later, after he may have tapped another (it used to overwrite that pick).
          // `own`: these are the stepper's own boxes, so its target does not move when they land.
          self._bfAddSeq = self._opSeq();
          self.addItems(adds.map(function(x) { return { id: byb.variants[x.h], quantity: x.n }; }), res, { src: 'tap', touched: true, own: true });
        });
      });
    }
    // addItems answers before its own repaint has come back; wait for the lane to drain AND for that
    // repaint, so the number is handed back to Shopify's count only once that count is on screen. (The
    // lane frees when the read returns, a beat before it is painted; deciding the free box in that beat
    // used the cart from before the add and showed a box it then took back, found 2026-10-09.)
    // Capped: a request that never answers (a dead connection) used to hold _bfBusy for the life of the
    // page, and every later tap waited behind it forever (review finding 2). After the lane's own give-up
    // the job counts as landed and Shopify's cart is read again.
    var once = false;
    var settled = chain.then(function() { return self._lane || null; }).then(function() { return self._refreshP || null; }).then(function() { return 'ok'; }, function() { return 'ok'; });
    var capped = new Promise(function(res) { setTimeout(function() { res('cap'); }, self._QUEUE_MS); });
    Promise.race([settled, capped]).then(function(why) { if (once) return; once = true; landed(); if (why === 'cap') self._resync(); });
  },
  // Take n boxes of a scent off, reading the key FRESH before every change (Shopify re-keys lines),
  // from an unmarked line first so the minus button never hands back the free box while a paid box
  // of that scent is still there.
  // The read and each change are ONE job: queued as separate requests, another add could land between the
  // read and the change, and the change (a quantity, not a difference) then took off his new box too (found
  // by the review's fuzzer, 2026-10-09: a minus queued behind a page add left one Amber fewer than shown).
  _bfTake: function(handle, n) {
    var self = this;
    return this._enqueue(function(f) {
      var guard = 0, last = null;
      var step = function(left) {
        if (left <= 0 || guard++ > 6) return last;
        return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }).then(function(cart) {
          last = cart;
          var lines = (cart.items || []).filter(function(i) { return i.handle === handle && !i.selling_plan_allocation; });
          if (!lines.length) return cart;
          var plain = lines.filter(function(i) { return !(i.properties && i.properties._byb_auto); });
          var pick = plain.length ? plain : lines, ln = pick[pick.length - 1], take = Math.min(left, ln.quantity);
          return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: ln.key, quantity: ln.quantity - take }) })
            .then(function(r) { return r.json(); })
            .then(function(c) { if (c && c.items) last = c; return step(left - take); });
        });
      };
      return step(n);
    }).then(function(c) { if (c && c.items) self.render(c); else self._resync(); }, function() { if (self._lastCart) self.render(self._lastCart); self._resync(); });
  },
  // One absolute change for a plain line, through updateQty's own bookkeeping (it records which way a box moved).
  // Only lines that are not one-time boxes come here (qtyStep sends boxes through bybStep), so the free box
  // has nothing to record. Read and change as one job, by HOW MANY he tapped, not a quantity worked out from
  // an older read.
  _bfChangeLine: function(key, delta) {
    var self = this;
    return this._enqueue(function(f) {
      return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }).then(function(cart) {
        var line = null;
        (cart.items || []).forEach(function(i) { if (i.key === key) line = i; });
        if (!line || !delta) return cart;
        return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, line.quantity + delta) }) })
          .then(function(r) { return r.json(); });
      });
    }).then(function(c) { if (c && c.items) self.render(c); else self._resync(); }, function(e) { console.error('Cart update error:', e); if (self._lastCart) self.render(self._lastCart); self._resync(); });
  },
  // ==========================================================================
  // INSTANT CART (founder 2026-10-09: "it should be smooth like butter... no bugs no lag no delays").
  //
  // Measured first (WebKit at iPhone 13 size, real network, 2026-10-09): a + tap moved its number in
  // about 45ms, but the prices sat dimmed for 1.1s, and a tap that earned a free box took 2.6s and 8
  // requests before the box appeared. The steppers were fast; the money was not.
  //
  // So every tap now paints the cart it will land on, prices included, the moment it happens, and the
  // network catches up behind it. The prices are not a guess. Shopify's Buy 2 Get 1 is a fixed rule,
  // measured on 13 real carts the same day (see _simAllocate), and the drawer only predicts a cart that
  // rule reproduces to the cent: no percent code, no order-level discount, and the rule giving exactly
  // the free boxes Shopify gave the cart already on screen (_predictable). Anything else falls back to
  // the half-strength prices of before. Checkout still waits for Shopify's own answer (dbCheckoutBusy).
  // ==========================================================================
  _instantOK: false,        // the last paint was a prediction the drawer trusts to the cent
  _lineLook: {},            // handle -> how Shopify drew that scent's line last time (see render)
  _bybLastTapped: '',       // the scent he added last; the free box follows it (founder 2026-10-09)
  _bybLastDir: 0,           // which way his last tap went
  _bybAutoPlanned: '',      // a free box the cart has decided to add and is already showing
  _bybAutoStarted: false,   // ... and the add is on its way, so a tap can no longer take it back
  _bybGraceUntil: 0,        // the free box waits for him to pause
  _BYB_GRACE: 1000,         // judgment, not measured: someone picking scents taps again within about a second. At 500ms a second tap 700ms later had a free box dropped in between (the C2 test)
  _instantOps: [],          // adds on their way, each { tok, mix: [{ h, q, props }] }: a page add, the 1-or-4 button
  _instantSeq: 0,
  _pageTok: 0,              // the bundle page's add on its way (its add reaches addItems without a token)
  _pageTouched: false,      // ... and openInstant already recorded that tap (the add must not record it again)
  _pendingSlot: '',         // a free-box chip tap on its way
  _swapPlan: null,          // { from, to } on its way
  _removeAllPlan: false,
  _protectWant: undefined,  // the Ship Happens toggle on its way: true, false, or undefined for none
  _protectToggling: false,
  // Is anything on its way that the screen should already show?
  _instantWanted: function() {
    return !!(this._bfBusy || this._bfHasPending() || this._bybAutoPlanned || this._instantOps.length ||
      this._pendingSlot || this._swapPlan || this._removeAllPlan || this._protectToggling || this._protectAdding);
  },
  // His own moves still on their way to Shopify (not the free box the cart adds by itself). While any is
  // out, the free box does not decide (a decision taken from a cart that is about to change added a 4th,
  // paid box under a $0.00 chip: review finding 1, 2026-10-09), and a removal is not judged yet.
  _userOpsInFlight: function() {
    return !!(this._bfBusy || this._bfHasPending() || this._instantOps.length || this._pendingSlot ||
      this._swapPlan || this._removeAllPlan || this._verifyN > 0);
  },
  // An add on its way, owned by whoever started it: only its own landing takes it back off the screen
  // (one add's landing used to clear another's boxes: review finding 3).
  _instantStart: function(mix, kind) {
    var tok = ++this._instantSeq, self = this;
    this._instantOps = this._instantOps.concat([{ tok: tok, mix: mix || [], kind: kind || '', seq: this._opSeq() }]);
    this._opArm('inst' + tok, function() { self._instantDone(tok); });
    return tok;
  },
  _instantDone: function(tok) {
    if (!tok) return;
    this._instantOps = this._instantOps.filter(function(o) { return o.tok !== tok; });
    if (this._pageTok === tok) this._pageTok = 0;
    this._opDisarm('inst' + tok);
  },
  // A dead connection must never hold the cart. Anything painted ahead of Shopify lets go after the
  // lane's own give-up (_QUEUE_MS), the screen goes back to Shopify's cart, and checkout frees up
  // (review finding 2: a hung request used to stick the cart for the life of the page).
  _opT: {},
  _opArm: function(name, clear) {
    var self = this;
    clearTimeout(this._opT[name]);
    this._opT[name] = setTimeout(function() {
      self._opT[name] = null;
      try { clear(); } catch (e) {}
      if (self._lastCart) self.render(self._lastCart);
      self._resync();
    }, this._QUEUE_MS + 1000);
  },
  // Read Shopify's cart until a newer one is actually painted: after a give-up the connection may still be
  // stalled, and one read that never answers left an old cart on screen for good (the review's fuzzer,
  // requests that never answer). Up to three more tries, 8 seconds apart.
  _resync: function(tries) {
    var self = this, seq0 = this._lastSeq || 0, n = tries || 0;
    this.refresh();
    if (n < 3) setTimeout(function() { if ((self._lastSeq || 0) <= seq0) self._resync(n + 1); }, 8000);
  },
  _opDisarm: function(name) { clearTimeout(this._opT[name]); this._opT[name] = null; },
  _verifyN: 0,              // free-box proofs running (_bybVerifyTapped): checkout waits for them too
  // Every tap: remember the scent, hold the free box until he pauses, and paint where it lands.
  _tapped: function(handle, d) {
    // A hat or a subscription line is not a box: the free box does not move for it.
    if (!handle) { this._instantPaint(); return; }
    // A free box already on screen but not yet sent is now part of what he is looking at, so it
    // becomes an ordinary box he keeps. Withdrawing it would make one tap move the count by two.
    if (this._bybAutoPlanned && !this._bybAutoStarted) {
      var h0 = this._bybAutoPlanned;
      this._bybAutoPlanned = '';
      this._bfPend[h0] = (this._bfPend[h0] || 0) + 1;
    }
    this._bybIntent(d, handle, 'tap');
    this._instantPaint();
  },
  // His move, recorded the moment he makes it, whichever button it was. His LAST move decides the free
  // box: a plus arms it, a minus that lands one short is a "no thanks". Recorded when the network
  // answered instead, an add that landed after his minus re-armed the box he had just declined (review
  // finding 4, 2026-10-09). Every move also restarts the pause the free box waits for.
  _bybIntent: function(dir, handle, src) {
    if (!dir) return;
    var byb = window.DB_BYB, self = this;
    var h = (handle && byb && byb.variants && byb.variants[handle]) ? handle : '';
    if (dir < 0) {
      // A minus always means "no more for now": it disarms, and a cart that lands one short is a no-thanks.
      // The scent counts as TAKEN OFF only when it ends below what Shopify has: "+ + -" on Alpine is still
      // one more Alpine, so the button keeps naming Alpine (A6).
      this._bybTouch(src || 'tap', -1, (h && this._bfShown(h) < this._bfInCart(h)) ? h : '');
    } else this._bybTouch(src || 'tap', dir, h);
    if (dir > 0 && h) this._bybLastTapped = h;
    this._bybLastDir = dir;
    this._bybOtherOpen = false;   // a tap elsewhere closes the "Pick another scent" row
    this._bybGraceUntil = Date.now() + this._BYB_GRACE;
    clearTimeout(this._bybGraceT);
    this._bybGraceT = setTimeout(function() { self._bybForecast(); }, this._BYB_GRACE + 10);
  },
  // He has paused. If his moves land one box short of a free one, show the free box now, in the scent he
  // picked last, rather than after the round trips that will actually add it (_bybReconcile does that,
  // and adds exactly this box).
  _bybForecast: function() {
    if (!this._bybAuto() || this._bybBlocked || this._bybAutoPlanned || this._bybAdding) return;
    if (this._bybLastDir <= 0) return;          // a removal that lands one short is a "no thanks"
    // Nothing of his still on its way: Shopify's cart is the whole story, so reconcile decides (and adds) now.
    if (!this._userOpsInFlight()) { if (this._lastCart) this.render(this._lastCart); return; }
    if (this._bybPlanIfDue()) this._instantPaint();
  },
  // Show the free box ahead of Shopify only when reconcile will add exactly that box once his moves land:
  // armed, not declined on this cart, a cart the drawer can price, not a state already tried. Without
  // these it showed a box that reconcile then took back off (review, 2026-10-09).
  _bybPlanIfDue: function() {
    var c = this._lastCart, byb = window.DB_BYB, self = this;
    if (!this._bybAuto() || this._bybBlocked || this._bybAutoPlanned || this._bybAdding || this._bybLastDir <= 0) return false;
    if (!c || !c.items || !this._bybArmed || this._bybOptedOut(c) || !this._predictable(c)) return false;
    var have = {}, n = 0;
    byb.handles.forEach(function(h) { have[h] = self._bfShown(h); n += have[h]; });
    if (n < 2 || n % 3 !== 2) return false;
    if (this._bybTried[this._bybTriedKey(c, n)]) return false;
    var h = this._bybPickFromCounts(have);
    if (!h) return false;
    this._bybAutoPlanned = h;
    return true;
  },
  // Checkout tapped: the pause is over. His unsent taps go now and the free box decides now, so he never
  // leaves with the box it was about to add (review finding 5: checkout was open during the pause).
  _bybDecideNow: function() {
    clearTimeout(this._bybGraceT); clearTimeout(this._bybRecheckT);
    this._bybGraceUntil = 0;
    if (this._bfHasPending() && !this._bfBusy) { clearTimeout(this._bfTimer); this._bfFlush(); }
    if (!this._userOpsInFlight() && this._lastCart) this.render(this._lastCart);
  },
  // Another of his moves landed on a scent the steppers are still sending: its boxes are in Shopify's cart
  // now, so the steppers' own target moves with them (it showed 7, then 6 for a second, then 7: finding 8).
  _bfShiftBase: function(d) {
    for (var h in (d || {})) {
      if (Object.prototype.hasOwnProperty.call(d, h) && Object.prototype.hasOwnProperty.call(this._bfSend, h)) this._bfBase[h] += d[h];
    }
  },
  // Which scent the free box is. Founder 2026-10-09: "why is it always another free box of coastal
  // drift? what if somebody doesnt want coastal drift". It used to prefer a scent he did NOT have, then
  // walk the standing order, which ends on Coastal Drift, so a shopper with all three scents got Coastal
  // every time. Now:
  //   1. the scent he added last (he just showed us what he wants more of),
  //   2. failing that, the scent he has the most of,
  //   3. failing that, the standing order,
  // never past a scent's stock cap, and never the scent he just took off unless nothing else is left.
  _bybPickFromCounts: function(have) {
    var byb = window.DB_BYB, self = this, order = this._bybFreeOrder();
    var room = function(h) { return !!(h && byb.variants[h]) && (!byb.caps || typeof byb.caps[h] !== 'number' || byb.caps[h] > (have[h] || 0)); };
    var ok = function(h) { return room(h) && h !== self._bybLastRemoved; };
    if (ok(this._bybLastTapped)) return this._bybLastTapped;
    var best = '', most = 0;
    order.forEach(function(h) { var q = have[h] || 0; if (q > 0 && q >= most && ok(h)) { best = h; most = q; } });
    if (best) return best;
    for (var k = order.length - 1; k >= 0; k--) { if (ok(order[k])) return order[k]; }
    for (k = order.length - 1; k >= 0; k--) { if (room(order[k])) return order[k]; }
    return '';
  },
  _moneyCents: function(s) {
    if (typeof s === 'number') return Math.round(s);
    var n = Math.round(parseFloat(String(s || '').replace(/[^0-9.]/g, '')) * 100);
    return isNaN(n) ? 0 : n;
  },
  // Can the drawer paint this cart's next state to the cent?
  _predictable: function(cart) {
    var byb = window.DB_BYB, self = this;
    if (!cart || !cart.items || !byb || !byb.live || !byb.variants || !byb.prices || !byb.handles) return false;
    if (!byb.handles.every(function(h) { return byb.prices[h] > 0 && byb.variants[h]; })) return false;
    // Shopify's free-box order was measured with every scent at one price; a scent priced apart could
    // change which line gives up the free box, so the drawer stops predicting rather than guess (review).
    if (!byb.handles.every(function(h) { return byb.prices[h] === byb.prices[byb.handles[0]]; })) return false;
    if ((cart.cart_level_discount_applications || []).some(function(d) { return (d.total_allocated_amount || 0) > 0; })) return false;
    // A free-shipping code moves no line price. Any other code (a percent code, a creator code) may,
    // and how it stacks with the free box is Shopify's call, so the drawer does not guess it.
    var ship = { SHIPSFREE: 1 };
    try { (window.DB_FREESHIP_CODES || []).forEach(function(c) { if (c) ship[String(c).toUpperCase()] = 1; }); } catch (e0) {}
    // The mystery gift's preview test code (sandbox only) discounts the gift line alone, like the live automatic.
    if (window.DB_GIFT && window.DB_GIFT.code) ship[String(window.DB_GIFT.code).toUpperCase()] = 1;
    if ((cart.discount_codes || []).some(function(d) { return d && d.code && !ship[String(d.code).toUpperCase()]; })) return false;
    var ok = true;
    cart.items.forEach(function(i) {
      (i.line_level_discount_allocations || []).forEach(function(a) {
        var t = (a.discount_application && a.discount_application.title) || '';
        if ((a.amount || 0) > 0 && !self._bybIsFreeBoxDiscount(t) && !self._giftIsLine(i)) ok = false;
      });
      if (!i.selling_plan_allocation && byb.variants[i.handle] && i.original_price && i.original_price !== byb.prices[i.handle]) ok = false;
    });
    if (!ok) return false;
    // The rule has to reproduce the free boxes Shopify actually gave THIS cart, scent by scent.
    var lines = this._simFromCart(cart), want = this._simAllocate(lines), real = {};
    cart.items.forEach(function(i) { if (!i.selling_plan_allocation && byb.variants[i.handle]) real[i.handle] = (real[i.handle] || 0) + self._bybFreeUnits(i); });
    return byb.handles.every(function(h) { return (want[h] || 0) === (real[h] || 0); });
  },
  // A line's identity, the way Shopify keeps lines apart: the same scent with different properties is
  // a different line (the bundle's visible "Bundle" tag, the free box's hidden _byb_auto, attribution).
  _propSig: function(props) {
    props = props || {};
    return Object.keys(props).filter(function(k) { return props[k] !== null && props[k] !== undefined && props[k] !== ''; })
      .sort().map(function(k) { return k + '=' + String(props[k]); }).join('&');
  },
  // The properties an add of this scent will carry (attribution, page form inputs, plus `extra`).
  _addProps: function(handle, extra) {
    var byb = window.DB_BYB, body = this._addBody(byb.variants[handle], 1, null, extra);
    return body.properties || {};
  },
  // The cart's one-time scent boxes as Shopify's discount sees them: one line per scent AND properties,
  // with `idx` its place in cart order, where 0 is the line added LAST. Shopify sometimes shows one line
  // as two (its free part and its paid part, same properties); those count as one line, at the earlier place.
  _simFromCart: function(cart) {
    var byb = window.DB_BYB, self = this, lines = [], at = {};
    (cart.items || []).forEach(function(i, idx) {
      if (i.selling_plan_allocation || !byb.variants[i.handle]) return;
      var sig = self._propSig(i.properties), k = i.handle + '|' + sig;
      if (at[k] === undefined) {
        at[k] = lines.length;
        lines.push({ h: i.handle, sig: sig, props: i.properties || {}, auto: !!(i.properties && i.properties._byb_auto), q: 0, idx: idx, item: i });
      }
      lines[at[k]].q += i.quantity;
    });
    return lines;
  },
  // Shopify's Buy 2 Get 1, measured on 13 real carts 2026-10-09 (one each in two orders, 2+1 both ways,
  // 4, 5, 6 four ways, 7, 9): one free box per three; the line with the LOWEST line total gives them
  // up first, a tie goes to the line added LAST, and a line gives up as many as it has before the next
  // is touched. Sets `free` on each line; returns free boxes per scent.
  _simAllocate: function(lines) {
    var byb = window.DB_BYB, n = 0, per = {};
    lines.forEach(function(l) { n += l.q; l.free = 0; });
    var left = Math.floor(n / 3);
    lines.slice().sort(function(a, b) {
      var ta = a.q * byb.prices[a.h], tb = b.q * byb.prices[b.h];
      return ta !== tb ? ta - tb : a.idx - b.idx;
    }).forEach(function(l) { var take = Math.min(l.q, left); l.free = take; left -= take; });
    lines.forEach(function(l) { per[l.h] = (per[l.h] || 0) + l.free; });
    return per;
  },
  // WHERE EVERYTHING ON ITS WAY LANDS, as the cart's scent lines (one per scent and properties; `idx` is a
  // line's age: 0 = newest in Shopify's cart, below 0 = still on its way, lower = queued later). Moves are
  // replayed in the order the lane will send them, each stamped when it was queued (_opSeq): his stepper
  // job, a page add, the 1-or-4 button, a chip, a swap, a remove-all, then taps not sent yet, then the free
  // box. Replaying his taps first instead moved the FREE tag from one row to another for a second, and a
  // minus on a box still on its way was lost from the total (review 2, 2026-10-09).
  _opSeq: function() { this._opSeqN = (this._opSeqN || 0) + 1; return this._opSeqN; },
  _replay: function(base) {
    var byb = window.DB_BYB, self = this;
    var lines = this._simFromCart(base || { items: [] });
    if (!byb || !byb.variants || !byb.handles) return lines;
    var nextIdx = -1;
    var add = function(h, q, props) {
      if (q <= 0 || !byb.variants[h]) return;
      var sig = self._propSig(props), l = null;
      lines.forEach(function(x) { if (!l && x.h === h && x.sig === sig) l = x; });
      if (l) l.q += q;
      else lines.push({ h: h, sig: sig, props: props, auto: !!(props && props._byb_auto), q: q, idx: nextIdx--, item: null });
    };
    // The minus button's order (_bfTake, bybSwap): unmarked lines first, oldest first, the marked free box last.
    var take = function(h, q) {
      lines.filter(function(l) { return l.h === h && !l.auto; }).sort(function(a, b) { return b.idx - a.idx; })
        .concat(lines.filter(function(l) { return l.h === h && l.auto; }).sort(function(a, b) { return b.idx - a.idx; }))
        .forEach(function(l) { var t = Math.min(l.q, q); l.q -= t; q -= t; });
    };
    var LATE = 1e15, steps = [];
    // The stepper's job on its way: whatever part of it Shopify's cart does not show yet. Its takes go first,
    // its add when that is queued (or, not queued yet, after everything already queued).
    if (this._bfBusy) {
      var sendHs = Object.keys(this._bfSend).filter(function(h) { return byb.variants[h]; });
      var left = {};
      sendHs.forEach(function(h) { left[h] = self._bfBase[h] + self._bfSend[h] - self._bfInCart(h); });
      steps.push({ seq: this._bfSendSeq || 0, run: function() { sendHs.forEach(function(h) { if (left[h] < 0) take(h, -left[h]); }); } });
      steps.push({ seq: this._bfAddSeq || (LATE - 1), run: function() { sendHs.forEach(function(h) { if (left[h] > 0) add(h, left[h], self._addProps(h)); }); } });
    }
    this._instantOps.forEach(function(o) { steps.push({ seq: o.seq || 0, run: function() { o.mix.forEach(function(m) { add(m.h, m.q, m.props); }); } }); });
    if (this._pendingSlot) { var slotH = this._pendingSlot; steps.push({ seq: this._slotSeq || 0, run: function() { add(slotH, 1, self._addProps(slotH, { _byb_src: 'slot' })); } }); }
    if (this._swapPlan) { var sw = this._swapPlan; steps.push({ seq: sw.seq || 0, run: function() { take(sw.from, 1); add(sw.to, 1, self._addProps(sw.to)); } }); }
    if (this._removeAllPlan) steps.push({ seq: this._rmSeq || 0, run: function() { lines.forEach(function(l) { l.q = 0; }); } });
    // His taps not sent yet go out after everything already queued: removals first, like the flush.
    steps.push({ seq: LATE, run: function() {
      var hs = Object.keys(self._bfPend).filter(function(h) { return byb.variants[h] && self._bfPend[h]; });
      hs.forEach(function(h) { if (self._bfPend[h] < 0) take(h, -self._bfPend[h]); });
      hs.forEach(function(h) { if (self._bfPend[h] > 0) add(h, self._bfPend[h], self._addProps(h)); });
    } });
    // The free box: queued when it started, or (only planned) after everything of his lands.
    if (this._bybAutoPlanned) { var ah = this._bybAutoPlanned; steps.push({ seq: this._bybAutoStarted ? (this._bybAutoSeq || 0) : LATE + 1, run: function() { add(ah, 1, self._addProps(ah, { _byb_auto: '1', _byb_src: 'auto' })); } }); }
    steps.sort(function(a, b) { return a.seq - b.seq; });
    steps.forEach(function(st) { st.run(); });
    return lines;
  },
  // A cart shaped like /cart.js, showing where everything on its way lands (_replay), priced by the rule.
  _predictCart: function(base) {
    var byb = window.DB_BYB, self = this;
    var lines = this._replay(base).filter(function(l) { return l.q > 0; });
    this._simAllocate(lines);
    var title = 'Buy 2, Get 1 Free';
    (base.items || []).forEach(function(i) {
      (i.line_level_discount_allocations || []).forEach(function(a) {
        var t = a.discount_application && a.discount_application.title;
        if (t && self._bybIsFreeBoxDiscount(t)) title = t;
      });
    });
    var tmpl = {};
    (base.items || []).forEach(function(i) { if (byb.variants[i.handle] && !i.selling_plan_allocation && !tmpl[i.handle]) tmpl[i.handle] = i; });
    var build = function(l) {
      var t = l.item || tmpl[l.h] || null, price = byb.prices[l.h], it;
      try { it = t ? JSON.parse(JSON.stringify(t)) : {}; } catch (e1) { it = {}; }
      it.handle = l.h;
      it.variant_id = Number(byb.variants[l.h]); it.id = it.variant_id;
      it.key = (l.item && l.item.key) || ('pending:' + l.h + ':' + (l.auto ? 'auto' : 'n') + ':' + (-l.idx));
      it.quantity = l.q;
      it.price = price; it.original_price = price; it.discounted_price = price;
      it.original_line_price = l.q * price; it.line_price = l.q * price;
      it.final_line_price = (l.q - l.free) * price; it.final_price = Math.round(it.final_line_price / Math.max(1, l.q));
      it.total_discount = l.free * price;
      it.discounts = [];
      it.line_level_discount_allocations = [{ amount: l.free * price, discount_application: { title: title, type: 'automatic' } }];
      it.selling_plan_allocation = null;
      try { it.properties = JSON.parse(JSON.stringify(l.props || {})); } catch (e4) { it.properties = {}; }
      if (!t) {
        var look = self._lineLook[l.h];
        if (look) { for (var lk in look) { if (Object.prototype.hasOwnProperty.call(look, lk)) it[lk] = look[lk]; } }
        else {
          it.product_title = String((byb.names && byb.names[l.h]) || l.h).toUpperCase(); it.title = it.product_title;
          it.product_type = 'Detergent Sheets'; it.variant_title = null;
          it.featured_image = (byb.images && byb.images[l.h]) ? { url: byb.images[l.h] } : null;
        }
      }
      return it;
    };
    var items = [], placed = {};
    lines.filter(function(l) { return l.idx < 0; }).sort(function(a, b) { return a.idx - b.idx; }).forEach(function(l) { items.push(build(l)); });
    var covVid = window.DB_SHIP_PROTECT && String(window.DB_SHIP_PROTECT.variant);
    var covLine = null, keyQty = {};
    var kk = {}, k2;
    for (k2 in this._bfKeyPend) kk[k2] = 1;
    for (k2 in this._bfKeySend) kk[k2] = 1;
    Object.keys(kk).forEach(function(key) {
      var b = (key in self._bfKeySend) ? (self._bfKeyBase[key] + self._bfKeySend[key]) : self._bfLineQty(key);
      if (b !== null) keyQty[key] = Math.max(0, b + (self._bfKeyPend[key] || 0));
    });
    (base.items || []).forEach(function(i) {
      if (!i.selling_plan_allocation && byb.variants[i.handle]) {
        var k = i.handle + '|' + self._propSig(i.properties);
        if (placed[k]) return;
        placed[k] = true;
        var l = null;
        lines.forEach(function(x) { if (!l && x.idx >= 0 && x.h === i.handle && x.sig === self._propSig(i.properties)) l = x; });
        if (l) items.push(build(l));
        return;
      }
      if (covVid && String(i.variant_id) === covVid) { covLine = i; return; }
      var c;
      try { c = JSON.parse(JSON.stringify(i)); } catch (e2) { c = i; }
      if (Object.prototype.hasOwnProperty.call(keyQty, i.key)) {
        var q = keyQty[i.key];
        if (!q) return;
        var unit = i.quantity ? i.final_line_price / i.quantity : 0, unitO = i.quantity ? i.original_line_price / i.quantity : 0;
        c.quantity = q; c.final_line_price = Math.round(unit * q); c.original_line_price = Math.round(unitO * q); c.line_price = c.original_line_price;
      }
      items.push(c);
    });
    // The mystery gift follows the boxes he is moving. A cart that stops qualifying paints without it at once, as the
    // gift sync leaves it once Shopify answers. A cart that starts qualifying shows it only when Shopify has rung it
    // up at $0.00 (the gift sync's own render), so the drawer never promises a gift ahead of the cart.
    if (window.DB_GIFT && !this._giftWant({ items: items })) items = items.filter(function(i) { return !self._giftIsLine(i); });
    // Ship Happens: his toggle, or what the drawer's own rule will do once the boxes land (render adds it
    // to a cart with product unless he opted out, and drops it from a cart with nothing else).
    var cover = this._protectWant;
    var product = items.some(function(i) { return i.quantity > 0; });
    var covOn = cover === true || (cover === undefined && (covLine ? true :
      !!(window.DB_SHIP_PROTECT && !this._protectOptedOut() && !this._protectAddFailed && !window.DB_CART_PAGE_OWNS_PROTECT)));
    if (product && covOn) {
      if (covLine) { items.push(JSON.parse(JSON.stringify(covLine))); }
      else if (window.DB_SHIP_PROTECT) {
        var cp = this._moneyCents(window.DB_SHIP_PROTECT.price);
        if (!cp) return null;   // no price to show: do not predict a total we cannot back
        items.push({ id: Number(covVid), variant_id: Number(covVid), key: 'pending:coverage', handle: window.DB_SHIP_PROTECT.handle || 'ship-happens-coverage',
          quantity: 1, price: cp, original_price: cp, final_price: cp, original_line_price: cp, line_price: cp, final_line_price: cp,
          selling_plan_allocation: null, properties: {}, line_level_discount_allocations: [], discounts: [], product_title: 'Ship Happens Coverage', title: 'Ship Happens Coverage' });
      }
    }
    var pc;
    try { pc = JSON.parse(JSON.stringify(base)); } catch (e3) { return null; }
    var total = 0, orig = 0, n = 0;
    items.forEach(function(i) { total += i.final_line_price || 0; orig += i.original_line_price || 0; n += i.quantity || 0; });
    pc.items = items; pc.item_count = n;
    pc.total_price = total; pc.items_subtotal_price = total; pc.original_total_price = orig; pc.total_discount = orig - total;
    pc.cart_level_discount_applications = [];
    pc._predicted = true;
    return pc;
  },
  // Paint where everything on its way lands. Returns false (and leaves the screen alone) when the cart
  // cannot be predicted to the cent.
  _instantPaint: function() {
    var base = this._lastCart, byb = window.DB_BYB;
    // Painting ahead is optional; the tap it paints is not. Whatever goes wrong in here, the tap's own
    // job still runs and the screen falls back to the half-strength wait (review: a throw here would
    // have stopped the stepper's send).
    try {
      if (!base || !byb || !byb.handles || !this._predictable(base)) { this._instantOK = false; this._bfPaint(); return false; }
      var pc = this._predictCart(base);
      if (!pc) { this._instantOK = false; this._bfPaint(); return false; }
      this._instantOK = true;
      this.render(pc);
      return true;
    } catch (e) {
      this._instantOK = false;
      try { console.error('Instant cart paint error:', e); this._bfPaint(); } catch (e2) {}
      return false;
    }
  },
  // A page add (the bundle page's picker). Opens the drawer on the boxes he picked straight away and
  // paints them, the free sixth too when five land one short; the add itself follows. `built` is the
  // page's own bbBuildLines() answer and `last` the scent he tapped last there.
  openInstant: function(built, last) {
    var byb = window.DB_BYB, base = this._lastCart, self = this;
    // Only the loose-box road lands the picker's boxes as these scent lines; anything else adds a line
    // this cannot draw, so it waits for Shopify like before.
    if (!built || !byb || !byb.handles || !this._bybLooseOn()) return false;
    var send = built.bundle ? this._bybLooseLines(1, built.free) : (built.lines || []);
    if (!send || !send.length || send.some(function(l) { return !l.handle || !byb.variants[l.handle]; })) return false;
    // Tracked even when the drawer cannot paint it ahead (a partner code on the cart): checkout waits for it
    // all the same (review 2). Then the add carries no boxes to draw, and the drawer opens when it lands.
    var predictable = !!(base && this._predictable(base));
    // One page add at a time (the page's button is disabled while one is out): a second call for the same
    // add replaces the first instead of leaving an orphan that held checkout until its give-up.
    if (this._pageTok) this._instantDone(this._pageTok);
    var tok = this._instantStart(predictable ? send.map(function(l) { return { h: l.handle, q: l.quantity || 1, props: self._addBody(l.id, 1, null, l.props).properties || {} }; }) : [], 'page');
    this._pageTok = tok;
    // His tap on the page is his latest move: recorded now, so a minus he taps in the drawer before the
    // add lands still wins (the add's own landing does not record it again, see addItems).
    this._bybIntent(1, (last && byb.variants[last]) ? last : '', 'pdp');
    this._pageTouched = true;
    if (!predictable) return false;
    this._bybPlanIfDue();   // five boxes: the free sixth shows with them
    this._openDrawer();
    if (!this._instantPaint()) { if (this._bybAutoPlanned && !this._bybAutoStarted) this._bybAutoPlanned = ''; return false; }
    return true;
  },
  // Big Bastard Bundle card steppers (founder 2026-09-17: "configurable in the cart so they can add and
  // drop scents right before purchase"). The native bundle is a fixed product, so the first tap turns it
  // into its loose boxes: add q of each scent (the tapped one +/-1) through addItems (attribution, test
  // code, rollback on a failed add), then, only once the cart really holds those boxes, drop the bundle
  // line. Buy 2 Get 1 prices the loose boxes the same, and the drawer shows the Build Your Bundle card.
  bbStep: function(handle, delta) {
    var self = this;
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || !byb.handles || this._bbBusy) return;
    var done = function() { self._bbBusy = false; self._opDisarm('bb'); };
    self._bbBusy = true;
    self._opArm('bb', function() { self._bbBusy = false; });
    // His move, recorded when he makes it (the add below does not record it again).
    self._bybIntent(delta > 0 ? 1 : -1, handle, 'bb');
    DB_Cart._cartFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }).then(function(cart) {
      var bb = cart.items.filter(function(i) { return i.handle === 'big-bastard-bundle' && !i.selling_plan_allocation; })[0];
      if (!bb) { done(); self.render(cart); return; }
      var q = bb.quantity, want = {}, lines = [], ok = true;
      byb.handles.forEach(function(h) {
        want[h] = Math.max(0, q + (h === handle ? delta : 0));
        if (want[h] > 0 && !byb.variants[h]) ok = false;
        else if (want[h] > 0 && !self._bbCanAdd(h, cart, 0, want[h])) ok = false;
        if (want[h] > 0 && byb.variants[h]) lines.push({ id: byb.variants[h], quantity: want[h] });
      });
      if (!ok) { done(); self._toast('That scent is out of stock right now.'); return; }
      var singles = function(c) { var m = {}; (c.items || []).forEach(function(i) { if (!i.selling_plan_allocation && byb.variants[i.handle]) m[i.handle] = (m[i.handle] || 0) + i.quantity; }); return m; };
      var before = singles(cart);
      self.addItems(lines, function() {
        DB_Cart._cartFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }).then(function(after) {
          var now = singles(after);
          var landed = byb.handles.every(function(h) { return (now[h] || 0) >= (before[h] || 0) + want[h]; });
          var line = after.items.filter(function(i) { return i.handle === 'big-bastard-bundle' && !i.selling_plan_allocation; })[0];
          if (!landed || !line) { done(); self.render(after); return; }
          return DB_Cart._cartFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
            .then(function(r) { return r.json(); })
            .then(function(c) { done(); self.render(c); });
        }).catch(function() { done(); self.refresh(); });
      }, { src: 'bb', dir: delta, handle: handle, touched: true });
    }).catch(function() { done(); self.refresh(); });
  },
  // Can `extra` more boxes of this scent go in on top of `bundleQty` bundled ones and any loose boxes?
  // The cap (stock and the member reserve floor) counts everything that draws on the scent.
  _bbCanAdd: function(handle, cart, bundleQty, extra) {
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || !byb.variants[handle]) return false;
    if (!byb.caps || typeof byb.caps[handle] !== 'number') return true;
    var inCart = 0;
    ((cart && cart.items) || []).forEach(function(i) { if (i.handle === handle && !i.selling_plan_allocation) inCart += i.quantity; });
    return byb.caps[handle] >= inCart + bundleQty + extra;
  },
  // Remove every one-time scent line. Shopify re-keys split lines after each change, so this
  // re-reads the cart before every removal instead of trusting a list of keys captured up front.
  bybRemoveAll: function() {
    var self = this;
    var byb = window.DB_BYB;
    if (this._removeAllPlan) return;
    this._bybTouch('remove-all', -1, '');
    // Gone from the screen at once; the removals follow (2026-10-09).
    this._removeAllPlan = true;
    var rmSeq = this._rmSeq = this._opSeq();
    this._opArm('rmall', function() { self._removeAllPlan = false; });
    this._instantPaint();
    // ONE job: read, remove, read again until no box is left. As separate requests, a box he added a moment
    // later landed between two of them and the next one removed it too (review 2 finding 8). Anything he
    // adds now queues behind this job and stays.
    this._enqueue(function(f) {
      var guard = 0;
      var step = function() {
        return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }).then(function(cart) {
          var ln = cart.items.filter(function(i) { return byb && byb.variants && byb.variants[i.handle] && !i.selling_plan_allocation; })[0];
          if (!ln || guard++ > 12) return cart;
          return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: ln.key, quantity: 0 }) }).then(function(r) { return r.json(); }).then(step);
        });
      };
      return step();
    }).then(function(cart) {
      self._removeAllPlan = false; self._opDisarm('rmall');
      // A stepper job queued before this one landed first and was removed with the rest: its target is 0.
      // One queued after lands on the empty cart (and on anything queued between): it starts from 0.
      for (var h in self._bfSend) {
        if (!Object.prototype.hasOwnProperty.call(self._bfSend, h)) continue;
        var sentAt = self._bfSend[h] < 0 ? self._bfSendSeq : self._bfAddSeq;
        self._bfBase[h] = (sentAt && sentAt < rmSeq) ? -self._bfSend[h] : 0;
      }
      self.render(cart);
    }, function(e) { console.error('Remove bundle error:', e); self._removeAllPlan = false; self._opDisarm('rmall'); if (self._lastCart) self.render(self._lastCart); self._resync(); });
  },
  updateQty: function(key, qty) {
    var self = this;
    // Which way did the shopper move, and was it a box? The auto-add arms on an increase only.
    // A decrease that lands one short of the free box is a deliberate "no thanks" (_bybTouch).
    // Read from the last painted cart, which is what the button on screen was built from.
    var byb = window.DB_BYB, lc = this._lastCart, prev = null;
    if (lc && lc.items) {
      for (var qi = 0; qi < lc.items.length; qi++) { if (lc.items[qi].key === key) { prev = lc.items[qi]; break; } }
    }
    if (prev && !prev.selling_plan_allocation && byb && byb.variants && byb.variants[prev.handle]) {
      this._bybTouch('qty', qty - prev.quantity, prev.handle);
    }
    DB_Cart._cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { self.render(cart); })
    .catch(function(e) { console.error('Cart update error:', e); });
  },
  // Build one /cart/add.js body with the attribution line properties. Shared by addItem
  // (single line) and addItems (Build Your Bundle: several lines, one drawer open at the end)
  // so lp_variant / creative_code / popup_session never get dropped on a multi-line add.
  // `props` are extra hidden line properties (leading underscore = hidden from the customer and from
  // the order display, but stored on the order). The free box uses them to mark HOW a box got into the
  // cart: _byb_src is tap / slot / auto, and _byb_auto flags the one the cart added by itself.
  //
  // Worth knowing: line properties make lines DISTINCT, so a marked box does NOT merge into an
  // unmarked line of the same scent. That is deliberate here (the free box gets its own line and
  // wears the FREE tag cleanly), and the receipt card already sums per scent across lines, but it is
  // why only the three free-box paths are marked. Marking a generic stepper would split lines for no
  // measurement value.
  _addBody: function(variantId, quantity, sellingPlanId, props) {
    var body = { id: variantId, quantity: quantity || 1 };
    if (sellingPlanId) body.selling_plan = sellingPlanId;
    if (props) {
      for (var pk in props) {
        if (!Object.prototype.hasOwnProperty.call(props, pk)) continue;
        if (props[pk] === null || props[pk] === undefined || props[pk] === '') continue;
        body.properties = body.properties || {};
        body.properties[pk] = String(props[pk]);
      }
    }
    // Hidden properties[...] inputs on the page's product form (the pre-order disclosure) ride along (B-22).
    try {
      document.querySelectorAll('#product-form input[name^="properties["], #bundle-form input[name^="properties["]').forEach(function(inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value) { body.properties = body.properties || {}; body.properties[m[1]] = inp.value; }
      });
    } catch (ePr) {}

    // Read LP variant cookie and attach as cart attribute for attribution.
    // Accepts a/b/c plus named customer-segment ids (e.g. dads-grads).
    var lpMatch = document.cookie.match(/db_variant=([a-z0-9_-]{1,40})/);
    if (lpMatch) {
      body.properties = body.properties || {};
      body.properties['lp_variant'] = lpMatch[1];
    }
    // Bastard Grid creative code (db_creative cookie, set from utm_content on
    // load). Line-item parity with the cart attribute written at DOMContentLoaded,
    // so the code survives even when the cart-level write is missed. Its OWN
    // if-block that re-creates body.properties, for the same reason spelled out
    // for popup_session below: paid traffic frequently has a creative code and NO
    // LP cookie, so assuming body.properties already exists would throw and
    // silently kill add-to-cart for exactly the cohort we paid for.
    var ccM = document.cookie.match(/db_creative=([^;]+)/);
    if (ccM) {
      var ccv = '';
      try { ccv = decodeURIComponent(ccM[1]); } catch (eCa) { ccv = ''; }
      if (ccv) {
        body.properties = body.properties || {};
        body.properties['creative_code'] = ccv;
      }
    }
    // Pop-up session id -> cart attribute for signup->order conversion attribution.
    // Its OWN if-block that re-creates body.properties: a popup signup with no LP
    // cookie must not hit body.properties being undefined (that would throw and
    // silently kill add-to-cart for the ~83% no-LP-cookie popup cohort).
    var sidMatch = document.cookie.match(/db_popup_sid=([a-z0-9_-]{1,64})/);
    if (sidMatch) {
      body.properties = body.properties || {};
      body.properties['popup_session'] = sidMatch[1];
    }

    return body;
  },
  addItem: function(variantId, quantity, sellingPlanId, onSuccess) {
    var self = this;
    // The bundle as three loose boxes (see _bybLooseOn). Every bundle add on the site comes through
    // here: the bundle page, its audience views, the offer page.
    if (!sellingPlanId && this._bybLooseOn() && String(variantId) === String(window.DB_BYB.bundleVariant)) {
      var looseLines = this._bybLooseLines(quantity || 1);
      if (looseLines) { this._bybAddBundleLoose(looseLines, quantity || 1, onSuccess); return; }
    }
    var body = this._addBody(variantId, quantity, sellingPlanId);
    DB_Cart._cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) { return self._okJson(r); })
    .then(function() {
      // A one-time BOX arms. Merch, a subscription box and the bundle do not (see _bybIsBoxVariant).
      // The scent rides along, so a free box this add earns comes in the same scent.
      if (!sellingPlanId && self._bybIsBoxVariant(variantId)) {
        var vh = '', byb0 = window.DB_BYB;
        for (var hh in byb0.variants) { if (Object.prototype.hasOwnProperty.call(byb0.variants, hh) && String(byb0.variants[hh]) === String(variantId)) vh = hh; }
        self._bybTouch('tap', 1, vh);
      }
      self.open();   // open() refreshes; calling refresh() as well cost every add a second cart read and a second repaint
      if (onSuccess) onSuccess();
    })
    .catch(function(e) { console.error('Add to cart error:', e); self._toast((e && e.description) || 'Could not add that to the cart.'); self.refresh(); if (onSuccess) onSuccess(); });
  },
  // A 422 from /cart/add.js (sold out, unpublished) RESOLVES fetch; without this it read as success
  // and the drawer opened unchanged (D-06). Rejects with Shopify's error body so the toast can say why.
  _okJson: function(r) {
    if (r.ok) return r.json();
    return r.json().catch(function() { return {}; }).then(function(body) { var err = new Error(body.description || body.message || ('Cart error ' + r.status)); err.description = body.description || body.message; throw err; });
  },
  _toast: function(msg) {
    try {
      var t = document.getElementById('db-toast');
      if (!t) { t = document.createElement('div'); t.id = 'db-toast'; t.setAttribute('role', 'status'); t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:100000;background:#0D3B23;color:#F5EFE6;font-family:Barlow,Arial,sans-serif;font-size:14px;font-weight:600;padding:12px 18px;border-radius:6px;box-shadow:0 10px 30px rgba(10,36,21,.35);max-width:90vw;text-align:center;'; document.body.appendChild(t); }
      t.textContent = msg; t.style.display = 'block';
      clearTimeout(this._toastTimer); this._toastTimer = setTimeout(function() { t.style.display = 'none'; }, 3200);
    } catch (e) {}
  },
  // BUILD YOUR BUNDLE. Adds every line in ONE /cart/add.js request (items array, each line with the
  // attribution properties), then applies the sandbox test code when one is configured
  // (window.DB_BYB.code; empty on live, where the AUTOMATIC Buy 2 Get 1 discount needs no code), then
  // refreshes and opens the drawer ONCE. lines = [{ id: variantId, quantity: n }].
  // A multi-line add is NOT all-or-nothing on Shopify (tested 2026-09-16: one over-stock line came back
  // 422 "Only 50 items were added..." with BOTH lines in the cart). So the cart is read first, and a failed
  // add is rolled back to those quantities: the shopper never ends up with two paid boxes and no free third.
  // `opts` describes the shopper move for the auto-add: { src, dir, handle }. It defaults to an
  // add (dir 1), which arms the free box. bbStep passes dir -1 when the tap was a MINUS on the
  // bundle card, because that path reaches the same cart by adding loose boxes and is a removal
  // from the shopper's point of view, not a request for more.
  // opts (2026-10-09, the instant cart): `instantTok` the add on its way that this call lands (the bundle
  // page's add finds its own), `touched` true when the tap already recorded itself (_bybIntent), `shift`
  // the boxes per scent this add puts in (see _bfShiftBase), `onLand(ok, cart)` runs in the paint that
  // first shows Shopify's answer. onSuccess(ok) still runs once, after a success or a rolled-back failure.
  addItems: function(lines, onSuccess, opts) {
    var self = this;
    var items = (lines || []).filter(function(ln) { return ln && ln.id && ln.quantity > 0; }).map(function(ln) { return self._addBody(ln.id, ln.quantity, null, ln.props); });
    if (!items.length) { if (onSuccess) onSuccess(); return; }
    var src = opts && opts.src;
    var pageAdd = src === 'pdp' || src === 'bundle';
    var tok = (opts && opts.instantTok) || (pageAdd ? this._pageTok : 0) || 0;
    var pageTapped = pageAdd && this._pageTouched;
    if (pageTapped) this._pageTouched = false;
    // The boxes per scent this add puts in. When it lands, the steppers' own target moves with them, so a
    // number he is still sending never steps back (review 2 finding 3: a page add then a + went 5, 3, 5).
    // Not for the steppers' own add (`own`): those ARE the target.
    var byb0 = window.DB_BYB, shift = null;
    if (!(opts && opts.own) && byb0 && byb0.variants) {
      items.forEach(function(it) {
        if (it.selling_plan) return;
        for (var hh in byb0.variants) { if (Object.prototype.hasOwnProperty.call(byb0.variants, hh) && String(byb0.variants[hh]) === String(it.id)) { shift = shift || {}; shift[hh] = (shift[hh] || 0) + it.quantity; } }
      });
    }
    var land = function(ok) {
      return function(cart) {
        self._instantDone(tok);
        if (ok && cart && shift) self._bfShiftBase(shift);
        if (opts && opts.onLand) { try { opts.onLand(ok, cart); } catch (eL) {} }
      };
    };
    var ids = {}, sent = {};
    items.forEach(function(it) { ids[String(it.id)] = true; if (!it.selling_plan) sent[String(it.id)] = (sent[String(it.id)] || 0) + it.quantity; });
    var qtyOf = function(cart) {
      var m = {};
      (cart.items || []).forEach(function(i) { var k = String(i.variant_id); if (ids[k] && !i.selling_plan_allocation) m[k] = (m[k] || 0) + i.quantity; });
      return m;
    };
    var before = null;
    // Read, add, read again: ONE job, so nothing can land in between. In the first gap a free box the cart
    // added by itself once went in ahead of the shopper's chip, which then rang up as a paid 4th (review
    // finding 1, 2026-10-09). In the second, another tap's read saw this add before the add had taken its
    // own boxes off the screen, and they showed twice for a beat (the free tag hopped scents, found by R3).
    DB_Cart._enqueue(function(f) {
      return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { before = qtyOf(cart); }, function() { before = null; })
        .then(function() {
          return f('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function(r) { return self._okJson(r); })
        .then(function() { return self._bybApplyTestCode(f); })
        .then(function() {
          // The add is in. A failed read here must not undo it: it just means reading again outside.
          return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
            .then(function(r) { return r.json(); })
            .then(function(c) { return (c && c.items) ? c : null; }, function() { return null; });
        }, function(e) {
          // The add failed, or its answer was lost after Shopify took it. Put back what THIS add may have
          // put in, inside this same job and never more than it sent: run outside, the rollback counted a
          // box from his next tap as excess and took that too (review 2 finding 7).
          var undo = before ? self._bybUndo(before, qtyOf, f, sent) : Promise.resolve(false);
          return undo.then(function(undid) { var err = e || new Error('Add failed'); try { err._undid = undid; } catch (eU) {} throw err; },
            function() { throw e; });
        });
    })
      .then(function(after) {
        // Same rule as addItem: only a one-time box arms. A caller that means "this was a removal"
        // (bbStep's minus) passes dir -1 and is honoured whatever it added. A tap that recorded itself
        // when it happened is not recorded again now: he may have tapped since, and his LAST tap decides.
        var dir = (opts && typeof opts.dir === 'number') ? opts.dir : 1;
        var touched = dir < 0 || items.some(function(it) { return !it.selling_plan && self._bybIsBoxVariant(it.id); });
        if (touched && !(opts && opts.touched) && !pageTapped) self._bybTouch(src || 'tap', dir, opts && opts.handle);
        // The boxes shown ahead of time come off in the same paint that shows Shopify's.
        // (Its own handler, not inside the rollback's chain: a throw while painting must never undo an add
        // that landed.)
        try {
          self._openDrawer();
          if (after) { land(true)(after); self.render(after); self._refreshP = Promise.resolve(); }
          else self.refresh(land(true));
        } catch (eP) { console.error('Cart paint error:', eP); }
        if (onSuccess) onSuccess(true);
      }, function(e) {
        console.error('Add to cart error:', e);
        if (self._bybAutoPlanned && !self._bybAutoStarted) self._bybAutoPlanned = '';
        self._toast(e && e._undid ? 'Could not add those boxes. Your cart is unchanged.' : ((e && e.description) || 'Could not add that to the cart.'));
        self.refresh(land(false));
        if (onSuccess) onSuccess(false);
      });
  },
  // Remove lines by what they ARE, reading their key fresh at the moment of removal.
  //
  // Shopify: "the line item key is not persistent for the lifetime of a line item, it changes as
  // characteristics of the line item change." So a key captured at paint time, or captured before a
  // write, is not an identity any more, it is a guess. The swap functions below all did the same
  // thing: capture keys, ADD the bundle, then remove by the pre-add keys. If anything about the
  // scent lines changed in between (a discount re-allocating across them is a characteristic
  // change), the removals 404 silently and the shopper is left holding the bundle AND the boxes it
  // was meant to replace, paying for both.
  //
  // Reproduced 2026-09-18 in the harness with a re-keying fake: 2 boxes plus the bundle, both boxes
  // still there, two changes issued and both missed. Found by applying the other session's sweep
  // test ("identity we wrote, or count we inferred?") and then asking the second half of it: is the
  // identity still FRESH?
  // `cap` (optional, handle -> units) bounds how much of each handle this may take off: what was
  // there BEFORE the write that prompted the removal. Without it, matching on handle is unbounded,
  // and the Big Bastard Bundle is a NATIVE COMPONENT BUNDLE: it records as three scent line items at
  // ORDER level (the counting rule in CLAUDE.md). A real cart shows it as ONE line today, checked by
  // the other session on 2026-09-18, but cart shape and order shape demonstrably differ on this
  // product, so a handle match that trusted the cart shape would delete the bundle's own components
  // the moment that changed. The cap makes the question moot.
  _removeLinesFresh: function(match, f, cap) {
    var fetchIt = f || function(u, o) { return DB_Cart._cartFetch(u, o); };
    var guard = 0, taken = {};
    var step = function() {
      return fetchIt('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var hit = null;
          (cart.items || []).some(function(i) {
            if (!match(i)) return false;
            if (cap) {
              var left = (cap[i.handle] || 0) - (taken[i.handle] || 0);
              if (left <= 0) return false;
            }
            hit = i; return true;
          });
          if (!hit || guard++ > 12) return cart;
          taken[hit.handle] = (taken[hit.handle] || 0) + hit.quantity;
          return fetchIt('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: hit.key, quantity: 0 }) })
            .then(function() { return step(); });
        });
    };
    return step();
  },
  // Remove exactly the line(s) this cart added by itself, identified by the _byb_auto property it
  // wrote. Nothing else.
  //
  // _bybUndo below restores a VARIANT to a prior quantity, which is the right tool for a failed
  // multi-line add but the wrong one here: if a box of the same scent arrives from anywhere else
  // while the job is in flight (a second tab, a chip tap), "restore to before" counts that box as
  // excess and deletes it too. Reproduced 2026-09-18 as part of the unexpected-count check: the
  // rollback took the cart from 4 boxes down to 2 when it should have gone to 3.
  _bybUndoAuto: function(f) {
    var fetchIt = f || function(u, o) { return DB_Cart._cartFetch(u, o); };
    var guard = 0;
    var step = function() {
      return fetchIt('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var mine = (cart.items || []).filter(function(i) { return i.properties && i.properties._byb_auto; });
          if (!mine.length || guard++ > 6) return true;
          return fetchIt('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: mine[0].key, quantity: 0 }) })
            .then(function() { return step(); });
        });
    };
    return step().catch(function() { return false; });
  },
  // Takes the cart back to the one-time quantities in `before` (variant id -> qty) for the variants a
  // failed addItems touched. Re-reads the cart before every change (Shopify re-keys split lines).
  // Resolves true when it removed anything.
  // `cap` (optional, variant id -> units) is the most this undo may remove of each variant: exactly
  // what the caller added. Without it this restores a variant to its `before` quantity, which is the
  // right tool for a failed multi-line add and the WRONG one whenever a box of the same scent can
  // arrive from somewhere else mid-flight (a second tab, a chip tap). "Restore to before" counts
  // that box as excess and deletes it. That mistake has now appeared three times in this file, each
  // time from inferring what we added out of quantities instead of bounding it by what we sent.
  _bybUndo: function(before, qtyOf, f, cap) {
    var guard = 0, undid = false, removed = {};
    var fetchIt = f || function(u, o) { return DB_Cart._cartFetch(u, o); };
    var step = function() {
      return fetchIt('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var now = qtyOf(cart), target = null, excess = 0;
          Object.keys(now).some(function(k) {
            var ex = now[k] - (before[k] || 0);
            if (cap) { ex = Math.min(ex, (cap[k] || 0) - (removed[k] || 0)); }
            if (ex > 0) { target = k; excess = ex; return true; }
            return false;
          });
          if (!target || guard++ > 12) return undid;
          var lines = cart.items.filter(function(i) { return String(i.variant_id) === target && !i.selling_plan_allocation; });
          // Take the line WE marked first. This used to take the last line of the variant, which is a
          // guess: line properties keep the auto line separate from the shopper's line of the same
          // scent, so on a cart holding both, the rollback deleted the box the shopper had just added
          // and sometimes left the auto one behind as a paid $24.99 line. Reproduced 2026-09-18.
          var marked = lines.filter(function(i) { return i.properties && i.properties._byb_auto; });
          var pool = marked.length ? marked : lines;
          var ln = pool[pool.length - 1];
          // Never take more off one line than that line holds, and never more than the excess.
          excess = Math.min(excess, ln.quantity);
          removed[target] = (removed[target] || 0) + excess;
          return fetchIt('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: ln.key, quantity: Math.max(0, ln.quantity - excess) }) })
            .then(function(r) { if (r.ok) undid = true; return step(); });
        });
    };
    return step().catch(function() { return undid; });
  },
  // SANDBOX ONLY (window.DB_BYB.code is empty on live). Puts the test code on the cart NEXT TO the codes
  // already there (the silent SHIPSONUS, a partner code), so the preview prices the way the automatic will.
  _bybApplyTestCode: function(f) { return this._applyTestCode(window.DB_BYB && window.DB_BYB.code, f); },
  // The same for any sandbox test code (the mystery gift's is window.DB_GIFT.code, also empty on live).
  _applyTestCode: function(code, f) {
    if (!code) return Promise.resolve();
    var fetchIt = f || function(u, o) { return DB_Cart._cartFetch(u, o); };
    return fetchIt('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var onCart = (cart.discount_codes || []).map(function(d) { return String(d.code || ''); }).filter(Boolean);
        if (onCart.some(function(c) { return c.toUpperCase() === code.toUpperCase(); })) return;
        // A code applied by link can still sit only in the discount_code cookie; keep it too.
        var fromCookie = [];
        var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
        if (m) { var ck = ''; try { ck = decodeURIComponent(m[1]); } catch (e) { ck = ''; } ck.split(',').forEach(function(c) { c = c.trim(); if (c) fromCookie.push(c); }); }
        var seen = {}, list = [];
        onCart.concat(fromCookie, [code]).forEach(function(c) { var k = c.toUpperCase(); if (!seen[k]) { seen[k] = true; list.push(c); } });
        return fetchIt('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) });
      })
      .catch(function() {});
  },
  // Is this discount the free box, rather than some other discount that happens to take money off?
  // Matched on the allocation's title.
  //   LIVE: the automatic is titled exactly "Buy 2, Get 1 Free" (read off
  //   DiscountAutomaticNode/1271418028193 on 2026-09-18, not guessed). It is deliberately parked at
  //   startsAt 2027-01-01 and moves to now at launch.
  //   SANDBOX: the stand-in test code BYBT-NVDOQQ5ERE has a long admin title, "BYB TEST (hidden,
  //   2026-09-16): buy 2 scent singles get 1 free, ...". What cart.js reports as the title for a
  //   CODE discount (the code, or that admin title) is UNVERIFIED, so both are covered: the phrase
  //   "get 1 free" appears in each, and the configured code is matched exactly as well.
  // Anything else is a different offer. A percent code (HALFOFF, a creator code) matches nothing here,
  // which is the whole point: it must never read as a free box.
  _bybIsFreeBoxDiscount: function(title) {
    var t = String(title || '');
    if (!t) return false;
    if (/get\s*1\s*free/i.test(t)) return true;
    var up = t.toUpperCase(), byb = window.DB_BYB, i;
    if (byb && byb.code && up === String(byb.code).toUpperCase()) return true;
    // Settable from the Theme Editor (byb_free_titles). This is the no-code escape hatch for the one
    // hard coupling left in this feature: the free box is identified by a string a human types into
    // the Shopify admin. Rename the automatic there and every FREE tag silently disappears, every
    // auto-add rolls back, and the bar stands down, with no error anywhere. If that happens, add the
    // new title here rather than waiting on a theme deploy. Measured 2026-09-18: for a CODE discount
    // the title Shopify reports is the CODE itself, not the discount's admin title.
    var extra = (byb && byb.freeTitles) || [];
    for (i = 0; i < extra.length; i++) { if (extra[i] && up === String(extra[i]).toUpperCase()) return true; }
    return false;
  },
  // Whole boxes the FREE-BOX discount took off one cart line.
  //
  // Read from line_level_discount_allocations, so only the free box counts. The old whole-box math
  // (line original minus line final, over the unit price) cannot tell the free box apart from any
  // other discount that lands on a round number: a 50%-off code on TWO boxes takes off exactly one
  // box price and used to read as "1 FREE", which would put a FREE tag on a box Shopify charged for
  // (founder 2026-09-18: the drawer may never do that) and would fool the step-3 rollback check into
  // keeping a box that was never free.
  //
  // When allocations are present but NONE of them is the free box, the answer is 0, deliberately: the
  // money off this line came from something else. The whole-box math stays only as the fallback for a
  // payload that carries no allocation detail at all.
  _bybFreeUnits: function(item) {
    var unit = item.original_price || ((item.original_line_price || 0) / Math.max(1, item.quantity || 1));
    if (unit <= 0) return 0;
    var whole = function(off) {
      if (off <= 0) return 0;
      var n = Math.round(off / unit);
      return (n >= 1 && Math.abs(off - n * unit) < 2) ? n : 0;
    };
    // An EMPTY array is Shopify positively saying no line-level discount touched this line, so it
    // must read as zero, not fall through to the whole-box math this function exists to replace.
    // Measured on a real cart 2026-09-18: Shopify puts an allocation on every ENTITLED line, with
    // amount 0 on the ones it did not discount, and no allocations at all on a line the discount
    // does not entitle (the coverage add-on came back with []).
    var allocs = item.line_level_discount_allocations;
    if (allocs) {
      var off = 0, otherOff = 0, saw = false;
      for (var i = 0; i < allocs.length; i++) {
        var a = allocs[i] || {};
        var t = (a.discount_application && a.discount_application.title) || '';
        if (this._bybIsFreeBoxDiscount(t)) { off += (a.amount || 0); saw = true; }
        else { otherOff += (a.amount || 0); }
      }
      if (!saw) return 0;
      // Measure against the price the free box was actually costed at, not the sticker price. When
      // the free box STACKS with a percent code (a partner <handle>15, BACKER15), Shopify computes
      // the 100%-off on the ALREADY-DISCOUNTED unit, so the allocation is e.g. 2124 rather than 2499
      // and the exact-multiple test called a genuinely free box "not free". The cart then rolled a
      // real free box back out and stood the offer down, silently switching the feature off for the
      // partner-code cohort, which is the cohort most likely to convert.
      var qty = Math.max(1, item.quantity || 1);
      var effUnit = Math.max(1, ((item.original_line_price || 0) - otherOff) / qty);
      var n = Math.round(off / effUnit);
      if (n >= 1 && Math.abs(off - n * effUnit) < 2 * qty) return n;
      return whole(off);   // unstacked carts still take the exact sticker-price path
    }
    return whole((item.original_line_price || 0) - (item.final_line_price || 0));
  },
  // Free boxes across the whole cart. One-time scent lines only, same rule as _bybBoxes.
  _bybFreeTotal: function(cart) {
    var byb = window.DB_BYB, n = 0;
    if (!byb || !byb.variants || !cart || !cart.items) return 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!it.selling_plan_allocation && byb.variants[it.handle]) n += this._bybFreeUnits(it);
    }
    return n;
  },
  // The identity of a cart state for the once-only add guard. It carries the DISCOUNT CODES as well
  // as the box count, and that is load bearing in both directions:
  //   it stops the loop, because a cart whose code oscillates around an order minimum returns to a
  //     state already tried, instead of looking new every cycle, and
  //   it allows the honest retry, because a shopper who removes the code that was beating the free
  //     box is genuinely in a new state and deserves another attempt.
  // Keyed on token + boxes alone, one of those two had to give: clearing the map on every code change
  // gave 60 adds in 2.5 seconds, and never clearing it left an unblocked cart permanently unable to
  // get its box. Both reproduced 2026-09-18.
  _bybTriedKey: function(cart, boxes) {
    return (cart && cart.token ? cart.token : '') + ':' + boxes + ':' + this._bybCodeKey(cart);
  },
  // How many free boxes this cart is SHORT of what Buy 2 Get 1 owes it: one free box per three
  // one-time boxes, with no per-order cap (the PRD). Zero means the discount is fully applying.
  //
  // This replaced a before/after comparison of cart totals, which a box the shopper added mid-job
  // could fool: that box supplied the free unit, the job credited it to its own box, and the cart
  // ended at 4 boxes and $74.97 with one free and nothing blocked. An invariant on the cart as it
  // stands cannot be fooled that way, and it works on a path that has no "before" at all, which is
  // what lets the shopper-tapped paths use the same check.
  _bybFreeShortfall: function(cart) {
    var owed = Math.floor(this._bybBoxes(cart) / 3);
    return Math.max(0, owed - this._bybFreeTotal(cart));
  },
  // The cart's discount codes as one comparable string, so a change in them can un-block the offer.
  _bybCodeKey: function(cart) {
    return ((cart && cart.discount_codes) || []).map(function(d) { return String((d && d.code) || '').toUpperCase(); })
      .sort().join(',');
  },
  // A verified add came back NOT free, so this cart cannot take the free box (a code that beats it,
  // the automatic missing). Stand the whole offer bar down rather than keep pitching something
  // checkout will not honour, and clear it the moment the cart's codes change.
  _bybUnblock: function(cart) {
    if (!this._bybBlocked) return;
    if (this._bybBlockedCodes === this._bybCodeKey(cart)) return;
    this._bybBlocked = false;
    this._bybBlockedCodes = '';
    // _bybTried is NOT cleared here. It used to be, and that removed the only bound on the add loop:
    // a cart carrying an order-level MINIMUM code (MOVEIN at $49.98, SHIPSFREE at $35) oscillates, the
    // add clears the minimum so the code applies and beats the free box, the box rolls back, the cart
    // drops under the minimum, the code vanishes, the code key changed so this unblocked and wiped the
    // guard, and it added again. 60 adds in 2.5 seconds against a live cart. Reproduced 2026-09-18.
    // Un-blocking is enough on its own: a genuinely new cart state has a different key and is free to try.
  },
  // May the drawer offer one more one-time box of this scent? Its cap (stock and the member reserve
  // floor, window.DB_BYB.caps from snippets/byb-cap) must be above what the cart already holds.
  //
  // This uses `>` and _bbCanAdd below uses `>=`, which looks like a disagreement and is not: this
  // asks "can the total become inCart + 1" (caps > inCart is caps >= inCart + 1), while _bbCanAdd is
  // handed the TOTAL it wants and asks whether that total is allowed. Same rule, two phrasings.
  // Reviewed 2026-09-18; do not "align" them.
  _bybCanAdd: function(handle, cart) {
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || !byb.variants[handle]) return false;
    if (!byb.caps || typeof byb.caps[handle] !== 'number') return true;
    var inCart = 0;
    var c = cart || this._lastCart;
    if (c && c.items) c.items.forEach(function(i) { if (i.handle === handle && !i.selling_plan_allocation) inCart += i.quantity; });
    return byb.caps[handle] > inCart;
  },
  // Verify a cart AFTER a shopper-tapped add that promised a free box, and put it back if the promise
  // did not hold.
  //
  // The verify-and-roll-back safety net used to live ONLY on the path the shopper did not ask for.
  // The two buttons the offer bar actually puts in front of them, the one-tap CTA and the slot chips,
  // went through addItems, which checks nothing. So on any cart carrying a code that beats Buy 2 Get 1
  // the drawer showed a box struck to $0.00, the shopper tapped, and paid $24.99 for it, with no
  // rollback, no message, and the bar simply going blank. Reproduced 2026-09-18: $49.98 to $74.97.
  //
  // `before` is the variant-quantity snapshot taken before the add, same shape _bybUndo takes.
  _bybVerifyTapped: function(before, qtyOf, added) {
    var self = this, ended = false;
    // Checkout waits for this proof too (it can take the box back off), with a give-up of its own.
    this._verifyN++;
    var end = function() { if (ended) return; ended = true; clearTimeout(cap); self._verifyN = Math.max(0, self._verifyN - 1); };
    var cap = setTimeout(function() { end(); if (self._lastCart) self.render(self._lastCart); }, this._QUEUE_MS + 1000);
    return this._enqueue(function(f) {
      return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(after) {
          if (self._bybFreeShortfall(after) === 0) return null;
          // The offer cannot be honoured on this cart. Undo the shopper's tap, stand the bar down,
          // and SAY SO: this is the one place silence is wrong, because a price just went up.
          self._bybBlocked = true;
          self._bybBlockedCodes = self._bybCodeKey(after);
          return self._bybUndo(before, qtyOf, f, added)
            .then(function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
            .then(function(r) { return r.json(); });
        });
    }).then(function(c) {
      end();
      if (c) {
        self._toast('Your discount code beats the free box, so we left your cart as it was.');
        self.render(c);
      } else if (self._lastCart) self.render(self._lastCart);   // proven: now the free box may decide, and a removal be judged
    }, function(e) { end(); console.error('Free box verify error:', e); if (self._lastCart) self.render(self._lastCart); self._resync(); });
  },
  // The variant-quantity snapshot helper the tapped paths share with the auto path.
  _bybQtyOf: function(ids) {
    return function(cart) {
      var m = {};
      ((cart && cart.items) || []).forEach(function(i) {
        var k = String(i.variant_id);
        if (ids[k] && !i.selling_plan_allocation) m[k] = (m[k] || 0) + i.quantity;
      });
      return m;
    };
  },
  // Free-box nudge chip: add ONE box of that scent (one-time), attribution included.
  addFreeBox: function(handle, btn) {
    var byb = window.DB_BYB;
    if (!byb || !byb.variants || !byb.variants[handle]) return;
    if (!this._bybCanAdd(handle) || this._pendingSlot) return;
    // The cart is already adding the free box: a chip now would be a 4th box at full price.
    if (this._bybAdding || this._bybAutoPlanned) { if (this._lastCart) this.render(this._lastCart); return; }
    var self = this;
    var ids = {}; ids[String(byb.variants[handle])] = true;
    var qtyOf = this._bybQtyOf(ids);
    var before = qtyOf(this._lastCart);
    var added = {}; added[String(byb.variants[handle])] = 1;   // exactly one box, and never more
    // On screen at once; the add and its free-box proof follow (2026-10-09).
    this._pendingSlot = handle;
    this._slotSeq = this._opSeq();
    this._opArm('slot', function() { self._pendingSlot = ''; });
    this._bybIntent(1, handle, 'slot');
    // Not predictable: the bar is painted again from Shopify's cart, showing the free box adding (no chips).
    if (!this._instantPaint() && this._lastCart) this._paintOffer(this._lastCart);
    this.addItems([{ id: byb.variants[handle], quantity: 1, props: { _byb_src: 'slot' } }], function(ok) {
      // The chip is labelled $0.00, so prove it before the shopper reaches checkout.
      if (ok !== false && self._bybAuto()) self._bybVerifyTapped(before, qtyOf, added);
    }, { src: 'slot', handle: handle, touched: true, onLand: function() { self._pendingSlot = ''; self._opDisarm('slot'); } });
  },
  // Swap the single one-time box (DB_Cart._unlockBox) to its scent's 8-week subscription.
  makeItSubscription: function() {
    var self = this;
    var box = this._unlockBox;
    if (!box) return;
    var map = window.DB_SUB_PLANS && window.DB_SUB_PLANS[box.handle];
    if (!map || !map.plan) return;
    // Primary: change the line's selling plan in place (price recomputes to the sub price).
    DB_Cart._cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: box.key, quantity: 1, selling_plan: map.plan })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var applied = cart.items && cart.items.some(function(i) { return i.selling_plan_allocation; });
      if (applied) { self.render(cart); self.open(); }
      else { self._subSwapFallback(box, map); }
    })
    .catch(function() { self._subSwapFallback(box, map); });
  },
  // Fallback if /cart/change.js won't attach the plan: remove the one-time line, re-add as a sub.
  _subSwapFallback: function(box, map) {
    var self = this;
    DB_Cart._cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: box.key, quantity: 0 })
    })
    .then(function() { self.addItem(map.variant, 1, map.plan); })
    .catch(function(e) { console.error('Sub swap error:', e); });
  },
  // Replace the single box with the Big Bastard Bundle (cart ends as just the bundle).
  makeItBundle: function() {
    var self = this;
    var box = this._unlockBox;
    var bundleVariant = window.DB_BUNDLE_VARIANT;
    if (!bundleVariant) return;
    DB_Cart._cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: bundleVariant, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Same stale-key trap: this removal happens AFTER the bundle add, so match the line fresh.
      if (box && box.handle) {
        var oneCap = {}; oneCap[box.handle] = box.quantity || 1;
        return self._removeLinesFresh(function(i) { return i.handle === box.handle && !i.selling_plan_allocation; }, null, oneCap);
      }
    })
    .then(function() { self.refresh(); self.open(); })
    .catch(function(e) { console.error('Bundle swap error:', e); });
  },
  // Replace 2+ one-time scent singles (DB_Cart._multiScentKeys, set in render) with the single Big
  // Bastard Bundle: add the bundle, then zero out each scent line so the cart ends as just the bundle.
  makeItBundleFromScents: function() {
    var self = this;
    var keys = this._multiScentKeys || [];
    var bundleVariant = window.DB_BUNDLE_VARIANT;
    if (!bundleVariant) return;
    DB_Cart._cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: bundleVariant, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Match on the SCENT LINES as they are now, not on the keys captured before the add.
      var want = {}, cap = null;
      keys.forEach(function(k) {
        if (k && k.handle) {
          want[k.handle] = true;
          cap = cap || {};
          cap[k.handle] = (cap[k.handle] || 0) + (k.quantity || 1);
        }
      });
      return self._removeLinesFresh(function(i) {
        if (i.selling_plan_allocation) return false;
        if (i.handle === 'big-bastard-bundle') return false;
        return Object.keys(want).length ? !!want[i.handle] : !!(window.DB_SUB_PLANS && window.DB_SUB_PLANS[i.handle]);
      }, null, cap);
    })
    .then(function() { self.refresh(); self.open(); })
    .catch(function(e) { console.error('Multi-scent bundle swap error:', e); });
  },
  // Ship Happens Coverage opt-out flag. Coverage is pre-selected, so we persist a per-visitor opt-out:
  // once someone unchecks it, render() must NOT auto-add it back (an un-removable pre-checked charge is
  // the FTC negative-option trap). Re-checking clears the flag. localStorage is wrapped in try/catch so
  // private-mode / disabled-storage browsers degrade to "not opted out" rather than throwing.
  _protectOptedOut: function() {
    // In-memory fallback FIRST: if storage is blocked (privacy mode / extension), we still must honor an
    // uncheck this session, or render() would re-add coverage right after removal (un-removable charge).
    if (this._protectOptoutMem) { return true; }
    try { return localStorage.getItem('db_ship_protect_optout') === '1'; } catch (e) { return false; }
  },
  _setProtectOptout: function(optedOut) {
    this._protectOptoutMem = !!optedOut;
    try {
      if (optedOut) { localStorage.setItem('db_ship_protect_optout', '1'); }
      else { localStorage.removeItem('db_ship_protect_optout'); }
    } catch (e) {}
  },
  // THE one definition of which selling plan coverage should carry RIGHT NOW: the coverage plan whose
  // frequency matches whatever subscription box is in the cart, or null when the cart holds no sub box.
  // Both the add path (_addProtection) and the repair path (_syncProtectPlan) read this, so coverage can
  // never be added under one rule and then judged under another.
  // Returns { plan: <id string|null>, evaluable: <bool> }. evaluable is false only when a sub box is in
  // the cart but the coverage plan map came back empty (Liquid rendered no plans): we cannot tell what
  // coverage SHOULD be on, so callers leave the line alone instead of stripping a correct plan off a
  // real subscriber.
  _desiredProtectPlan: function(cart) {
    var vid = window.DB_SHIP_PROTECT && window.DB_SHIP_PROTECT.variant;
    var map = window.DB_SHIP_PROTECT_PLANS || {};
    var hasMap = false;
    for (var k in map) { if (Object.prototype.hasOwnProperty.call(map, k)) { hasMap = true; break; } }
    var subBoxSeen = false;
    for (var j = 0; j < cart.items.length; j++) {
      var bx = cart.items[j];
      if (!bx.selling_plan_allocation || String(bx.variant_id) === vid) { continue; }
      subBoxSeen = true;
      var bn = (bx.selling_plan_allocation.selling_plan && bx.selling_plan_allocation.selling_plan.name) || '';
      var bw = bn.match(/\d+/);
      if (bw && map[bw[0]]) { return { plan: String(map[bw[0]]), evaluable: true }; }
    }
    if (subBoxSeen && !hasMap) { return { plan: null, evaluable: false }; }
    return { plan: null, evaluable: true };
  },
  // Add the hidden $1.98 coverage variant on whatever plan _desiredProtectPlan says it needs (a
  // matching-frequency plan when a subscription box is present, otherwise a plain one-time line).
  // Returns the /cart/add.js fetch promise.
  _addProtection: function(cart, f) {
    var self = this, vid = window.DB_SHIP_PROTECT.variant;
    var body = function(c) {
      var planId = self._desiredProtectPlan(c).plan;
      var addItem = planId ? { id: parseInt(vid, 10), quantity: 1, selling_plan: parseInt(planId, 10) } : { id: parseInt(vid, 10), quantity: 1 };
      return { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [addItem] }) };
    };
    // `f` is the job-scoped fetch when called from inside an _enqueue job (the coverage plan repair, which
    // has just removed the line itself).
    if (f) return f('/cart/add.js', body(cart));
    // Outside a job: read and add as ONE job, and add nothing if a coverage line is already there. Two
    // paths that each decided "no coverage yet" from an older read added one each: $1.98 x2 (review 2
    // finding 10). The answer looks like the add's, so callers read it the same way.
    return DB_Cart._enqueue(function(jf) {
      return jf('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(c) {
          var has = ((c && c.items) || []).some(function(i) { return String(i.variant_id) === String(vid); });
          if (has) return { ok: true, status: 200, json: function() { return Promise.resolve({}); } };
          return jf('/cart/add.js', body(c || cart));
        });
    });
  },
  // Coverage's plan used to be decided ONCE, when the line was added, from whatever box sat in the cart
  // at that instant, and was never looked at again. Switch the box from Subscribe to One-Time afterwards
  // and the coverage line kept the stale plan, so checkout opened a recurring $1.98 with no box behind it
  // (order #2064, 2026-09-18: one-time Amber Canyon + coverage on a 10 Week Subscription). Re-check the
  // line against the cart and rebuild it when the two disagree.
  // Runs at most once per page load (_protectSyncing / _protectSynced) so a repeated or failed repair can
  // never loop the drawer. Returns a promise resolving to the fixed cart, or null when nothing to do.
  _syncProtectPlan: function(cart) {
    if (!window.DB_SHIP_PROTECT || this._protectSyncing || this._protectSynced) { return null; }
    var vid = window.DB_SHIP_PROTECT.variant, cov = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === vid) { cov = cart.items[i]; break; }
    }
    if (!cov) { return null; }
    var want = this._desiredProtectPlan(cart);
    if (!want.evaluable) { return null; }
    var cur = (cov.selling_plan_allocation && cov.selling_plan_allocation.selling_plan && String(cov.selling_plan_allocation.selling_plan.id)) || null;
    if (cur === want.plan) { return null; }
    var self = this;
    this._protectSyncing = true;
    this._opArm('protSync', function() { self._protectSyncing = false; self._protectSynced = true; });
    // The remove and the re-add are one read-then-write job, so they hold the lane together: nothing may
    // slip a cart write between them, which is exactly the case _enqueue exists for. Rebuild rather than
    // patch the line, because /cart/change.js will not reliably DROP a selling plan.
    return this._enqueue(function(f) {
      // Plumbing only, logic untouched: a job must use the fetch _enqueue hands it, or it waits on
      // the lane it is itself holding. See _cartFetch. (Changed 2026-09-18 alongside the queue fix.)
      return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: cov.key, quantity: 0 }) })
        .then(function(r) { return r.json(); })
        .then(function(c) { return self._addProtection(c, f); })
        .then(function() { return f('/cart.js'); })
        .then(function(r) { return r.json(); });
    })
      .then(function(c) { self._protectSyncing = false; self._protectSynced = true; self._opDisarm('protSync'); return c; })
      .catch(function(e) {
        // Leave the cart alone. A stale plan still checks out, and looping a repair on a live cart is
        // worse than one wrong $1.98 plan we can see and cancel from the Recharge side.
        console.error('Coverage plan sync error:', e);
        self._protectSyncing = false; self._protectSynced = true; self._opDisarm('protSync');
        return null;
      });
  },
  // Ship Happens Coverage toggle: add/remove the coverage line and remember the choice so the
  // pre-selected default is respected on later renders.
  toggleProtection: function(checked) {
    var self = this;
    if (!window.DB_SHIP_PROTECT) return;
    var vid = window.DB_SHIP_PROTECT.variant;
    self._setProtectOptout(!checked);
    // The total moves the moment the box is ticked or unticked (2026-10-09); checkout waits for Shopify.
    self._protectWant = !!checked;
    self._instantPaint();
    // One toggle job at a time. A second tap while one runs only changes what he wants; the running job
    // reads the cart again and applies his LATEST wish before it finishes (two jobs at once could each
    // add a line: coverage x2).
    if (self._protectToggling) { self._protectAgain = true; return; }
    self._protectToggling = true;
    self._opArm('protect', function() { self._protectWant = undefined; self._protectToggling = false; self._protectAgain = false; });
    var finish = function(c) {
      self._protectWant = undefined; self._protectToggling = false; self._protectAgain = false; self._opDisarm('protect');
      if (c) { self.render(c); return; }
      // It did not go through: show the cart as it last was (his tick goes back) and read it again until it answers.
      if (self._lastCart) self.render(self._lastCart);
      self._resync();
    };
    // Read and write as ONE job, so the line it removes or the "no coverage yet" it adds against is the cart
    // as it stands, not as it stood before another add landed.
    var run = function() {
      self._protectAgain = false;
      var want = self._protectWant !== false;
      return DB_Cart._enqueue(function(f) {
        return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r) { return r.json(); }).then(function(cart) {
          var line = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === vid) { line = cart.items[i]; break; }
          }
          if (want) {
            if (line) return cart;
            return self._addProtection(cart, f)
              .then(function() { return f('/cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
              .then(function(r) { return r.json(); });
          }
          if (!line) return cart;
          return f('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
            .then(function(r) { return r.json(); });
        });
      }).then(function(c) {
        if (self._protectAgain) return run();
        finish(c && c.items ? c : null);
      });
    };
    run().catch(function(e) {
      console.error('Coverage toggle error:', e);
      // Say so, and take his choice back too, so the next add does not act on a change that never happened.
      self._setProtectOptout(!!checked);
      self._toast('Could not change Ship Happens. Try again.');
      finish(null);
    });
  }
};

// Every repaint puts the tapped numbers back on top of Shopify's (see "LIKE BUTTER" above).
(function() {
  var paint = DB_Cart.render;
  DB_Cart.render = function() { var out = paint.apply(this, arguments); try { this._bfPaint(); } catch (e) {} return out; };
})();
function openCart() { DB_Cart.open(); }
function closeCart() { DB_Cart.close(); }
// SAFETY NET: guarantee the drawer Checkout button always has a valid destination, even if a
// stale cached layout rendered an empty href. Target is window.DB_CHECKOUT_HREF, set by
// DB_Cart.render (now always /checkout: the free-ship-for-email capture is inline in the drawer,
// so the old /cart reroute is retired); the click reads it live so render timing never matters.
// This JS loads as an asset, so it repairs the button regardless of full-page cache state.
// Is the cart mid-write, so that leaving right now would take the shopper somewhere wrong?
//   _bybAdding      the free box is added but not yet verified, and the rollback has not run.
//   _protectSyncing the coverage line is being rebuilt. Measured 2026-09-18: for ~420ms of that
//                   window there is NO coverage line in the cart at all, and before it the line is
//                   still on a STALE SUBSCRIPTION PLAN, which is exactly how order #2064 became a
//                   standalone $1.98 Recharge subscription with no box behind it.
function dbCheckoutBusy(){
  // Taps he has made that the cart has not answered yet count too: leaving now would check out the old cart.
  // So do boxes already painted on screen and still on their way (the instant cart, 2026-10-09): a free
  // box the cart has decided to add, a page add, a chip, a swap, a remove-all, the coverage toggle.
  //   _giftBusy       the mystery gift is going on or coming off; leaving mid-write could check out without it.
  return !!(window.DB_Cart && (DB_Cart._bybAdding || DB_Cart._protectSyncing || DB_Cart._giftBusy || DB_Cart._bfBusy || DB_Cart._bfHasPending() ||
    DB_Cart._bybAutoPlanned || DB_Cart._instantOps.length || DB_Cart._pendingSlot || DB_Cart._swapPlan || DB_Cart._removeAllPlan || DB_Cart._protectToggling ||
    DB_Cart._verifyN > 0 || DB_Cart._protectAdding || DB_Cart._protectDropping || DB_Cart._protectTrimming || DB_Cart._bbBusy || DB_Cart._bundleLooseBusy));
}
// DEFER the tap, never drop it.
//
// The first version of this guard just returned, with e.preventDefault already called. The button
// looked completely normal and silently ate a tap for about a second: the shopper taps, nothing
// happens, they tap again. That is worse than either leaving it live or grasping the nettle and
// disabling it. So the intent is stashed and honoured as soon as the cart settles.
//
// aria-busy rather than a disabled look: assistive tech is told something is in progress, and the
// button does not turn grey and read as unavailable.
var _dbCheckoutPending = false;
var _dbCheckoutTick = null;
function dbCheckoutNow(btn){
  var href = window.DB_CHECKOUT_HREF || '/checkout';
  // The free box waits for him to pause; Checkout IS the pause. Decide it now (review finding 5).
  try { if (window.DB_Cart && DB_Cart._bybDecideNow) DB_Cart._bybDecideNow(); } catch (eD) {}
  if (!dbCheckoutBusy()) { window.location.href = href; return; }
  if (_dbCheckoutPending) return;            // a second tap joins the first, it does not queue twice
  _dbCheckoutPending = true;
  if (btn && btn.setAttribute) btn.setAttribute('aria-busy', 'true');
  // SAY SO (2026-10-09). The drawer now paints a tap at once and saves it behind the scenes, so a fast
  // shopper can reach Checkout while that save is still going (a page add plus its free box is a few
  // round trips). A button that sits there looks broken; this one answers the finger.
  if (btn && btn.classList) { btn.classList.add('is-saving'); try { btn.setAttribute('data-label', btn.textContent); btn.textContent = 'Saving your cart...'; } catch (eL) {} }
  var waited = 0;
  clearInterval(_dbCheckoutTick);
  var tick = _dbCheckoutTick = setInterval(function(){
    waited += 100;
    // The cap is a backstop, not a plan. If the cart somehow never settles, a shopper who has been
    // waiting that long is better served by going to checkout than by a dead button. It sits just past
    // the cart's own give-up (_QUEUE_MS, after which every flag lets go by itself): at 8s, a burst of
    // taps on a slow phone left for checkout with half of them still saving (the review's fuzzer, 2026-10-09).
    if (!dbCheckoutBusy() || waited >= ((window.DB_Cart && DB_Cart._QUEUE_MS) || 15000) + 2000) {
      clearInterval(tick);
      _dbCheckoutPending = false;
      if (btn && btn.removeAttribute) btn.removeAttribute('aria-busy');
      window.location.href = href;
    }
  }, 100);
}
function dbWireCheckout(){
  var btns = document.querySelectorAll('.cart-checkout-btn');
  for (var i = 0; i < btns.length; i++){
    var b = btns[i];
    var t = b.getAttribute('href');
    if (t !== '/checkout' && t !== '/cart') { b.setAttribute('href', window.DB_CHECKOUT_HREF || '/checkout'); }
    if (!b.getAttribute('data-db-wired')){
      b.setAttribute('data-db-wired', '1');
      b.addEventListener('click', function(e){
        e.preventDefault();
        dbCheckoutNow(this);
      });
    }
  }
}
if (document.readyState !== 'loading') { dbWireCheckout(); } else { document.addEventListener('DOMContentLoaded', dbWireCheckout); }
// Back from checkout (Safari's back-forward cache restores the page as it was left): put the button back.
window.addEventListener('pageshow', function(e) {
  if (!e.persisted) return;
  // A wait still running from before he left must not send him to checkout now (review), and the cart
  // may have changed while he was away (an order placed empties it), so read it again.
  clearInterval(_dbCheckoutTick); _dbCheckoutTick = null;
  try { if (window.DB_Cart) DB_Cart.refresh(); } catch (eR) {}
  _dbCheckoutPending = false;
  var bs = document.querySelectorAll('.cart-checkout-btn.is-saving');
  for (var i = 0; i < bs.length; i++) { bs[i].classList.remove('is-saving'); bs[i].removeAttribute('aria-busy'); if (bs[i].getAttribute('data-label')) bs[i].textContent = bs[i].getAttribute('data-label'); }
});

// ---- EMAIL POPUP ----
// ---- EMAIL POPUP: removed 2026-09-09 (the #email-popup markup was deleted long ago; the laundry game owns capture). openPopup stays as a shim for pre-launch inline handlers. ----
function openPopup() { if (typeof openLaundryGame === 'function') openLaundryGame(); }
function closePopupDirect() {}
function closePopup() {}
function submitPopup() {}

// ---- FAQ ----
function toggleFaq(btn) {
  var answer = btn.nextElementSibling;
  var isOpen = answer.classList.contains('open');
  document.querySelectorAll('.faq-a').forEach(function(a) { a.classList.remove('open'); });
  document.querySelectorAll('.faq-q').forEach(function(q) { q.classList.remove('open'); });
  if (!isOpen) {
    answer.classList.add('open');
    btn.classList.add('open');
  }
}

// ---- COLLAPSIBLE PDP SECTIONS (pdp-howto: used by product.liquid AND pdp-bundle-core templates) ----
function togglePdpSection(btn) {
  var body = btn.nextElementSibling;
  var arrow = btn.querySelector('.pdp-collapse-arrow');
  if (body.style.display === 'block') {
    body.style.display = 'none';
    arrow.textContent = '+';
  } else {
    body.style.display = 'block';
    arrow.textContent = '−';
  }
}

// ---- PDP GALLERY: warm the other slides WITHOUT racing the first photo (2026-09-21, site-wide butter pass) ----
// Each PDP body (templates/product.liquid, snippets/pdp-bundle-core.liquid, snippets/pdp-hostage-core.liquid)
// used to carry its own copy of an idle-callback preloader. On a phone the "idle" moment comes about 2s in,
// while the line is still saturated, so six hidden 900px slides (about 900KB) downloaded NEXT TO the main
// photo, and the main photo (the page's LCP) landed at 8 to 9s on the slow-phone profile (1.6 Mbps, 150ms,
// CPU 4x). Now: wait for the main photo AND window load, then fetch ONE slide at a time at low priority,
// nearest first and alternating forward and back, so a swipe either way lands on a warm slide. A tap on a
// slide that is not warm yet still works: setThumb fetches it itself. Data saver or a 2g link warms only
// the next slide. The scent switch in product.liquid calls this again after it rebuilds the thumbs; a newer
// call cancels the older chain. Tests: outputs/site-rebuild-2026-09-21/butter-site/harness/gallery-preload.test.js
var _dbGalleryRun = 0;
function dbPreloadGallery() {
  var run = ++_dbGalleryRun;
  var main = document.getElementById('product-main-img');
  var thumbs = [].slice.call(document.querySelectorAll('.thumb'));
  if (!main || thumbs.length < 2) return;
  var a = 0;
  thumbs.forEach(function(t, i) { if (t.classList.contains('active')) a = i; });
  var n = thumbs.length, seen = {}, queue = [];
  seen[a] = 1;
  for (var s = 1; s < n; s++) {
    [(a + s) % n, (a - s + n) % n].forEach(function(i) {
      if (seen[i]) return;
      seen[i] = 1;
      var u = thumbs[i].getAttribute('data-full');
      if (u) queue.push(u);
    });
  }
  var conn = navigator.connection || {};
  if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) queue = queue.slice(0, 1);
  function next() {
    if (run !== _dbGalleryRun) return;
    var u = queue.shift();
    if (!u) return;
    var img = new Image();
    try { img.fetchPriority = 'low'; } catch (e) {}
    img.onload = img.onerror = function() { setTimeout(next, 0); };
    img.src = u;
  }
  function start() {
    if (run !== _dbGalleryRun) return;
    if (window.requestIdleCallback) requestIdleCallback(next, { timeout: 2000 });
    else setTimeout(next, 200);
  }
  function afterMain() {
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }
  if (main.complete) afterMain();
  else {
    main.addEventListener('load', afterMain, { once: true });
    main.addEventListener('error', afterMain, { once: true });
  }
}

// ---- TOAST ----
function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2800);
}

// ---- COUNT-UP ANIMATION ----
(function() {
  function parseStatValue(text) {
    text = text.trim();
    var prefix = '';
    var suffix = '';
    var numStr = text;

    // Extract leading $ or other symbol
    if (numStr.charAt(0) === '$') { prefix = '$'; numStr = numStr.slice(1); }

    // Extract trailing symbols (+, ★, etc.)
    var trailingMatch = numStr.match(/([+★☆%].*)$/);
    if (trailingMatch) {
      suffix = trailingMatch[1];
      numStr = numStr.slice(0, -suffix.length);
    }

    // Handle K suffix (e.g. "230K")
    var multiplier = 1;
    if (numStr.toUpperCase().endsWith('K')) {
      multiplier = 1000;
      numStr = numStr.slice(0, -1);
    }

    var num = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(num)) return null;

    return { prefix: prefix, suffix: suffix, target: num * multiplier, hasK: multiplier === 1000, useCommas: text.indexOf(',') !== -1 || num * multiplier >= 1000 };
  }

  function formatNum(n, hasK, useCommas, decimals) {
    if (hasK) {
      var kVal = n / 1000;
      return kVal % 1 === 0 ? kVal.toFixed(0) + 'K' : kVal.toFixed(decimals || 0) + 'K';
    }
    if (useCommas) return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
    return n % 1 === 0 ? n.toFixed(0) : n.toFixed(1);
  }

  function animateCount(el, parsed, duration) {
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease-out cubic
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(ease * parsed.target);
      el.textContent = parsed.prefix + formatNum(current, parsed.hasK, parsed.useCommas) + parsed.suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-count-target]');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var parsed = parseStatValue(el.getAttribute('data-count-target'));
          if (parsed) animateCount(el, parsed, 2000);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.3 });

    els.forEach(function(el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountUp);
  } else {
    initCountUp();
  }
})();

// ---- INIT ON LOAD ----
document.addEventListener('DOMContentLoaded', function() {
  // A cart restore (email P5, assets/db-cart-restore.js) owns this page load: it rebuilds the saved cart
  // and reloads the page without the token, and that reload runs everything below on the rebuilt cart.
  // Standing down here keeps the coverage auto-add, the attribution writes and the drawer repaint from
  // racing the rebuild.
  if (window.DB_CART_RESTORING) return;
  DB_Cart.refresh();
  dbPreloadGallery();

  // Capture an lp / lp_variant id from the URL (?lp=dads-grads) into the
  // db_variant cookie, so any tagged ad or email link attributes too, not
  // only dedicated landing pages.
  try {
    var qs = new URLSearchParams(location.search);
    var lpParam = qs.get('lp') || qs.get('lp_variant');
    if (lpParam && /^[a-z0-9_-]{1,40}$/.test(lpParam)) {
      document.cookie = 'db_variant=' + lpParam + ';path=/;max-age=2592000;SameSite=Lax';
      // Count this click as a visit for attribution. Only campaign/ad/email links
      // carry ?lp=, so this beacon fires on those; dedicated LP templates already
      // beacon via db-lp-track.liquid and set window.__dbLpBeaconSent, so we skip
      // to avoid double-counting when a page has both. Mirrors db-lp-track's
      // sendBeacon exactly (text/plain avoids a CORS preflight).
      if (!window.__dbLpBeaconSent) {
        window.__dbLpBeaconSent = true;
        // Once per SESSION per variant, shared key with db-lp-track.liquid so an
        // ad click landing here and the dedicated LP page it leads to count as ONE
        // visit, not two. Keeps the dashboard Visits denominator ~= real sessions
        // (Shopify's session count) instead of raw page views. Fail open on
        // storage errors (private mode) so tracking still fires.
        var lpKey = 'db_lp_beacon_' + lpParam;
        var lpBeaconed = false;
        try { lpBeaconed = sessionStorage.getItem(lpKey) === '1'; } catch (eS) {}
        if (!lpBeaconed) {
          try { sessionStorage.setItem(lpKey, '1'); } catch (eS2) {}
          try {
            var lpBody = JSON.stringify({ variant: lpParam, referrer: document.referrer });
            var lpUrl = 'https://db-dashboard-two.vercel.app/api/lp-track';
            if (navigator.sendBeacon) {
              navigator.sendBeacon(lpUrl, new Blob([lpBody], { type: 'text/plain' }));
            } else {
              fetch(lpUrl, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: lpBody, keepalive: true }).catch(function(){});
            }
          } catch (e2) {}
        }
      }
    }
  } catch (e) {}

  // Capture utm_content from the URL into the db_creative cookie -> the
  // creative_code cart attribute below. This is the Bastard Grid's REVENUE-side
  // join key: the meta-insights cron grades SPEND by parsing the ad NAME into a
  // cell (a2-s3), and the ad's URL parameters carry that same ad name in
  // utm_content ({{ad.name}}), so an order that keeps it can be joined back to
  // the exact creative that paid for it.
  //
  // SHIPPED 2026-08-04, and it had never existed before. lib/lp-attribution.ts
  // has always read a `creative_code` cart attribute first, but NOTHING in this
  // theme ever wrote one: a 14-day audit found creative_code on 0 of 324 orders.
  // The grid was running entirely on the trybe_ad_id fallback, which only the
  // Trybe integration stamps and therefore only creator ads carry, so HALF of
  // paid revenue ($5,167 of $10,416) could not resolve to any cell, and the
  // missing half was almost all DB-made statics. That made creator cells look
  // strong and static cells look dead purely as an artifact of who stamps an id.
  //
  // Mirrors the ?lp= capture above deliberately. Differences, both required:
  //   - The value is stored URL-ENCODED, because a real ad name contains spaces
  //     and pipes ('DB_20260730_laundry-for-college-guys | a1-s1-static-4x5')
  //     which are not safe in a raw cookie value.
  //   - The charset is wider than db_variant's [a-z0-9_-]: ad names carry
  //     uppercase, '=', '|', '.', '+' and spaces (e.g.
  //     'LoriLewis_20260722_trybe=79def6fb'). The RAW string is kept on purpose;
  //     parseCreativeCode() in the dashboard collapses it to the join cell, so a
  //     full descriptor is expected and safe.
  try {
    var qsC = new URLSearchParams(location.search);
    var cc = qsC.get('utm_content');
    if (cc) {
      // Reject an unsubstituted macro. Meta CAN fail to substitute its own
      // {{...}} tokens (seen live on utm_campaign, order #1410, 2026-08-02).
      // Storing the literal would attribute real revenue to a phantom creative,
      // which is worse than storing nothing.
      if (cc.indexOf('{{') === -1 && cc.indexOf('}}') === -1 && /^[\w .|=+-]{1,120}$/.test(cc)) {
        document.cookie = 'db_creative=' + encodeURIComponent(cc) + ';path=/;max-age=2592000;SameSite=Lax';
      }
    }
  } catch (eC) {}

  // Set LP variant as cart attribute for checkout attribution.
  // Accepts a/b/c plus named customer-segment ids (e.g. dads-grads).
  var lpMatch = document.cookie.match(/db_variant=([a-z0-9_-]{1,40})/);
  if (lpMatch) {
    DB_Cart._cartFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { lp_variant: lpMatch[1] } })
    }).catch(function(){});
  }
  // Creative code -> cart attribute. Its OWN if-block, NOT gated on lpMatch: most
  // paid traffic carries a creative code and no LP cookie, and /cart/update.js
  // merges attributes per-key so this cannot clobber lp_variant or popup_session.
  var ccMatch = document.cookie.match(/db_creative=([^;]+)/);
  if (ccMatch) {
    var ccVal = '';
    try { ccVal = decodeURIComponent(ccMatch[1]); } catch (eD) { ccVal = ''; }
    if (ccVal) {
      DB_Cart._cartFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { creative_code: ccVal } })
      }).catch(function(){});
    }
  }
  // Pop-up session id backstop: stamp popup_session on the cart on page load too,
  // whether or not an LP cookie is present (separate if-block, NOT gated on lpMatch).
  // /cart/update.js merges attribute keys per-key, so this does not clobber lp_variant.
  var sidMatch = document.cookie.match(/db_popup_sid=([a-z0-9_-]{1,64})/);
  if (sidMatch) {
    DB_Cart._cartFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { popup_session: sidMatch[1] } })
    }).catch(function(){});
  }
});

// ---- DIALOG KEYBOARD (2026-09-09 site audit, D-08): Escape closes an open drawer; opening moves focus in ----
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var cd = document.getElementById('cart-drawer');
    if (cd && cd.classList.contains('open') && typeof closeCart === 'function') { closeCart(); return; }
    var ad = document.getElementById('acct-drawer');
    if (ad && ad.classList.contains('open') && typeof closeAcctDrawer === 'function') { closeAcctDrawer(); }
  });
  var mo = new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      var el = m.target;
      if (el.classList.contains('open')) {
        var first = el.querySelector('button, [href], input, [tabindex="0"]');
        try { (first || el).focus({ preventScroll: true }); } catch (e) {}
      }
    });
  });
  ['cart-drawer', 'acct-drawer'].forEach(function (id) { var el = document.getElementById(id); if (el) mo.observe(el, { attributes: true, attributeFilter: ['class'] }); });
})();
